webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EventBus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LeadBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebApp__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_WebApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_login_Login__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_login_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_login_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dialogloopsdk__ = __webpack_require__(506);






var service = new __WEBPACK_IMPORTED_MODULE_4_dialogloopsdk__["a" /* default */]();
service.setLogLevel(4); // Debug

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'WebApp',
        component: __WEBPACK_IMPORTED_MODULE_2__components_WebApp___default.a,
        props: {
            service: service
        },
        query: {
            userId: 'userID',
            exp: 'exp',
            s: 'sessionCode',
            shortCode: 'shortCode',
            handle: 'handle',
            testAuth: 'testAuth'
        }
    }, {
        path: '/login',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_3__components_login_Login___default.a,
        props: {
            service: service
        }
    }]
}));

// Declare Event Bus
var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
var LeadBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(121)('wks');
var uid = __webpack_require__(76);
var Symbol = __webpack_require__(8).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var core = __webpack_require__(3);
var ctx = __webpack_require__(54);
var hide = __webpack_require__(37);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(521), __esModule: true };

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(509);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(510);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(508);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(113);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(113);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(44)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var IE8_DOM_DEFINE = __webpack_require__(190);
var toPrimitive = __webpack_require__(123);
var dP = Object.defineProperty;

exports.f = __webpack_require__(28) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/anonymous.svg";

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);





var Item = function Item(data) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Item);

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this, data);
};

/* harmony default export */ __webpack_exports__["a"] = (Item);
;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(30);
var createDesc = __webpack_require__(73);
module.exports = __webpack_require__(28) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(191);
var defined = __webpack_require__(114);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(196);
var enumBugKeys = __webpack_require__(116);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(71);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);





var NavigatorUtils = function () {
    function NavigatorUtils() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NavigatorUtils);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NavigatorUtils, null, [{
        key: 'isIE',
        value: function isIE() {
            return !!navigator.userAgent.match(/Trident.*rv\:11\./);
        }
    }, {
        key: 'isMobile',
        value: function isMobile() {
            if (typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1) {
                return true;
            }

            return false;
        }
    }, {
        key: 'isAndroid',
        value: function isAndroid() {
            return navigator.userAgent.toLowerCase().indexOf("android") > -1;
        }
    }, {
        key: 'isIOS',
        value: function isIOS() {
            return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        }
    }]);

    return NavigatorUtils;
}();

/* harmony default export */ __webpack_exports__["a"] = (NavigatorUtils);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);







var StorageUtils = function () {
  function StorageUtils() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, StorageUtils);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(StorageUtils, null, [{
    key: "getItem",
    value: function getItem(key, defaultValue) {
      if (key === undefined || key === null || !window.localStorage) {
        return defaultValue;
      }

      var value = window.localStorage.getItem(key);

      return value === undefined || value === null ? defaultValue : value;
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      if (key === undefined || !window.localStorage) {
        return false;
      }

      var v = value;

      if ((typeof value === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === "object") {
        try {
          v = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(v);
        } catch (e) {
          return false;
        }
      } else if (typeof value === "string") {
        v = value;
      } else {
        console.log("Unsupported type of object");
        return false;
      }

      window.localStorage.setItem(key, v);

      return true;
    }
  }]);

  return StorageUtils;
}();

/* harmony default export */ __webpack_exports__["a"] = (StorageUtils);

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(30).f;
var has = __webpack_require__(36);
var TAG = __webpack_require__(9)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(114);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);





var TimeUtils = function () {
    function TimeUtils() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TimeUtils);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TimeUtils, null, [{
        key: 'formatFromNow',
        value: function formatFromNow(timestamp) {
            var localize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (key) {
                return key;
            };

            var diffSeconds = parseInt((Date.now() - timestamp * 1000) / 1000);
            var diffDays = Math.floor(diffSeconds / 86400);

            if (diffDays >= 1) {
                return diffDays + localize('day');
            }

            var diffHrs = Math.floor(diffSeconds % 86400 / 3600);

            if (diffHrs >= 1) {
                return diffHrs + localize('hour');
            }

            var diffMins = Math.floor(diffSeconds % 86400 % 3600 / 60);

            if (diffMins >= 1) {
                return diffMins + localize('minute');
            }

            if (diffSeconds >= 20) {
                return diffSeconds + localize('second');
            }

            return localize('now');
        }
    }]);

    return TimeUtils;
}();

/* harmony default export */ __webpack_exports__["a"] = (TimeUtils);

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/arrow.svg";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(311)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(462),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(459),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Item__ = __webpack_require__(35);








var Person = function (_Item) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Person, _Item);

    function Person() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Person);

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Person.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Person)).apply(this, arguments));
    }

    return Person;
}(__WEBPACK_IMPORTED_MODULE_4__Item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Person);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(525), __esModule: true };

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(513);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(512);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);
var document = __webpack_require__(8).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 116 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(71);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(16);
var dPs = __webpack_require__(543);
var enumBugKeys = __webpack_require__(116);
var IE_PROTO = __webpack_require__(120)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(115)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(189).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 119 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(121)('keys');
var uid = __webpack_require__(76);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(29);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var core = __webpack_require__(3);
var LIBRARY = __webpack_require__(72);
var wksExt = __webpack_require__(125);
var defineProperty = __webpack_require__(30).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(9);


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(549)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(192)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(552);
var global = __webpack_require__(8);
var hide = __webpack_require__(37);
var Iterators = __webpack_require__(55);
var TO_STRING_TAG = __webpack_require__(9)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 128 */,
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);







var Notes = function () {
  function Notes(userId) {
    var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Notes);

    this.userId = userId;
    this.content = content;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Notes, [{
    key: 'update',
    value: function update(presentationId, slideId, note) {
      if (presentationId === undefined || slideId === undefined) {
        return false;
      }

      if (!this.content[presentationId]) {
        this.content[presentationId] = {};
      }

      if (note === undefined) {
        delete this.content[presentationId][slideId];

        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.content[presentationId]).length === 0) {
          delete this.content[presentationId];
        }
      } else {
        this.content[presentationId][slideId] = note;
      }

      return true;
    }
  }, {
    key: 'get',
    value: function get(presentationId, slideId, defaultValue) {
      if (presentationId === undefined || slideId === undefined) {
        return defaultValue;
      }

      if (!this.content[presentationId]) {
        return defaultValue;
      }

      if (this.content[presentationId][slideId] !== undefined) {
        return this.content[presentationId][slideId];
      }

      return defaultValue;
    }
  }, {
    key: 'list',
    value: function list(presentationId) {
      if (presentationId === undefined || !this.content[presentationId]) {
        return [];
      }

      var slideIds = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.content[presentationId]);
      var notes = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(slideIds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var slideId = _step.value;

          notes.push({
            slideId: slideId,
            text: this.content[presentationId][slideId]
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return notes;
    }
  }]);

  return Notes;
}();

/* harmony default export */ __webpack_exports__["a"] = (Notes);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);





var IdentifierUtils = function () {
    function IdentifierUtils() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, IdentifierUtils);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(IdentifierUtils, null, [{
        key: 'guid',
        value: function guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
            });
        }
    }]);

    return IdentifierUtils;
}();

/* harmony default export */ __webpack_exports__["a"] = (IdentifierUtils);

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/enter.svg";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/notes_selected.svg";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_selected.svg";

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/questions_selected.svg";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sessions_selected.svg";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(325)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(476),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Item__ = __webpack_require__(35);










var Question = function (_Item) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Question, _Item);

    function Question(data) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Question);

        var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Question.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Question)).call(this, data));

        if (_this.props) {
            var replyArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(_this.props);

            replyArray.sort(function (a, b) {
                return a.timestamp - b.timestamp;
            });
            _this.replies = replyArray;
        }
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Question, [{
        key: "merge",
        value: function merge(question) {
            if (!question) {
                return;
            }

            this.votes = question.votes === undefined ? this.votes : question.votes;
            this.voted = question.voted === undefined ? this.voted : question.voted;
            this.props = question.props === undefined ? this.props : question.props;
            this.replies = question.replies === undefined ? this.replies : question.replies;
        }
    }]);

    return Question;
}(__WEBPACK_IMPORTED_MODULE_6__Item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Question);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Item__ = __webpack_require__(35);








var Slide = function (_Item) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Slide, _Item);

    function Slide() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Slide);

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Slide.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Slide)).apply(this, arguments));
    }

    return Slide;
}(__WEBPACK_IMPORTED_MODULE_4__Item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Slide);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var DLog = function () {
  function DLog() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DLog);

    this.level = 2;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DLog, [{
    key: "error",
    value: function error(msg) {
      if (this.level > 0) {
        console.error(msg);
      }
    }
  }, {
    key: "warn",
    value: function warn(msg) {
      if (this.level > 1) {
        console.warn(msg);
      }
    }
  }, {
    key: "info",
    value: function info(msg) {
      if (this.level > 2) {
        console.log("[info] " + msg);
      }
    }
  }, {
    key: "debug",
    value: function debug(msg) {
      if (this.level > 3) {
        console.log("[debug] " + msg);
      }
    }
  }]);

  return DLog;
}();

/* harmony default export */ __webpack_exports__["a"] = (DLog);
;

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);





var Identifier = function () {
    function Identifier() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Identifier);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Identifier, null, [{
        key: 'guid',
        value: function guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
            });
        }
    }]);

    return Identifier;
}();

/* harmony default export */ __webpack_exports__["a"] = (Identifier);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(516), __esModule: true };

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(517), __esModule: true };

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(522), __esModule: true };

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(53);
var TAG = __webpack_require__(9)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(8).document;
module.exports = document && document.documentElement;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(28) && !__webpack_require__(44)(function () {
  return Object.defineProperty(__webpack_require__(115)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(53);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(72);
var $export = __webpack_require__(12);
var redefine = __webpack_require__(200);
var hide = __webpack_require__(37);
var has = __webpack_require__(36);
var Iterators = __webpack_require__(55);
var $iterCreate = __webpack_require__(537);
var setToStringTag = __webpack_require__(74);
var getPrototypeOf = __webpack_require__(195);
var ITERATOR = __webpack_require__(9)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(56);
var createDesc = __webpack_require__(73);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(123);
var has = __webpack_require__(36);
var IE8_DOM_DEFINE = __webpack_require__(190);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(28) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(196);
var hiddenKeys = __webpack_require__(116).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(36);
var toObject = __webpack_require__(75);
var IE_PROTO = __webpack_require__(120)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(36);
var toIObject = __webpack_require__(38);
var arrayIndexOf = __webpack_require__(530)(false);
var IE_PROTO = __webpack_require__(120)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(12);
var core = __webpack_require__(3);
var fails = __webpack_require__(44);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var isObject = __webpack_require__(29);
var newPromiseCapability = __webpack_require__(117);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(37);


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(16);
var aFunction = __webpack_require__(71);
var SPECIES = __webpack_require__(9)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(54);
var invoke = __webpack_require__(533);
var html = __webpack_require__(189);
var cel = __webpack_require__(115);
var global = __webpack_require__(8);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(53)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(122);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(188);
var ITERATOR = __webpack_require__(9)('iterator');
var Iterators = __webpack_require__(55);
module.exports = __webpack_require__(3).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 205 */
/***/ (function(module, exports) {



/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */,
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(457),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */,
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app'
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ProfileManagement__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ProfileManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ProfileManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        profilemanagement: __WEBPACK_IMPORTED_MODULE_0__components_ProfileManagement___default.a
    },

    props: {
        user: Object,
        service: Object
    },

    data: function data() {
        return {
            modalOpen: false
        };
    },


    methods: {
        toggleAccountSettings: function toggleAccountSettings() {
            this.modalOpen = !this.modalOpen;
        },
        Logout: function Logout() {
            __WEBPACK_IMPORTED_MODULE_1__router_index__["b" /* EventBus */].$emit('logout');
        },
        close: function close() {
            this.modalOpen = false;
        }
    }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BottomTray__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BottomTray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_BottomTray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NotesTray__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NotesTray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_NotesTray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var REFRESH_PANEL_TIMEOUT = 15000;
var MAX_REFRESH_TIMES = 12;





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        bottomtray: __WEBPACK_IMPORTED_MODULE_0__components_BottomTray___default.a,
        notestray: __WEBPACK_IMPORTED_MODULE_1__components_NotesTray___default.a
    },

    props: {
        presentation: {},
        presentationList: {},
        questionList: {},
        peopleList: {},
        peopleMap: {},
        slideList: {},
        user: {},
        currentSlide: '',
        chatList: {},
        chatContacts: {},
        isAllowedToListSessions: Boolean,
        isLoading: Boolean
    },

    data: function data() {
        return {
            trayContent: undefined,
            broadcaster: {},
            contactId: {},
            person: undefined,
            newQuestion: false,
            newPerson: false,
            timerRefresh: undefined,
            refreshTime: 0,
            shouldOpenSessions: false
        };
    },


    computed: {
        isBottomTrayVisible: function isBottomTrayVisible() {
            return this.trayContent !== undefined && this.trayContent !== 'Notes';
        }
    },

    watch: {
        user: function user() {
            var _this = this;

            if (this.shouldOpenSessions) {
                setTimeout(function () {
                    _this.openSessions();
                }, 100);
                this.shouldOpenSessions = false;
            }
        },
        isAllowedToListSessions: function isAllowedToListSessions() {
            var _this2 = this;

            if (this.isAllowedToListSessions && this.trayContent === undefined) {
                setTimeout(function () {
                    _this2.openSessions();
                }, 100);
            }
        },
        presentation: function presentation() {
            if (this.presentation) {
                this.closeTray();
            }
        },
        peopleList: function peopleList() {
            if (this.trayContent !== 'People') {
                this.newPerson = true;
            }
        }
    },

    mounted: function mounted() {
        var _this3 = this;

        if (this.$route.query.handle) {
            if (this.user.id) {
                setTimeout(function () {
                    _this3.openSessions();
                }, 100);
            } else {
                this.shouldOpenSessions = true;
            }
        }

        __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$on('openChat', function (person) {
            _this3.contactId = person.id;
            _this3.person = person;
            _this3.trayContent = 'Chat';

            if (person && person.id) {
                __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit("getMessages", person.id);
            }
        });

        __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$on('openPeople', function () {
            _this3.openPeople();
        });

        __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$on('openPresentation', function (presentation) {
            _this3.trayContent = undefined;
        });

        __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$on('questionsChanged', function () {
            if (_this3.trayContent !== 'Questions') {
                _this3.newQuestion = true;
            }
        });
    },


    methods: {
        onAnimationStart: function onAnimationStart() {
            document.body.style.overflowY = 'hidden';
        },
        onAnimationEnd: function onAnimationEnd() {
            document.body.style.overflowY = 'default';
        },
        clearRefreshTimer: function clearRefreshTimer() {
            if (this.timerRefresh) {
                clearTimeout(this.timerRefresh);
                this.timerRefresh = undefined;
            }
        },
        refreshPanelContent: function refreshPanelContent(eventName, eventData) {
            var _this4 = this;

            if (++this.refreshTime >= MAX_REFRESH_TIMES) {
                // Show banner
                __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit('showBanner', this.$t('str.AutoRefreshDisabledToConserveResourcesClickHereToResume'), function () {
                    _this4.refreshTime = 0;
                    _this4.refreshPanelContent(eventName, eventData);
                });
                return;
            }

            this.$emit(eventName, eventData, function () {
                // Schedule a new refresh on whatever is up
                _this4.timerRefresh = setTimeout(function () {
                    _this4.timerRefresh = undefined;
                    _this4.refreshPanelContent(eventName, eventData);
                }, REFRESH_PANEL_TIMEOUT);
            });
        },
        openSessions: function openSessions() {
            this.clearRefreshTimer();
            __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit("closeModals"); // Hacky but css change would be too much

            if (!this.isAllowedToListSessions) {
                return;
            }

            if (this.trayContent === 'Sessions' && this.presentation) {
                this.trayContent = undefined;
            } else {
                this.trayContent = 'Sessions';

                if (this.presentation && this.presentation.props) {
                    this.refreshPanelContent('getPresentations', this.presentation.props.PublishedInHandle);
                } else {
                    this.refreshPanelContent('getPresentations', this.$route.query.handle);
                }
            }
        },
        openQuestions: function openQuestions() {
            this.clearRefreshTimer();
            __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit("closeModals"); // Hacky but css change would be too much

            if (!this.presentation) {
                return;
            }

            if (this.trayContent === 'Questions') {
                this.trayContent = undefined;
            } else {
                this.$set(this, 'trayContent', 'Questions');
                this.newQuestion = false;
                __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit('getQuestions', this.presentation.id);
                __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit('getPeople', this.presentation.id);
            }
        },
        openPeople: function openPeople() {
            this.clearRefreshTimer();
            __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit("closeModals"); // Hacky but css change would be too much

            if (!this.presentation) {
                return;
            }

            if (this.trayContent === 'People') {
                this.trayContent = undefined;
            } else {
                this.trayContent = 'People';
                this.newPerson = false;
                __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit('getPeople', this.presentation.id);
            }
        },
        openNotes: function openNotes() {
            this.clearRefreshTimer();
            __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit("closeModals"); // Hacky but css change would be too much

            if (!this.presentation) {
                return;
            }

            if (this.trayContent === 'Notes') {
                this.trayContent = undefined;
                __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit('enableResourcePane');
            } else {
                this.trayContent = 'Notes';
                __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit('getSlides', this.presentation.id);
                __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit('disableResourcePane');
            }
        },
        openChat: function openChat() {
            this.clearRefreshTimer();
            __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit("closeModals"); // Hacky but css change would be too much

            if (this.trayContent === 'Chat') {
                this.trayContent = undefined;
            } else {
                this.trayContent = 'Chat';
            }
        },
        closeTray: function closeTray() {
            this.trayContent = undefined;
        }
    }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SessionsTray__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SessionsTray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_SessionsTray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PeopleTray__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PeopleTray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PeopleTray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_question_QuestionTray__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_question_QuestionTray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_question_QuestionTray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chat_ChatTray__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chat_ChatTray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_chat_ChatTray__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: get timeout working.





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        sessionstray: __WEBPACK_IMPORTED_MODULE_0__components_SessionsTray___default.a,
        peopletray: __WEBPACK_IMPORTED_MODULE_1__components_PeopleTray___default.a,
        questiontray: __WEBPACK_IMPORTED_MODULE_2__components_question_QuestionTray___default.a,
        chattray: __WEBPACK_IMPORTED_MODULE_3__components_chat_ChatTray___default.a
    },

    props: {
        trayType: '',
        presentation: {},
        presentationList: {},
        peopleList: {},
        questionList: {},
        peopleMap: {},
        user: {},
        person: {},
        chatList: {},
        chatContacts: {},
        isLoading: Boolean
    },

    data: function data() {
        return {
            trayOpen: false
        };
    },


    methods: {
        close: function close() {
            this.$emit('closeTray');
        }
    }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__javascript_classes_utils_navigator__ = __webpack_require__(57);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function isFullScreen() {
    return document.mozFullScreen || document.webkitIsFullScreen || document.fullScreen || document.isFullScreen;
}

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        presentation: {},
        slideList: {},
        syncSlideNum: {},
        syncSlide: {},
        progressiveReveal: {}
    },

    data: function data() {
        return {
            leftLocation: 0,
            mouseLocation: 0,
            mouseDown: false,

            showFullscreen: false,
            showArrows: false,
            fullscreenLock: false,

            currentSlide: 0,
            previousSyncSlide: 0,

            resX: 0,
            resY: 0,

            baseResX: 0,
            baseResY: 0,

            isResReady: false,
            callbackOnResReady: [],

            isMobileDevice: __WEBPACK_IMPORTED_MODULE_1__javascript_classes_utils_navigator__["a" /* default */].isMobile(),
            isLandscape: false,
            //Animation Data============================
            stopAnimation: false,
            start: 0,
            timeDivisor: 0,
            leftValue: 0,
            difference: 0
            //==========================================
        };
    },


    computed: {
        isLeftArrowVisible: function isLeftArrowVisible() {
            return this.currentSlide > 0 && this.showArrows === true;
        },
        isRightArrowVisible: function isRightArrowVisible() {
            return this.currentSlide + 1 < this.progressiveReveal && this.showArrows === true;
        },
        containerStyle: function containerStyle() {
            if (isFullScreen()) {
                var w = this.$refs.carouselContainer.clientWidth;
                var h = this.$refs.carouselContainer.clientHeight;
                var factor = Math.min(screen.width / w, screen.height / h);
                var left = 0;

                if (this.$refs.carouselContainer.mozRequestFullScreen) {
                    left = (screen.width - Math.round(w * factor)) / 2;
                }

                return {
                    width: Math.round(w * factor) + 'px',
                    height: Math.round(h * factor) + 'px',
                    left: left + 'px'
                };
            }

            return {
                width: this.resX + 'px',
                height: this.resY + 'px'
            };
        },
        sliderStyle: function sliderStyle() {
            return {
                width: this.slideList.length * this.resX + 'px',
                height: this.resY + 'px'
            };
        },
        isFullScreenSupported: function isFullScreenSupported() {
            var container = this.$el;

            return container.requestFullScreen || container.webkitRequestFullScreen || container.mozRequestFullScreen || container.msRequestFullScreen;
        }
    },

    methods: {
        switchFullScreen: function switchFullScreen() {
            if (isFullScreen()) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (this.$refs.carouselContainer.requestFullScreen) {
                    this.$refs.carouselContainer.requestFullScreen();
                } else if (this.$refs.carouselContainer.webkitRequestFullScreen) {
                    this.$refs.carouselContainer.webkitRequestFullScreen();
                } else if (this.$refs.carouselContainer.mozRequestFullScreen) {
                    this.$refs.carouselContainer.mozRequestFullScreen();
                } else if (this.$refs.carouselContainer.msRequestFullScreen) {
                    this.$refs.carouselContainer.msRequestFullScreen();
                }
            }
        },
        fullscreenSwitched: function fullscreenSwitched() {
            var _this = this;

            if (isFullScreen()) {
                return;
            }

            setTimeout(function () {
                _this.calcResX();
                _this.$refs.carouselSlider.style.left = -(_this.resX * _this.currentSlide) + 'px';
                _this.$refs.carouselContainer.style.width = _this.resX + 'px';
                _this.$refs.carouselContainer.style.height = _this.resY + 'px';
                _this.$refs.carouselContainer.style.left = 0;
            }, 1000);
        },
        checkProgressiveReveal: function checkProgressiveReveal(index) {
            return index <= this.progressiveReveal;
        },
        moveStart: function moveStart() {
            this.mouseDown = true;
            this.leftLocation = Number(this.$refs.carouselSlider.style.left.replace('px', ''));
        },
        moveStop: function moveStop() {
            if (this.mouseDown) {
                this.mouseDown = false;
                this.calculateSlide();
            }
        },
        mouseLeave: function mouseLeave() {
            this.showFullscreenOn(false);
            this.showArrows = false;
            this.moveStop();
        },
        mouseOver: function mouseOver() {
            this.showFullscreenOn(true);
            this.showArrows = true;
        },
        physicalAnimation: function physicalAnimation() {
            var _this2 = this;

            this.registerOnResReady(function () {
                _this2.stopAnimation = true;
                var gotoValue = -1 * _this2.currentSlide * _this2.resX;
                _this2.leftValue = Number(_this2.$refs.carouselSlider.style.left.replace('px', ''));
                var startValue = _this2.leftValue;
                _this2.difference = gotoValue - startValue;

                _this2.start = performance.now();
                var self = _this2;

                _this2.timeDivisor = 300;
                _this2.stopAnimation = false;
                requestAnimationFrame(_this2.animate);
            });
        },
        animate: function animate(time) {
            if (this.stopAnimation === true) {
                return;
            }

            var timeFraction = (time - this.start) / this.timeDivisor;

            if (timeFraction > 1) {
                timeFraction = 1;
            }

            var progress = Math.pow(timeFraction, 2);
            var changeValue = this.leftValue + progress * this.difference;
            this.$refs.carouselSlider.style.left = changeValue + 'px';

            if (timeFraction < 1) {
                requestAnimationFrame(this.animate);
            }
        },
        registerOnResReady: function registerOnResReady(callback) {
            if (!callback) {
                return;
            }

            if (this.isResReady) {
                callback();
            } else {
                this.callbackOnResReady.push(callback);
            }
        },
        showFullscreenOn: function showFullscreenOn(newVal) {
            if (!this.fullscreenLock) {
                this.showFullscreen = newVal;
            }
        },
        changeSlide: function changeSlide(newVal) {
            if (newVal >= 0 && newVal <= this.progressiveReveal) {
                this.$emit('syncSlideEvent', false);
                this.currentSlide = newVal;
                this.physicalAnimation();
            }
        },
        changeSlideSync: function changeSlideSync(newVal) {
            if (newVal >= 0 && newVal <= this.slideList.length) {
                this.currentSlide = newVal;
                this.physicalAnimation();
            }
        },
        calculateSlide: function calculateSlide() {
            var leftValue = Number(this.$refs.carouselSlider.style.left.replace('px', ''));
            var potentialSlide = void 0;

            if (typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1) {
                if (this.leftLocation > leftValue) {
                    potentialSlide = this.currentSlide + 1;
                } else if (this.leftLocation < leftValue) {
                    potentialSlide = this.currentSlide - 1;
                }
            } else {
                potentialSlide = Math.round(-leftValue / this.resX);
            }

            if (potentialSlide > -1 && potentialSlide < this.progressiveReveal && potentialSlide !== this.currentSlide) {
                this.$emit('syncSlideEvent', false);
                this.currentSlide = potentialSlide;
            }

            if (this.leftLocation !== leftValue) {
                this.physicalAnimation();
            }
        },
        calcResX: function calcResX() {
            if (__WEBPACK_IMPORTED_MODULE_1__javascript_classes_utils_navigator__["a" /* default */].isMobile()) {
                this.resXPhone();
            } else {
                this.resXPC();
            }

            this.isResReady = true;
        },
        resXPC: function resXPC() {
            var potentialHeight = this.baseResY / this.baseResX * window.innerWidth;

            if (isFullScreen()) {
                var w = this.$refs.carouselContainer.clientWidth;
                var h = this.$refs.carouselContainer.clientHeight;
                var factor = Math.min(screen.width / w, screen.height / h);

                this.resX = Math.round(w * factor);
            } else if (potentialHeight < window.innerHeight - 210) {
                this.resX = window.innerWidth;
            } else {
                this.resX = (window.innerHeight - 210) / (this.baseResY / this.baseResX);
            }

            this.resY = this.baseResY / this.baseResX * this.resX;
        },
        resXPhone: function resXPhone() {
            var screenWidth = void 0;
            var screenHeight = void 0;

            if (window.innerWidth > window.innerHeight) {
                screenWidth = window.innerWidth;
                screenHeight = window.innerHeight;
            } else {
                screenWidth = window.innerHeight;
                screenHeight = window.innerWidth;
            }

            if (this.isLandscape) {
                var potentialHeight = this.baseResY / this.baseResX * screenWidth;

                if (potentialHeight < screenHeight) {
                    this.resX = screenWidth;
                } else {
                    this.resX = screenHeight / (this.baseResY / this.baseResX);
                }
            } else {
                this.resX = screenHeight;
            }

            this.resY = this.baseResY / this.baseResX * this.resX;

            window.scrollTo(0, 0);
        },
        moveTouch: function moveTouch(event) {
            if (this.mouseDown) {
                this.$refs.carouselSlider.style.left = event.changedTouches[0].clientX - this.mouseLocation + this.leftLocation + 'px';
            }
        },
        stopScroll: function stopScroll(event) {
            event.preventDefault();
        },
        startTouch: function startTouch(event) {
            if (event.type === 'touchstart' && event.touches.length === 1) {
                this.mouseLocation = event.touches[0].clientX;
                this.moveStart();
            }
        },
        imageStyle: function imageStyle(slide) {
            var width = void 0;

            if (isFullScreen()) {
                var w = this.$refs.carouselContainer.clientWidth;
                var h = this.$refs.carouselContainer.clientHeight;
                var factor = Math.min(screen.width / w, screen.height / h);

                width = Math.round(w * factor);
            } else {
                width = this.resX;
            }

            return {
                backgroundImage: 'url(' + slide.url + ')',
                backgroundSize: 'contain',
                width: width + 'px'
            };
        }
    },

    created: function created() {
        var _this3 = this;

        document.onmousemove = function (event) {
            if (_this3.mouseDown === false) {
                _this3.mouseLocation = event.clientX;
            } else {
                _this3.$refs.carouselSlider.style.left = event.clientX - _this3.mouseLocation + _this3.leftLocation + 'px';
            }
        };

        window.onresize = function () {
            _this3.calcResX();
            _this3.$refs.carouselSlider.style.left = -(_this3.resX * _this3.currentSlide) + 'px';

            // Mozilla support
            if (isFullScreen()) {
                var w = _this3.$refs.carouselContainer.clientWidth;
                var h = _this3.$refs.carouselContainer.clientHeight;
                var factor = Math.min(screen.width / w, screen.height / h);
                var left = (screen.width - Math.round(w * factor)) / 2;

                _this3.$refs.carouselContainer.style.width = Math.round(w * factor) + 'px';
                _this3.$refs.carouselContainer.style.height = Math.round(h * factor) + 'px';

                if (_this3.$refs.carouselContainer.mozRequestFullScreen) {
                    _this3.$refs.carouselContainer.style.left = left + 'px';
                }
            }
        };

        document.addEventListener('webkitfullscreenchange', this.fullscreenSwitched, false);
        document.addEventListener('mozfullscreenchange', this.fullscreenSwitched, false);
        document.addEventListener('fullscreenchange', this.fullscreenSwitched, false);
        document.addEventListener('MSFullscreenChange', this.fullscreenSwitched, false);
    },
    mounted: function mounted() {
        var _this4 = this;

        document.onkeydown = function (e) {
            e = e || window.event;
            if (e.keyCode === '37') {
                // left arrow
                _this4.changeSlide(_this4.currentSlide - 1);
            } else if (e.keyCode === '39') {
                // right arrow
                _this4.changeSlide(_this4.currentSlide + 1);
            }
        };

        window.addEventListener("orientationchange", function () {
            _this4.isLandscape = window.orientation !== 0;
        });

        this.isLandscape = window.orientation !== 0;

        // In Firefox full screen must be set to the parent of the canvas
        // to allow resizing the canvas for correct aspect ratio
        if (this.$refs.carouselContainer.mozRequestFullScreen) {
            this.$refs.carouselContainer.mozRequestFullScreen = function () {
                this.parentNode.mozRequestFullScreen.apply(this.parentNode, arguments);
            };
        }
    },


    watch: {
        slideList: function slideList(newVal) {
            var self = this;
            var img = new Image();

            this.isResReady = false;

            img.addEventListener('load', function () {
                self.baseResX = this.naturalWidth;
                self.baseResY = this.naturalHeight;
                self.calcResX();
                self.calculateSlide();
            });
            img.src = newVal[0].url;
        },
        presentation: function presentation(newVal) {
            this.currentSlide = 0;
        },
        currentSlide: function currentSlide(newVal) {
            this.$emit('calculatedSlide', newVal);
        },
        syncSlideNum: function syncSlideNum(newVal) {
            if (this.syncSlide) {
                this.changeSlideSync(newVal);
            }
        },
        syncSlide: function syncSlide(newVal) {
            if (newVal) {
                this.changeSlideSync(this.syncSlideNum);
            }
        },
        isResReady: function isResReady() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.callbackOnResReady), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var callback = _step.value;

                    callback();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AccountMenu__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AccountMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AccountMenu__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        accountmenu: __WEBPACK_IMPORTED_MODULE_0__components_AccountMenu___default.a
    },

    props: {
        user: Object,
        service: Object
    },

    data: function data() {
        return {
            menuOpen: false,
            toggled: false
        };
    },


    methods: {
        toggleAccountMenu: function toggleAccountMenu() {
            /* if (!this.toggled && !this.menuOpen) {
                 this.toggled = true;
                 this.menuOpen = true;
             } else if (this.toggled && !this.menuOpen) {
                 this.toggled = false;
             }*/
            this.menuOpen = !this.menuOpen;
        }

        /*closeMenu() {
            this.menuOpen = false;  
        }*/

    }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__javascript_classes_utils_identifier_js__ = __webpack_require__(130);

//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        service: {},
        activePres: {},
        user: {}
    },

    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1__router_index__["c" /* LeadBus */].$on('recordLead', function (leadData) {
            if (!_this.activePres || !_this.activePres.props) {
                return;
            }

            var presenter = '';

            if (_this.activePres.props.PresenterInfo) {
                presenter = _this.activePres.props.PresenterInfo.displayName;
            } else if (_this.activePres.props.PresenterProfiles && _this.activePres.props.PresenterProfiles.profiles && _this.activePres.props.PresenterProfiles.profiles.length > 0 && _this.activePres.props.PresenterProfiles.profiles[0]) {
                presenter = _this.activePres.props.PresenterProfiles.profiles[0].displayName;
            } else {
                return;
            }

            _this.service.postLead(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(leadData.data),
                leadId: __WEBPACK_IMPORTED_MODULE_2__javascript_classes_utils_identifier_js__["a" /* default */].guid(),
                presenter: presenter,
                sessionId: _this.activePres.id,
                timestamp: Date.now().toString(),
                type: leadData.type,
                userId: _this.user.id
            }));
        });
    }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__javascript_classes_utils_storage_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__javascript_classes_Notes__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var AUTO_SAVE_TIMER = 5000;
var CLEAR_SAVED_LABEL_TIMER = 6000;

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        presentation: {},
        user: {},
        slideList: {},
        currentSlide: ''
    },

    data: function data() {
        return {
            currentSlideId: '',
            notes: undefined,
            userNotes_: undefined, // Cached version of user notes for the userNotes computed property only.
            autosaveTimer: undefined,
            isDirty: undefined
        };
    },


    computed: {
        userNotes: {
            get: function get() {
                if (!this.slideList || !this.user) {
                    return "";
                }

                if (this.userNotes_ !== undefined) {
                    return this.userNotes_;
                }

                this.currentSlideId = this.slideList[this.currentSlide].slideId;
                this.userNotes_ = "";

                // load from localStorage
                var str = __WEBPACK_IMPORTED_MODULE_0__javascript_classes_utils_storage_js__["a" /* default */].getItem(this.user.id);

                if (str === undefined || str === null) {
                    return;
                }

                var notesJson = void 0;

                try {
                    notesJson = JSON.parse(str);
                } catch (e) {
                    console.log(e);
                    return;
                }

                if (!notesJson) {
                    return;
                }

                this.notes = new __WEBPACK_IMPORTED_MODULE_1__javascript_classes_Notes__["a" /* default */](this.user.id, notesJson.content);
                this.userNotes_ = this.notes.get(this.presentation.id, this.currentSlideId, "");

                return this.userNotes_;
            },
            set: function set(notes) {
                this.userNotes_ = notes;
                this.isDirty = true;
            }
        }
    },

    beforeDestroy: function beforeDestroy() {
        if (this.autosaveTimer) {
            clearTimeout(this.autosaveTimer);
        }

        this.save();
    },
    mounted: function mounted() {
        if (this.slideList && this.currentSlide && this.slideList[this.currentSlide]) {
            this.currentSlideId = this.slideList[this.currentSlide].slideId;
        }

        this.scheduleNextAutoSaving();
    },


    watch: {
        currentSlide: function currentSlide() {
            this.save();
            this.userNotes_ = undefined;
        }
    },

    methods: {
        close: function close() {
            this.$emit('closeTray');
        },
        downloadNotes: function downloadNotes() {
            __WEBPACK_IMPORTED_MODULE_2__router_index__["c" /* LeadBus */].$emit('recordLead', {
                type: 'notes-download-pfd',
                data: {}
            });
        },
        emailNotes: function emailNotes() {
            var _this = this;

            if (this.presentation === null || !this.user) {
                return;
            }

            this.save();

            var sNotesToEmail = "";
            var oTemp = {
                title: this.presentation.title,
                sessionId: this.presentation.id,
                notesMetrics: {}
            };
            var index = 1;

            this.notes.list(this.presentation.id).map(function (noteSlide) {
                if (noteSlide.text === "") {
                    return;
                }

                oTemp.notesMetrics[index] = noteSlide.text.length;
                sNotesToEmail += _this.$t('str.SlideOf', {
                    slideIndex: index,
                    savedNote: noteSlide.text
                });
                sNotesToEmail += "\r\n\r\n";

                ++index;
            });

            var sSubject = this.$t('str.EmailNotesSubject', {
                firstname: this.user.firstname,
                presentation: this.presentation.title
            });
            var windowForEmailLaunch = window.open('mailto:?subject=' + encodeURI(sSubject) + '&body=' + encodeURIComponent(sNotesToEmail));

            if (windowForEmailLaunch !== null) {
                setTimeout(function () {
                    return windowForEmailLaunch.close();
                }, 1000);
            }

            __WEBPACK_IMPORTED_MODULE_2__router_index__["c" /* LeadBus */].$emit('recordLead', {
                type: 'notes-launched-email',
                data: oTemp
            });
        },
        copyToClipboard: function copyToClipboard() {
            var el = this.$el.querySelector('[name="user-notes"]');

            el.select();
            document.execCommand('copy');
            __WEBPACK_IMPORTED_MODULE_2__router_index__["c" /* LeadBus */].$emit('recordLead', {
                type: 'notes-copied-to-clipboard',
                data: {
                    currentNote: this.currentNote,
                    currentSlide: this.currentSlideId
                }
            });

            // Unselect text
            var sel = void 0;

            if ((sel = document.selection) && sel.empty) {
                sel.empty();
            } else {
                if (window.getSelection) {
                    window.getSelection().removeAllRanges();
                }

                // Collapse the selection to the end
                el.selectionStart = el.selectionEnd;
            }
        },
        scheduleNextAutoSaving: function scheduleNextAutoSaving() {
            var _this2 = this;

            if (this.autosaveTimer) {
                clearTimeout(this.autosaveTimer);
            }

            this.autosaveTimer = setTimeout(function () {
                _this2.autosaveTimer = undefined;
                _this2.save();
                _this2.scheduleNextAutoSaving();
            }, AUTO_SAVE_TIMER);
        },
        save: function save() {
            var _this3 = this;

            if (!this.isDirty || !this.slideList || !this.currentSlideId) {
                return;
            }

            if (!this.notes) {
                this.notes = new __WEBPACK_IMPORTED_MODULE_1__javascript_classes_Notes__["a" /* default */](this.user.id);
            }

            this.notes.update(this.presentation.id, this.currentSlideId, this.userNotes);

            if (__WEBPACK_IMPORTED_MODULE_0__javascript_classes_utils_storage_js__["a" /* default */].setItem(this.user.id, this.notes) === false) {
                alert(this.$t('str.UnableToSaveNotesToLocalStorageEnsureYouAreNotInIncognitoMode'));
                return;
            }

            this.isDirty = false;

            // Set to undefined after timeout so that we can remove the "saved" label from UI.
            setTimeout(function () {
                return _this3.isDirty = undefined;
            }, CLEAR_SAVED_LABEL_TIMER);
        }
    }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        text: String,
        color: String,
        timer: String
    },

    data: function data() {
        return {
            timeout: undefined,
            barHeight: 0,
            tableEl: undefined,
            isAnimating: false
        };
    },


    computed: {
        isVisible: function isVisible() {
            return this.text && (!this.timer || this.timeout);
        },
        styleNotification: function styleNotification() {
            var style = {};

            if (this.isAnimating) {
                style.height = this.barHeight + 'px';
            } else if (this.barHeight === 0) {
                style.height = '0px';
            } else {
                style.height = 'auto';
            }

            if (this.color) {
                style['background-color'] = this.color;
            }

            return style;
        },
        styleTable: function styleTable() {
            if (this.isAnimating) {
                return {
                    position: 'absolute'
                };
            }

            if (this.barHeight === 0) {
                return {
                    position: 'absolute'
                };
            }

            // Set the table position and wrapper height to default so that it adjusts itself
            // with the content when the browser windows is resized.
            return {
                position: 'static'
            };
        },
        htmlText: function htmlText() {
            if (this.text && this.text != '') {
                return {
                    template: '<div>' + this.text.replace(/{/g, "<a v-on:click='click'>").replace(/}/g, '</a>') + '</div>',
                    methods: {
                        click: function () {
                            this.$emit('notification-click');
                        }.bind(this)
                    }
                };
            }
        }
    },

    mounted: function mounted() {
        this.tableEl = this.$el.querySelector('table');

        function onAnimationEnd() {
            this.isAnimating = false;
        }

        this.$el.addEventListener('transitionend', onAnimationEnd.bind(this), false);
        this.$el.addEventListener('webkitTransitionEnd', onAnimationEnd.bind(this), false);
        this.$el.addEventListener('oTransitionEnd', onAnimationEnd.bind(this), false);
        this.$el.addEventListener('msTransitionEnd', onAnimationEnd.bind(this), false);

        this.show();
    },


    watch: {
        text: function text() {
            if (this.text && this.text !== '') {
                this.show();
            } else {
                this.hide();
            }
        }
    },

    methods: {
        show: function show() {
            var _this = this;

            if (!this.text || this.text === '') {
                return;
            }

            // Transition the wrapper of the table to its new height
            this.isAnimating = true;
            this.barHeight = this.tableEl.offsetHeight;

            if (!this.timer) {
                return;
            }

            // Close after timeout;
            if (this.timeout) {
                clearTimeout(this.timeout);
            }

            this.timeout = setTimeout(function () {
                _this.timeout = undefined;
                _this.barHeight = 0;
            }, parseInt(this.timer));
        },
        hide: function hide(event) {
            var _this2 = this;

            if (event) {
                event.stopPropagation();
            }

            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = undefined;
            }

            this.isAnimating = true;
            this.barHeight = this.tableEl.offsetHeight;

            // Animate height on next iteration otherwise it won't animate.
            setTimeout(function () {
                return _this2.barHeight = 0;
            }, 20);
        }
    }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PersonIcon__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PersonIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PersonIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PersonCard__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PersonCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PersonCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// TODO: show notification when new person joins session (give corresponding notification on personIcon to know who is new)




var TRIGGER_SCROLL_EPS = 10;

/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        personicon: __WEBPACK_IMPORTED_MODULE_0__components_PersonIcon___default.a,
        personcard: __WEBPACK_IMPORTED_MODULE_1__components_PersonCard___default.a,
        spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default.a
    },

    props: {
        people: {},
        user: {}
    },

    data: function data() {
        return {
            attendee: undefined,
            userScrolled: false,
            ignoreScroll: false
        };
    },


    computed: {
        isEmpty: function isEmpty() {
            return this.people !== undefined && !this.people.length;
        }
    },

    watch: {
        people: function people() {
            if (!this.userScrolled) {
                this.showLastAttendeeJoined();
            }
        }
    },

    mounted: function mounted() {
        this.showLastAttendeeJoined();
    },


    methods: {
        openCard: function openCard(attendee) {
            this.attendee = attendee;
            this.$emit('openCard', this.attendee);
        },
        cardClosed: function cardClosed() {
            this.attendee = undefined;
        },
        scroll: function scroll(event) {
            // Block auto scroll if user is scrolling manually
            // Enable it back is user scrolled at the bottom.
            this.userScrolled = this.$el.scrollHeight - this.$el.clientHeight - this.$el.scrollTop > TRIGGER_SCROLL_EPS;
        },
        showLastAttendeeJoined: function showLastAttendeeJoined() {
            var _this = this;

            setTimeout(function () {
                var maxScrollTop = _this.$el.scrollHeight - _this.$el.clientHeight;
                var startScrollTop = _this.$el.scrollTop;
                var scrollRange = maxScrollTop - startScrollTop;
                var startScrollTime = performance.now();

                var animateScroll = function animateScroll(time) {
                    var timeFraction = (time - startScrollTime) / 300;

                    if (timeFraction > 1) {
                        timeFraction = 1;
                    }

                    // ease out
                    timeFraction = --timeFraction * timeFraction * timeFraction + 1;

                    _this.$el.scrollTop = startScrollTop + scrollRange * timeFraction;

                    if (timeFraction < 1) {
                        requestAnimationFrame(animateScroll);
                    } else {
                        setTimeout(function () {
                            _this.userScrolled = false;
                        }, 10);
                    }
                };

                requestAnimationFrame(animateScroll);
            }, 10);
        }
    }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SocialIcons__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SocialIcons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_SocialIcons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        socialIcons: __WEBPACK_IMPORTED_MODULE_0__components_SocialIcons___default.a
    },

    props: {
        attendee: {},
        user: {}
    },

    methods: {
        openChat: function openChat(person) {
            __WEBPACK_IMPORTED_MODULE_1__router_index__["b" /* EventBus */].$emit('openChat', person);
        },
        close: function close() {
            this.$emit('cardClosed');
        }
    }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//

// TODO: reduce space between rows (Manoo's request)

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        attendee: {}
    },

    data: function data() {
        return {
            person: {}
        };
    },


    methods: {
        openPersonCard: function openPersonCard() {
            this.$emit('openCard', this.attendee);
            __WEBPACK_IMPORTED_MODULE_0__router_index__["c" /* LeadBus */].$emit('recordLead', { type: 'attendee-profile-card', data: { profileCardOf: this.attendee.id } });
        }
    }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PresenterLink__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PresenterLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PresenterLink__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        presenterLink: __WEBPACK_IMPORTED_MODULE_0__components_PresenterLink___default.a
    },

    props: {
        presentation: {},
        profileIndex: ''
    },

    data: function data() {
        return {
            show: false
        };
    },


    methods: {
        scrollProfile: function scrollProfile(direction) {
            this.$emit('scrollProfile', direction);
        },
        close: function close() {
            this.show = false;
        },
        afterHidden: function afterHidden() {
            this.$emit('closeCard');
        },
        stopClickPropagation: function stopClickPropagation(event) {
            if (event && event.stopPropagation) {
                event.stopPropagation();
            }
        }
    },

    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            _this.show = true;
        }, 1);
    }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        item: {}
    },

    methods: {
        recordLead: function recordLead() {
            __WEBPACK_IMPORTED_MODULE_0__router_index__["c" /* LeadBus */].$emit('recordLead', { type: 'presenter-profile-card', data: { label: this.item.label, link: this.item.href } });
        }
    }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: websocket or force rerender to update UI when new account linked


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        user: {},
        service: Object
    },

    data: function data() {
        return {
            socialMedias: {
                linkedin: 'LinkedIn',
                twitter: 'Twitter',
                facebook: 'Facebook'
            }
        };
    },


    methods: {
        isConnected: function isConnected(socialMedia) {
            return !!this.getUserSocialMediaProfile(socialMedia);
        },
        getProfileUrl: function getProfileUrl(socialMedia) {
            var userProfile = this.getUserSocialMediaProfile(socialMedia);
            if (userProfile !== undefined && userProfile[0].network === socialMedia) {
                return userProfile[0].profileUrl;
            }
        },
        getProfilePicture: function getProfilePicture(socialMedia) {
            var userProfile = this.getUserSocialMediaProfile(socialMedia);
            return userProfile && userProfile[0].network === socialMedia && userProfile[0].pictureUrl ? userProfile[0].pictureUrl : '/static/img/anonymous.svg';
        },
        socialMediaIcon: function socialMediaIcon(socialMedia) {
            return 'fa fa-' + socialMedia;
        },
        unlinkAccount: function unlinkAccount(socialMedia) {
            var userProfile = this.getUserSocialMediaProfile(socialMedia);
            var socialIndex = userProfile[1];

            if (userProfile[0].network === socialMedia) {
                this.user.social.splice(socialIndex, 1);
                __WEBPACK_IMPORTED_MODULE_0__router_index__["b" /* EventBus */].$emit('unlinkAccount', socialMedia);
            }
        },
        getUserSocialMediaProfile: function getUserSocialMediaProfile(socialMedia) {
            var socialMediasCount = this.user.social.length;

            for (var i = 0; i < socialMediasCount; i++) {
                if (this.user.social[i].network === socialMedia) {
                    return [this.user.social[i], i];
                }
            }
        },
        linkAccount: function linkAccount(socialMedia) {
            // links only for testing. Server will handle redirects
            var authBaseUrl = this.service.getLoginUrl(socialMedia);

            if (!authBaseUrl) {
                return;
            }

            authBaseUrl += '&u=' + this.user.id;

            var socialWindow = window.open(authBaseUrl);

            if (socialWindow === null) {
                return;
            }

            var userId = this.user.id;
            var profileFound = this.getUserSocialMediaProfile(socialMedia);

            function retry(nbTries) {
                if (++nbTries > 20) {
                    return;
                }

                var successful = profileFound;

                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_0__router_index__["b" /* EventBus */].$emit('getUser', userId);

                    if (!successful) {
                        retry(nbTries);
                    }
                }, 2000);
            }

            retry(0);
        },
        refreshUI: function refreshUI(socialMedia) {
            var userProfile = this.getUserSocialMediaProfile(socialMedia);
            while (!userProfile) {
                setTimeout(this.$emit('getUser', this.user.id), 3000);
                userProfile = this.getUserSocialMediaProfile(socialMedia);
            }
        },
        close: function close() {
            this.$emit('closeModal');
        }
    }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        presentation: {},
        user: {},
        slideList: {},
        currentSlide: '',
        surveys: {}
    },

    data: function data() {
        return {
            slideNum: this.slideList[this.currentSlide].slideId
        };
    },


    computed: {
        showFiles: function showFiles() {
            return this.presentation.props.Resources && this.presentation.props.Resources[this.slideNum] && this.presentation.props.Resources[this.slideNum].Files && this.presentation.props.Resources[this.slideNum].Files.length !== 0;
        },
        showLinks: function showLinks() {
            return this.presentation.props.Resources && this.presentation.props.Resources[this.slideNum] && this.presentation.props.Resources[this.slideNum].Links && this.presentation.props.Resources[this.slideNum].Links.length !== 0;
        },
        showNotes: function showNotes() {
            return this.presentation.props.Resources && this.presentation.props.Resources[this.slideNum] && this.presentation.props.Resources[this.slideNum].Notes && this.presentation.props.Resources[this.slideNum].Notes.length !== 0;
        },
        isSurveysEmpty: function isSurveysEmpty() {
            return this.surveys ? !this.surveys.length : true;
        }
    },

    watch: {
        currentSlide: function currentSlide() {
            this.slideNum = this.slideList[this.currentSlide].slideId;
        }
    },

    methods: {
        launchSurvey: function launchSurvey(survey) {
            __WEBPACK_IMPORTED_MODULE_1__router_index__["b" /* EventBus */].$emit('startSurvey', survey, function (json) {
                __WEBPACK_IMPORTED_MODULE_1__router_index__["b" /* EventBus */].$emit('submitSurvey', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json));
            }, console.log, function () {
                console.log('Survey cancelled');
            });
        },
        openFile: function openFile(fileName) {
            var fileLink = 'https://res.dialogloop.com/' + this.presentation.id + '/' + fileName;
            window.open(fileLink);
            this.recordLead('file', fileName, fileLink);
        },
        close: function close() {
            this.$emit('closeResources');
        },
        recordLead: function recordLead(type, label, link) {
            if (type === 'file') {
                __WEBPACK_IMPORTED_MODULE_1__router_index__["c" /* LeadBus */].$emit('recordLead', { type: 'resource-file', data: { label: label, link: link } });
            } else if (type === 'link') {
                __WEBPACK_IMPORTED_MODULE_1__router_index__["c" /* LeadBus */].$emit('recordLead', { type: 'resource-link', data: { label: label, link: link } });
            }
        }
    }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PresenterCard__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PresenterCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PresenterCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VisualPanel__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VisualPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VisualPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ResourcesTray__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ResourcesTray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ResourcesTray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__submodules_survey_web_dist_1_2_0_survey_templates_survey_1_2_0_vue__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__submodules_survey_web_dist_1_2_0_survey_templates_survey_1_2_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__submodules_survey_web_dist_1_2_0_survey_templates_survey_1_2_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        visualpanel: __WEBPACK_IMPORTED_MODULE_1__components_VisualPanel___default.a,
        presentercard: __WEBPACK_IMPORTED_MODULE_0__components_PresenterCard___default.a,
        resourcestray: __WEBPACK_IMPORTED_MODULE_2__components_ResourcesTray___default.a,
        survey: __WEBPACK_IMPORTED_MODULE_3__submodules_survey_web_dist_1_2_0_survey_templates_survey_1_2_0_vue___default.a
    },

    props: {
        presentation: {},
        user: {},
        slideList: {},
        syncSlideNum: {},
        currentSlide: '',
        progressiveReveal: {},
        surveys: {},
        service: {}
    },

    data: function data() {
        return {
            cardOpen: false,
            isResourceOpen: false,
            profileIndex: 0,
            notesOpen: false,
            initialOpen: false,
            isSurveyVisible: false,
            jsonSurvey: undefined,
            onSubmitSurvey: undefined,
            onFailSurvey: undefined,
            onCancelSurvey: undefined,
            lastPresentationId: undefined
        };
    },


    computed: {
        isResourceAvailable: function isResourceAvailable() {
            if (!this.slideList || !this.slideList[this.currentSlide] || !this.presentation || !this.presentation.props) {
                return false;
            }

            if (this.presentation.props.SurveyInstances && this.presentation.props.SurveyInstances.length > 0) {
                return true;
            }

            if (!this.presentation.props.Resources) {
                return false;
            }

            var slideNum = this.slideList[this.currentSlide].slideId;
            var resources = this.presentation.props.Resources[slideNum];
            var surveyExists = this.surveys ? !!this.surveys.length : false;

            return !this.notesOpen && (surveyExists || resources && (resources.Files && resources.Files.length > 0 || resources.Links && resources.Links.length > 0 || resources.Notes && resources.Notes.length > 0));
        },
        pictureUrl: function pictureUrl() {
            if (!this.presentation || !this.presentation.props) {
                return "../assets/icons/anonymous.svg";
            }

            if (this.presentation.props.PresenterInfo) {
                return this.presentation.props.PresenterInfo.pictureURL;
            }

            if (this.presentation.props.PresenterProfiles && this.presentation.props.PresenterProfiles.profiles && this.presentation.props.PresenterProfiles.profiles[this.profileIndex]) {
                return this.presentation.props.PresenterProfiles.profiles[this.profileIndex].pictureURL;
            }

            return "../assets/icons/anonymous.svg";
        }
    },

    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_4__router_index__["b" /* EventBus */].$on('disableResourcePane', function () {
            _this.notesOpen = true;
        });

        __WEBPACK_IMPORTED_MODULE_4__router_index__["b" /* EventBus */].$on('enableResourcePane', function () {
            _this.notesOpen = false;
        });

        __WEBPACK_IMPORTED_MODULE_4__router_index__["b" /* EventBus */].$on('startSurvey', function (json, onSubmit, onFail, onCancel) {
            if (json && json !== '') {
                _this.isSurveyVisible = true;
            }

            _this.jsonSurvey = json;

            _this.onSubmitSurvey = function (json) {
                _this.isSurveyVisible = false;

                if (onSubmit) {
                    onSubmit(json);
                }
            };

            _this.onFailSurvey = function (err) {
                _this.isSurveyVisible = false;

                if (onFail) {
                    onFail(err);
                }
            };

            _this.onCancelSurvey = onCancel;
        });

        __WEBPACK_IMPORTED_MODULE_4__router_index__["b" /* EventBus */].$on('closeModals', function () {
            _this.closePresenterCard();
        });
    },


    methods: {
        togglePresenterCard: function togglePresenterCard() {
            this.cardOpen = !this.cardOpen;
        },
        getCurrentSlide: function getCurrentSlide(newSlide) {
            this.$emit('currentSlide', newSlide);
        },
        toggleTray: function toggleTray() {
            this.isResourceOpen = !this.isResourceOpen;
        },
        scrollProfile: function scrollProfile(direction) {
            var numProfiles = this.presentation.props.PresenterProfiles.profiles.length;

            if (direction === 'left') {
                this.profileIndex -= 1;

                if (this.profileIndex < 0) {
                    this.profileIndex = numProfiles - 1;
                }
            } else if (direction === 'right') {
                this.profileIndex += 1;

                if (this.profileIndex >= numProfiles) {
                    this.profileIndex = 0;
                }
            }
        },
        closePresenterCard: function closePresenterCard() {
            this.cardOpen = false;
        },
        dismissSurvey: function dismissSurvey() {
            this.isSurveyVisible = false;

            if (this.onCancelSurvey) {
                this.onCancelSurvey();
            }
        }
    },

    watch: {
        slideList: function slideList() {
            if (!this.slideList || !this.slideList[this.currentSlide]) {
                this.isResourceOpen = false;
                this.initialOpen = false;
                return;
            }

            var slideId = this.slideList[this.currentSlide].slideId;
            var surveyExists = this.presentation.props.Surveys || this.presentation.props.SurveyInstances ? true : undefined;
            var resourcesExist = this.presentation.props.Resources && this.presentation.props.Resources[slideId] ? true : undefined;
            var openPane = surveyExists || resourcesExist ? true : undefined;

            if (this.slideList && !this.initialOpen && openPane) {
                this.isResourceOpen = true;
                this.initialOpen = true;
            }
        },
        presentation: function presentation() {
            if (this.presentation.id !== this.lastPresentationId) {
                this.cardOpen = true;
                this.lastPresentationId = this.presentation.id;
            }
        }
    }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: create method for img onerror instead of writing statements in callback


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        presentation: {}
    },

    computed: {
        presenterInfo: function presenterInfo() {
            return this.presentation && this.presentation.props ? this.presentation.props.PresenterInfo : undefined;
        },
        presenterProfiles: function presenterProfiles() {
            return this.presentation && this.presentation.props ? this.presentation.props.PresenterProfiles : undefined;
        }
    },

    methods: {
        openPresentation: function openPresentation() {
            __WEBPACK_IMPORTED_MODULE_0__router_index__["b" /* EventBus */].$emit('openPresentation', this.presentation);
        }
    }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SessionCard__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SessionCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_SessionCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NotificationBar__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NotificationBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_NotificationBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        sessioncard: __WEBPACK_IMPORTED_MODULE_0__components_SessionCard___default.a,
        spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
        'notification-bar': __WEBPACK_IMPORTED_MODULE_2__components_NotificationBar___default.a
    },

    props: {
        presentations: {},
        isLoading: Boolean
    },

    data: function data() {
        return {
            option: 'all',
            notificationText: undefined,
            callbackNotification: undefined,
            retryUrl: 'dialog.live/',
            isRetrying: true
        };
    },


    computed: {
        presentationsGrouped: function presentationsGrouped() {
            if (this.option === 'recents') {
                return []; // TODO: SDK call to implement?
            }

            return this.presentations;
        },
        isReady: function isReady() {
            return !!this.presentationsGrouped && this.presentationsGrouped.constructor === Array;
        },
        isEmpty: function isEmpty() {
            return this.isReady && !this.presentationsGrouped.length;
        }
    },

    watch: {
        presentations: function presentations() {
            this.notificationText = undefined;
        }
    },

    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_3__router_index__["b" /* EventBus */].$on('showBanner', function (text, callback) {
            _this.notificationText = text;
            _this.callbackNotification = callback;
        });
    },


    methods: {
        showAll: function showAll() {
            this.option = 'all';
        },
        showRecents: function showRecents() {
            this.option = 'recents';
        },
        onNotificationClicked: function onNotificationClicked() {
            this.notificationText = undefined;

            if (this.callbackNotification) {
                this.callbackNotification();
            }
        },
        retry: function retry() {
            if (this.retryUrl.split('/').length > 1) {
                __WEBPACK_IMPORTED_MODULE_3__router_index__["b" /* EventBus */].$emit('reloadWithShortCodeUrl', this.retryUrl);
            }
        }
    }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var baseFB = 'https://www.facebook.com/sharer/sharer.php?u=';
var baseLI = 'https://www.linkedin.com/shareArticle?mini=true&url=';

/* harmony default export */ __webpack_exports__["default"] = ({

    props: {
        anchor: {},
        presentation: {},
        currentSlide: {},
        slideList: {}
    },

    data: function data() {
        return {
            top: 0,
            left: 0,
            arrowLeft: 0
        };
    },


    computed: {
        getSlideImageLink: function getSlideImageLink() {
            if (this.slideList) {
                return this.slideList[this.currentSlide].url;
            }
        },
        mailHref: function mailHref() {
            return 'mailto:?&body=' + encodeURI(this.$t("str.ImViewingAnInterestingPresentationAt") + location.href);
        },
        containerStyle: function containerStyle() {
            return {
                top: this.top + 'px',
                left: this.left + 'px'
            };
        },
        arrow: function arrow() {
            return {
                marginLeft: this.arrowLeft + 'px'
            };
        }
    },

    mounted: function mounted() {
        if (!this.anchor) {
            return;
        }

        this.top = this.anchor.offsetTop - this.$refs.container.clientHeight - 5;
        this.left = this.anchor.offsetLeft - this.$refs.container.clientWidth / 2;

        // If overflow on the right side
        if (this.left + this.$refs.container.clientWidth > this.$refs.overlay.clientWidth) {
            var shift = this.left - this.$refs.overlay.clientWidth + this.$refs.container.clientWidth + 5;
            this.arrowLeft = this.$refs.container.clientWidth / 2 - this.$refs.arrow.clientWidth / 2 + shift;
            this.left -= shift;
        } else {
            // No overflow
            this.arrowLeft = this.$refs.container.clientWidth / 2 - this.$refs.arrow.clientWidth / 2;
        }
    },


    methods: {
        shareOnFacebook: function shareOnFacebook() {
            window.open(encodeURI('' + baseFB + this.getSlideImageLink));
            __WEBPACK_IMPORTED_MODULE_0__router_index__["c" /* LeadBus */].$emit('recordLead', {
                type: 'shared-on',
                data: {
                    sharedon: 'facebook',
                    onSlideId: this.currentSlide
                }
            });
        },
        shareOnLinkedIn: function shareOnLinkedIn() {
            window.open(encodeURI('' + baseLI + this.getSlideImageLink + '&title=' + this.presentation.title + '&summary=' + this.presentation.description + '&source='));
            __WEBPACK_IMPORTED_MODULE_0__router_index__["c" /* LeadBus */].$emit('recordLead', {
                type: 'shared-on',
                data: {
                    sharedon: 'linkedin',
                    onSlideId: this.currentSlide
                }
            });
        },
        shareInMail: function shareInMail() {
            __WEBPACK_IMPORTED_MODULE_0__router_index__["c" /* LeadBus */].$emit('recordLead', {
                type: 'shared-on',
                data: {
                    sharedon: 'email',
                    onSlideId: this.currentSlide
                }
            });
        },
        close: function close() {
            this.$emit('close');
        }
    },

    created: function created() {
        var _this = this;

        window.onresize = function () {
            _this.close();
        };
    }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        network: {},
        attendee: {}
    },

    methods: {
        recordLead: function recordLead() {
            __WEBPACK_IMPORTED_MODULE_0__router_index__["c" /* LeadBus */].$emit('recordLead', { type: 'attendee-profile-link', data: { network: this.network.network, userId: this.attendee.id } });
        }
    }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {
        // Center it vertically
        this.$el.style.marginTop = (this.$el.parentNode.offsetHeight - this.$el.offsetHeight) / 2 + 'px';
    }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__javascript_classes_utils_storage_js__ = __webpack_require__(58);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// TODO: add checks to see if tweet properly sent




/* harmony default export */ __webpack_exports__["default"] = ({

    props: {
        twitterProfile: {},
        currentSlide: '',
        slideList: {},
        user: {},
        socialMedia: {}
    },

    data: function data() {
        return {
            userText: undefined
        };
    },


    computed: {
        slideUrl: function slideUrl() {
            return this.slideList && this.currentSlide !== undefined && this.slideList[this.currentSlide] ? this.slideList[this.currentSlide].url : undefined;
        },


        message: {
            get: function get() {
                if (this.userText !== undefined) {
                    return this.userText;
                }

                if (this.socialMedia && this.socialMedia.Twitter) {
                    return this.socialMedia.Twitter;
                }

                return '';
            },
            set: function set(newMessage) {
                this.userText = newMessage;
            }
        }
    },

    methods: {
        close: function close() {
            this.$emit('closeTweetUI');
        },
        tweetSlide: function tweetSlide() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__router_index__["b" /* EventBus */].$emit('tweetSlide', {
                url: this.slideList[this.currentSlide].url,
                id: this.slideList[this.currentSlide].id,
                nativeSlideId: this.slideList[this.currentSlide].slideId,
                status: this.message === '' ? this.$t('str.CheckOutTheSlideFromSessionIAmAttendingDialogloop') : this.message
            }, function (err) {
                if (err) {
                    return;
                }

                // Save the fact we sent a tweet
                var key = _this.user.id + "_tweets";
                var tweets = __WEBPACK_IMPORTED_MODULE_1__javascript_classes_utils_storage_js__["a" /* default */].getItem(key, "{}");

                try {
                    tweets = JSON.parse(tweets);
                    tweets[_this.slideList[_this.currentSlide].id] = true;
                    __WEBPACK_IMPORTED_MODULE_1__javascript_classes_utils_storage_js__["a" /* default */].setItem(key, tweets);
                } catch (e) {
                    console.log(e);
                    return;
                }

                // TODO: send notification that tweet was succesfully sent
                // close tweet UI
                _this.$emit('closeTweetUI');
                __WEBPACK_IMPORTED_MODULE_0__router_index__["c" /* LeadBus */].$emit('recordLead', {
                    type: 'shared-on',
                    data: {
                        sharedon: 'twitter',
                        onSlideId: _this.currentSlide
                    }
                });
            });
        }
    }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TweetSlideUI__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TweetSlideUI___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_TweetSlideUI__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ShareOptions__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ShareOptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ShareOptions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__javascript_classes_JS_DOCX_Document__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__javascript_classes_Notes__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__javascript_classes_utils_storage_js__ = __webpack_require__(58);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: add button to go back to first slide
// TODO: when web page is refreshed, should start at last slide user had open, not default to first slide









/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        carousel: __WEBPACK_IMPORTED_MODULE_0__components_Carousel___default.a,
        tweetslideui: __WEBPACK_IMPORTED_MODULE_1__components_TweetSlideUI___default.a,
        shareoptions: __WEBPACK_IMPORTED_MODULE_2__components_ShareOptions___default.a
    },

    props: {
        presentation: {},
        user: {},
        slideList: {},
        syncSlideNum: {},
        slideNum: {},
        progressiveReveal: {},
        service: {}
    },

    data: function data() {
        return {
            currentSlide: 0,
            syncSlide: true,
            slideLiked: false,
            tweet: false,
            twitterProfile: {},
            anchorOptions: undefined,
            notes: {},
            slideTweeted: undefined
        };
    },


    computed: {
        socialMedia: function socialMedia() {
            if (this.presentation && this.presentation.props && this.slideList && this.slideList[this.currentSlide] !== undefined && this.presentation.props.Resources && this.presentation.props.Resources[this.slideList[this.currentSlide].slideId]) {
                return this.presentation.props.Resources[this.slideList[this.currentSlide].slideId].SocialMedia;
            }
        }
    },

    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_3__router_index__["b" /* EventBus */].$emit('getSlides', this.presentation.id);
        this.updateIsSlideTweeted();
    },


    watch: {
        slideList: function slideList() {
            this.updateIsSlideTweeted();
            this.slideLiked = this.slideList[this.currentSlide].liked === true;
        },
        currentSlide: function currentSlide() {
            this.updateIsSlideTweeted();
        }
    },

    methods: {
        slideCalculated: function slideCalculated(newSlide) {
            this.currentSlide = newSlide;
            this.$emit('newCurrentSlide', newSlide);
            // TODO: ensure we check if slide is liked for first slide when loaded
            this.slideLiked = this.slideList[this.currentSlide].liked === true;
        },
        changeSyncSlide: function changeSyncSlide(newVal) {
            this.syncSlide = newVal;
        },
        likeSlide: function likeSlide() {
            if (this.slideLiked === false) {
                this.slideLiked = true;
                __WEBPACK_IMPORTED_MODULE_3__router_index__["b" /* EventBus */].$emit('likeSlide', this.slideList[this.currentSlide]);
                __WEBPACK_IMPORTED_MODULE_3__router_index__["b" /* EventBus */].$emit('getSlides', this.presentation.id);
            }
        },
        getUserSocialMediaProfile: function getUserSocialMediaProfile(socialMedia) {
            var socialMediasCount = this.user.social.length;

            for (var i = 0; i < socialMediasCount; i++) {
                if (this.user.social[i].network === socialMedia) {
                    return [this.user.social[i], i];
                }
            }
        },
        openTweetUI: function openTweetUI() {
            if (this.slideTweeted && confirm(this.$t('str.YouHaveAlreadyTweetedThisSlideDoYouWantToTweetItAgain')) !== true) {
                return;
            }

            this.twitterProfile = this.getUserSocialMediaProfile('Twitter');

            if (this.twitterProfile === null) {
                alert(this.$t('str.YouHaveNotConnectedATwitterAccountRedirecting'));

                var url = this.service.getLoginUrl('twitter');

                if (!url) {
                    return;
                }

                url += '&u=' + this.user.id;

                window.open(url);
            } else {
                this.tweet = !this.tweet;
            }
        },
        toggleTweetIcon: function toggleTweetIcon() {
            this.tweet = false;
            this.updateIsSlideTweeted();
        },
        toggleShareOptions: function toggleShareOptions(event) {
            if (this.anchorOptions) {
                this.anchorOptions = undefined;
            } else if (event) {
                this.anchorOptions = event.srcElement;
            }
        },
        downloadSlides: function downloadSlides() {
            __WEBPACK_IMPORTED_MODULE_3__router_index__["c" /* LeadBus */].$emit('recordLead', { type: 'slides-download-pdf', data: {} });
            var doc = new __WEBPACK_IMPORTED_MODULE_4__javascript_classes_JS_DOCX_Document__["a" /* default */]();
            this.currentSlideId = this.slideList[this.currentSlide].slideId;
            this.userId = this.user.id;

            var str = __WEBPACK_IMPORTED_MODULE_6__javascript_classes_utils_storage_js__["a" /* default */].getItem(this.userId);

            if (!str) {
                return;
            }

            var notesJson = void 0;

            try {
                notesJson = JSON.parse(str);
            } catch (e) {
                return;
            }

            this.notes = new __WEBPACK_IMPORTED_MODULE_5__javascript_classes_Notes__["a" /* default */](this.userId, notesJson.content);

            // check if there are notes for current slide
            for (var i = 0; i < this.slideList.length; i++) {
                doc.addImage(this.slideList[i].url, this.notes.get(this.presentation.id, this.slideList[i].slideId, ""));
            }
        },
        updateIsSlideTweeted: function updateIsSlideTweeted() {
            if (!this.user || this.currentSlide === undefined || !this.slideList || !this.slideList[this.currentSlide]) {
                return false;
            }

            var key = this.user.id + "_tweets";
            var tweets = __WEBPACK_IMPORTED_MODULE_6__javascript_classes_utils_storage_js__["a" /* default */].getItem(key);

            if (!tweets) {
                return false;
            }

            try {
                tweets = JSON.parse(tweets);
            } catch (e) {
                console.log(e);
                return false;
            }

            this.slideTweeted = tweets[this.slideList[this.currentSlide].id];
        },
        closeShare: function closeShare() {
            this.anchorOptions = undefined;
        }
    }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_HeaderBar__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BottomBar__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BottomBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_BottomBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SessionApp__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SessionApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_SessionApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LeadGen__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LeadGen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_LeadGen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_NotificationBar__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_NotificationBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_NotificationBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__javascript_classes_utils_navigator__ = __webpack_require__(57);




//
//
//
//
//
//
//
//
//
//
//
//
//










var androidIntent = 'intent://join/#Intent;package=com.dialogloop.dialogloop_android;action=android.intent.action.VIEW;S.browser_fallback_url=https%3A%2F%2Fplay.google.com%2Fstore;end';
var iOSIntent = 'dialogloop://';

function getParam(url, name, defaultValue) {
    if (!url || !name) {
        return;
    }

    var regexp = new RegExp('[?&#]' + name + '=');
    var start = url.search(regexp);

    if (start < 0) {
        return defaultValue;
    }

    start += name.length + 2;

    var end = url.substr(start).search(/[?&#]/);

    return url.substr(start, end >= 0 ? end : undefined);
}

/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        headerbar: __WEBPACK_IMPORTED_MODULE_4__components_HeaderBar___default.a,
        bottombar: __WEBPACK_IMPORTED_MODULE_5__components_BottomBar___default.a,
        sessionapp: __WEBPACK_IMPORTED_MODULE_6__components_SessionApp___default.a,
        leadgen: __WEBPACK_IMPORTED_MODULE_7__components_LeadGen___default.a,
        'notification-bar': __WEBPACK_IMPORTED_MODULE_9__components_NotificationBar___default.a
    },

    props: {
        service: Object
    },

    data: function data() {
        return {
            isReady: false,
            isLoading: true,
            activePres: undefined,
            presentationList: {},
            questionList: undefined,
            peopleList: undefined,
            slideList: [], // Unsorted chain list
            user: {},
            syncSlideNum: 0,
            peopleMap: {},
            currentSlide: 0,
            progressiveReveal: 0,
            chatList: undefined,
            chatContacts: undefined,
            revealOn: false,
            surveys: undefined,
            isAllowedToListSessions: false,
            notificationText: undefined,
            notificationForAll: undefined,
            connectionParams: undefined
        };
    },


    computed: {
        sortedSlides: function sortedSlides() {
            if (!this.slideList || this.slideList.length === 0) {
                return [];
            }

            var tmp = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.slideList));
            var sortedList = [];

            // Find first slide
            for (var i = 0; i < tmp.length; ++i) {
                if (tmp[i].prev === "0") {
                    sortedList.push(tmp.splice(i, 1)[0]);
                    break;
                }
            }

            while (tmp.length > 0) {
                var found = false;

                for (var _i = 0; _i < tmp.length; ++_i) {
                    if (sortedList[sortedList.length - 1].next === tmp[_i].id) {
                        sortedList.push(tmp.splice(_i, 1)[0]);
                        found = true;
                        break;
                    }
                }

                if (!found) {
                    console.error('Error processing sorted slides list. Could not find slide with Id: ' + sortedList[sortedList.length - 1].next);
                    break;
                }
            }

            return sortedList;
        }
    },

    watch: {
        $route: function $route(to, from) {
            this.init();
        }
    },

    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.service.join({
                                url: window.location.href
                            }).then(function (user) {
                                _this.user = user;
                                _this.init();

                                // Show notification if we can use native application
                                if (getParam(window.location.href, 'beta-enable-native', false)) {
                                    _this.service.getConnection(window.location.href).then(function (params) {
                                        if (!params) {
                                            return;
                                        }

                                        _this.connectionParams = params;

                                        if (__WEBPACK_IMPORTED_MODULE_10__javascript_classes_utils_navigator__["a" /* default */].isAndroid()) {
                                            _this.notificationForAll = '{$this.$t(\'str.UseAndroidNativeApp\')}}';
                                        } else if (__WEBPACK_IMPORTED_MODULE_10__javascript_classes_utils_navigator__["a" /* default */].isIOS()) {
                                            _this.notificationForAll = '{' + _this.$t('str.UseIOSNativeApp') + '}';
                                        }
                                    });
                                }
                            }).catch(function (err) {
                                if (err.code === 401) {
                                    // Show login page with social network selection
                                    _this.$router.push({
                                        path: 'login',
                                        query: _this.$route.query
                                    });
                                } else {
                                    console.error(err);
                                    _this.notificationText = _this.$t("str.SorryUnableToLogin");
                                }
                            });

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },


    methods: {
        init: function init() {
            var _this2 = this;

            this.notificationText = undefined;
            this.notificationForAll = undefined;
            this.isLoading = true;
            this.isAllowedToListSessions = false;

            this.service.getSession({
                url: window.location.href
            }).then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(handle) {
                    var presentation;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _this2.isReady = true;

                                    if (!handle.session) {
                                        _context2.next = 8;
                                        break;
                                    }

                                    _this2.isAllowedToListSessions = true;
                                    _context2.next = 5;
                                    return _this2.getPresentations(handle.session);

                                case 5:
                                    _this2.presentationList = _context2.sent;
                                    _context2.next = 18;
                                    break;

                                case 8:
                                    if (!handle.presentation) {
                                        _context2.next = 15;
                                        break;
                                    }

                                    _context2.next = 11;
                                    return _this2.service.getPresentation(handle.presentation);

                                case 11:
                                    presentation = _context2.sent;

                                    _this2.openPresentation(presentation);
                                    _context2.next = 18;
                                    break;

                                case 15:
                                    console.error("Invalid handle");
                                    _this2.notificationText = _this2.$t("str.UnexpectedError");
                                    return _context2.abrupt('return');

                                case 18:

                                    _this2.resetSurveys();
                                    _this2.isLoading = false;

                                case 20:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this2);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }()).catch(function (err) {
                console.error(err);
                _this2.notificationText = _this2.$t("str.SorryUnableToGetSessionInfo");
                _this2.isLoading = false;
            });
        },
        getCurrentSlide: function getCurrentSlide(newSlide) {
            this.currentSlide = newSlide;
        },
        addPresentationListeners: function addPresentationListeners() {
            var _this3 = this;

            this.service.addEventListener('slideChanged', function (slide) {
                if (_this3.revealOn === false) {
                    _this3.revealOn = true;
                    _this3.progressiveReveal = _this3.syncSlideNum;
                }

                _this3.syncSlideNum = _this3.getSlideIndexFromId(slide.id);

                if (_this3.syncSlideNum > _this3.progressiveReveal) {
                    _this3.progressiveReveal = _this3.syncSlideNum;
                }
            });

            this.service.addEventListener('attendeeJoined', function (attendee) {
                if (!_this3.peopleList) {
                    return;
                }

                for (var i = 0; i < _this3.peopleList.length; i++) {
                    if (_this3.peopleList[i].id === attendee.id) {
                        return;
                    }
                }

                _this3.peopleList.push(attendee);
                _this3.peopleMap.set(attendee.id, attendee);
            });

            this.service.addEventListener('questionAdded', function (question) {
                if (_this3.questionList === undefined) {
                    return;
                }

                _this3.questionList.push(question);
                _this3.questionList.sort(function (a, b) {
                    return a.timestamp - b.timestamp;
                });
                __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$emit('questionsChanged');
            });

            this.service.addEventListener('questionLiked', function (question) {
                if (_this3.questionList === undefined) {
                    return;
                }

                _this3.questionList.splice(_this3.questionList.findIndex(function (oldQuestion) {
                    return oldQuestion.id === question.id;
                }), 1);
                _this3.questionList.push(question);
                _this3.questionList.sort(function (a, b) {
                    // TODO: Insert in the right location right away to avoid resorting the whole array
                    return a.timestamp - b.timestamp;
                });
            });

            this.service.addEventListener('questionPropsUpdated', function (question) {
                if (_this3.questionList === undefined) {
                    return;
                }

                var oldIndex = _this3.questionList.findIndex(function (oldQuestion) {
                    return oldQuestion.id === question.id;
                });

                _this3.questionList[oldIndex].props = question.props;
                _this3.questionList[oldIndex].replies = question.replies;
            });

            this.service.addEventListener('slideUploaded', function () {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(slide) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this3.service.getSlides(_this3.activePres.id);

                                case 2:
                                    _this3.slideList = _context3.sent;

                                    _this3.syncSlideNum = _this3.getSlideIndexFromId(_this3.activePres.currentSlide);

                                case 4:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this3);
                }));

                return function (_x2) {
                    return _ref2.apply(this, arguments);
                };
            }());

            this.service.addEventListener('slideDeleted', function () {
                var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(data) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    _context4.next = 2;
                                    return _this3.service.getSlides(_this3.activePres.id);

                                case 2:
                                    _this3.slideList = _context4.sent;

                                    _this3.syncSlideNum = _this3.getSlideIndexFromId(_this3.activePres.currentSlide);

                                case 4:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, _this3);
                }));

                return function (_x3) {
                    return _ref3.apply(this, arguments);
                };
            }());

            this.service.addEventListener('surveyStarted', function (survey) {
                if (!_this3.activePres || !_this3.activePres.props) {
                    return;
                }

                if (!_this3.activePres.props.SurveyInstances) {
                    _this3.$set(_this3.activePres.props, 'SurveyInstances', []);
                }

                var instanceId = _this3.activePres.props.SurveyInstances.find(function (instanceId) {
                    return instanceId === survey.instanceId;
                });

                if (instanceId) {
                    return;
                }

                _this3.activePres.props.SurveyInstances.push(survey.instanceId);
                _this3.surveys.push(survey);
            });

            this.service.addEventListener('surveyStopped', function (survey) {
                if (!_this3.activePres || !_this3.activePres.props || !_this3.activePres.props.SurveyInstances) {
                    return;
                }

                for (var i = 0; i < _this3.activePres.props.SurveyInstances.length; ++i) {
                    if (_this3.activePres.props.SurveyInstances[i] === survey.instanceId) {
                        _this3.activePres.props.SurveyInstances.splice(i, 1);
                    }
                }

                for (var _i2 = 0; _i2 < _this3.surveys.length; ++_i2) {
                    if (_this3.surveys[_i2].instanceId === survey.instanceId) {
                        _this3.surveys.splice(_i2, 1);
                    }
                }
            });
        },
        resetSurveys: function resetSurveys() {
            var _this4 = this;

            if (!this.activePres || !this.activePres.props) {
                return;
            }

            this.surveys = [];

            var surveys = this.activePres.props.Surveys;

            if (surveys) {
                // Old api
                this.surveys = surveys;
            } else {
                // New api
                var surveyInstances = this.activePres.props.SurveyInstances;

                if (!surveyInstances) {
                    return;
                }

                surveyInstances.map(function () {
                    var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(surveyInstanceId) {
                        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                            while (1) {
                                switch (_context5.prev = _context5.next) {
                                    case 0:
                                        _context5.t0 = _this4.surveys;
                                        _context5.next = 3;
                                        return _this4.service.getSurvey(_this4.activePres.id, surveyInstanceId);

                                    case 3:
                                        _context5.t1 = _context5.sent;

                                        _context5.t0.push.call(_context5.t0, _context5.t1);

                                    case 5:
                                    case 'end':
                                        return _context5.stop();
                                }
                            }
                        }, _callee5, _this4);
                    }));

                    return function (_x4) {
                        return _ref4.apply(this, arguments);
                    };
                }());
            }
        },
        getSlideIndexFromId: function getSlideIndexFromId(id) {
            for (var i = 0; i < this.sortedSlides.length; ++i) {
                if (this.sortedSlides[i].id === id) {
                    return i;
                }
            }

            return 0;
        },
        getPresentations: function getPresentations(handle, callback) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var presentations;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (_this5.isReady) {
                                    _context6.next = 2;
                                    break;
                                }

                                return _context6.abrupt('return');

                            case 2:
                                presentations = void 0;

                                if (!handle) {
                                    _context6.next = 9;
                                    break;
                                }

                                _context6.next = 6;
                                return _this5.service.getPresentations(handle);

                            case 6:
                                presentations = _context6.sent;
                                _context6.next = 11;
                                break;

                            case 9:
                                presentations = [];
                                console.log('Undefined handle');

                            case 11:

                                if (callback) {
                                    callback(presentations);
                                }

                                return _context6.abrupt('return', presentations);

                            case 13:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this5);
            }))();
        },
        openPresentation: function openPresentation(presentation) {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                if (presentation) {
                                    _context7.next = 2;
                                    break;
                                }

                                return _context7.abrupt('return');

                            case 2:

                                _this6.activePres = presentation;
                                _context7.next = 5;
                                return _this6.service.getSlides(presentation.id);

                            case 5:
                                _this6.slideList = _context7.sent;

                                _this6.revealOn = false;
                                _this6.service.joinPresentation(_this6.activePres, _this6.user).then(function () {
                                    _this6.addPresentationListeners();
                                });
                                _this6.peopleList = undefined;
                                _this6.questionList = undefined;
                                _this6.resetSurveys();

                                if (presentation.pinned) {
                                    _this6.progressiveReveal = _this6.slideList.length;
                                } else {
                                    _this6.progressiveReveal = _this6.getSlideIndexFromId(presentation.currentSlide);
                                }

                            case 12:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this6);
            }))();
        },
        onNotificationClicked: function onNotificationClicked() {
            if (!this.connectionParams) {
                return;
            }
            this.notificationForAll = undefined;

            var params = 'dialogloopkey=' + this.connectionParams.dialogloopkey + '&token=' + this.connectionParams.token;

            if (this.connectionParams.session) {
                params += '&session=' + this.connectionParams.session;
            } else if (this.connectionParams.presentation) {
                params += '&presentation=' + this.connectionParams.presentation;
            }

            if (__WEBPACK_IMPORTED_MODULE_10__javascript_classes_utils_navigator__["a" /* default */].isAndroid()) {
                var ifr = document.createElement('iframe');

                ifr.src = androidIntent;
                ifr.style.display = 'none';
                document.body.appendChild(ifr);

                setTimeout(function () {
                    document.body.removeChild(ifr);
                }, 5000);
            } else if (__WEBPACK_IMPORTED_MODULE_10__javascript_classes_utils_navigator__["a" /* default */].isIOS()) {
                var saveHref = document.location.href;
                document.location.href = iOSIntent + '?' + params;

                setTimeout(function () {
                    document.location.href = saveHref;
                }, 400);
            } else {
                return;
            }
        }
    },

    mounted: function mounted() {
        var _this7 = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee23() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('getUser', function () {
                                var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(id) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                                        while (1) {
                                            switch (_context8.prev = _context8.next) {
                                                case 0:
                                                    _context8.next = 2;
                                                    return _this7.service.getUser(id);

                                                case 2:
                                                    _this7.user = _context8.sent;

                                                case 3:
                                                case 'end':
                                                    return _context8.stop();
                                            }
                                        }
                                    }, _callee8, _this7);
                                }));

                                return function (_x5) {
                                    return _ref5.apply(this, arguments);
                                };
                            }());

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('logout', function () {
                                _this7.user = undefined;
                                _this7.activePres = undefined;
                                _this7.$router.replace({
                                    path: 'login',
                                    query: _this7.$route.query
                                });
                            });

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('getPresentations', function () {
                                var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9(handle) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                                        while (1) {
                                            switch (_context9.prev = _context9.next) {
                                                case 0:
                                                    _this7.presentationList = _this7.getPresentations(handle);

                                                case 1:
                                                case 'end':
                                                    return _context9.stop();
                                            }
                                        }
                                    }, _callee9, _this7);
                                }));

                                return function (_x6) {
                                    return _ref6.apply(this, arguments);
                                };
                            }());

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('getPeople', function () {
                                var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11(id) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                                        while (1) {
                                            switch (_context11.prev = _context11.next) {
                                                case 0:
                                                    if (!(_this7.peopleList !== undefined)) {
                                                        _context11.next = 2;
                                                        break;
                                                    }

                                                    return _context11.abrupt('return');

                                                case 2:
                                                    _context11.next = 4;
                                                    return _this7.service.getPeople(id);

                                                case 4:
                                                    _this7.peopleList = _context11.sent;


                                                    _this7.peopleMap = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
                                                    _this7.peopleList.forEach(function () {
                                                        var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10(person) {
                                                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                                                                while (1) {
                                                                    switch (_context10.prev = _context10.next) {
                                                                        case 0:
                                                                            _this7.peopleMap.set(person.id, person);

                                                                        case 1:
                                                                        case 'end':
                                                                            return _context10.stop();
                                                                    }
                                                                }
                                                            }, _callee10, _this7);
                                                        }));

                                                        return function (_x8) {
                                                            return _ref8.apply(this, arguments);
                                                        };
                                                    }());

                                                case 7:
                                                case 'end':
                                                    return _context11.stop();
                                            }
                                        }
                                    }, _callee11, _this7);
                                }));

                                return function (_x7) {
                                    return _ref7.apply(this, arguments);
                                };
                            }());

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('postQuestion', function () {
                                var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12(question) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                                        while (1) {
                                            switch (_context12.prev = _context12.next) {
                                                case 0:
                                                    if (question && _this7.user) {
                                                        _this7.service.postQuestion(_this7.activePres.id, _this7.user.id, question);
                                                    }

                                                case 1:
                                                case 'end':
                                                    return _context12.stop();
                                            }
                                        }
                                    }, _callee12, _this7);
                                }));

                                return function (_x9) {
                                    return _ref9.apply(this, arguments);
                                };
                            }());

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('postMessage', function () {
                                var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13(message, contactId) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
                                        while (1) {
                                            switch (_context13.prev = _context13.next) {
                                                case 0:
                                                    if (message && _this7.user && _this7.activePres) {
                                                        _this7.service.postMessage(_this7.activePres.id, _this7.user.id, contactId, message);
                                                    }

                                                case 1:
                                                case 'end':
                                                    return _context13.stop();
                                            }
                                        }
                                    }, _callee13, _this7);
                                }));

                                return function (_x10, _x11) {
                                    return _ref10.apply(this, arguments);
                                };
                            }());

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('unlinkAccount', function () {
                                var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14(socialMedia) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
                                        while (1) {
                                            switch (_context14.prev = _context14.next) {
                                                case 0:
                                                    _this7.service.unlinkAccount(_this7.user.id, socialMedia);

                                                case 1:
                                                case 'end':
                                                    return _context14.stop();
                                            }
                                        }
                                    }, _callee14, _this7);
                                }));

                                return function (_x12) {
                                    return _ref11.apply(this, arguments);
                                };
                            }());

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('likeQuestion', function () {
                                var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15(question) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
                                        while (1) {
                                            switch (_context15.prev = _context15.next) {
                                                case 0:
                                                    if (question) {
                                                        _this7.service.likeQuestion(_this7.activePres.id, _this7.user.id, question.id);
                                                    }

                                                case 1:
                                                case 'end':
                                                    return _context15.stop();
                                            }
                                        }
                                    }, _callee15, _this7);
                                }));

                                return function (_x13) {
                                    return _ref12.apply(this, arguments);
                                };
                            }());

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('likeSlide', function () {
                                var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16(slide) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
                                        while (1) {
                                            switch (_context16.prev = _context16.next) {
                                                case 0:
                                                    if (slide) {
                                                        _this7.service.likeSlide(_this7.activePres.id, slide.id);
                                                    }

                                                case 1:
                                                case 'end':
                                                    return _context16.stop();
                                            }
                                        }
                                    }, _callee16, _this7);
                                }));

                                return function (_x14) {
                                    return _ref13.apply(this, arguments);
                                };
                            }());

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('getSlides', function () {
                                var _ref14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee17(id) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
                                        while (1) {
                                            switch (_context17.prev = _context17.next) {
                                                case 0:
                                                    _context17.next = 2;
                                                    return _this7.service.getSlides(id);

                                                case 2:
                                                    _this7.slideList = _context17.sent;

                                                    _this7.revealOn = false;
                                                    _this7.syncSlideNum = _this7.getSlideIndexFromId(_this7.activePres.currentSlide);

                                                    if (_this7.activePres.pinned) {
                                                        _this7.progressiveReveal = _this7.slideList.length;
                                                    } else {
                                                        _this7.progressiveReveal = _this7.syncSlideNum; // Issue if the presenter came back to an early slide before the attendee joins. The attendee won't be able to access all the slides that were shown before. Wait for an update on the props from PPT to check the latest shown slide
                                                    }

                                                case 6:
                                                case 'end':
                                                    return _context17.stop();
                                            }
                                        }
                                    }, _callee17, _this7);
                                }));

                                return function (_x15) {
                                    return _ref14.apply(this, arguments);
                                };
                            }());

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('openPresentation', function (presentation) {
                                _this7.openPresentation(presentation);
                            });

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('getQuestions', function () {
                                var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee18(id) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
                                        while (1) {
                                            switch (_context18.prev = _context18.next) {
                                                case 0:
                                                    if (!(_this7.questionList !== undefined)) {
                                                        _context18.next = 2;
                                                        break;
                                                    }

                                                    return _context18.abrupt('return');

                                                case 2:
                                                    _context18.next = 4;
                                                    return _this7.service.getQuestions(id);

                                                case 4:
                                                    _this7.questionList = _context18.sent;

                                                    _this7.questionList.sort(function (a, b) {
                                                        return a.timestamp - b.timestamp;
                                                    });

                                                case 6:
                                                case 'end':
                                                    return _context18.stop();
                                            }
                                        }
                                    }, _callee18, _this7);
                                }));

                                return function (_x16) {
                                    return _ref15.apply(this, arguments);
                                };
                            }());

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('postQuestionProps', function () {
                                var _ref16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee19(reply) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
                                        while (1) {
                                            switch (_context19.prev = _context19.next) {
                                                case 0:
                                                    if (!(!reply || !_this7.user || !_this7.activePres)) {
                                                        _context19.next = 2;
                                                        break;
                                                    }

                                                    return _context19.abrupt('return');

                                                case 2:

                                                    _this7.service.replyQuestion(_this7.activePres.id, _this7.user.id, reply.questionId, reply.comment);

                                                case 3:
                                                case 'end':
                                                    return _context19.stop();
                                            }
                                        }
                                    }, _callee19, _this7);
                                }));

                                return function (_x17) {
                                    return _ref16.apply(this, arguments);
                                };
                            }());

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('getMessages', function () {
                                var _ref17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee20(contactId) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
                                        while (1) {
                                            switch (_context20.prev = _context20.next) {
                                                case 0:
                                                    _context20.next = 2;
                                                    return _this7.service.getMessages(_this7.user.id, contactId);

                                                case 2:
                                                    _this7.chatList = _context20.sent;

                                                    _this7.chatList.sort(function (a, b) {
                                                        return a.timestamp - b.timestamp;
                                                    });

                                                case 4:
                                                case 'end':
                                                    return _context20.stop();
                                            }
                                        }
                                    }, _callee20, _this7);
                                }));

                                return function (_x18) {
                                    return _ref17.apply(this, arguments);
                                };
                            }());

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('getContacts', function () {
                                var _ref18 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee21(id) {
                                    var chatContacts, i;
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
                                        while (1) {
                                            switch (_context21.prev = _context21.next) {
                                                case 0:
                                                    if (_this7.user) {
                                                        _context21.next = 2;
                                                        break;
                                                    }

                                                    return _context21.abrupt('return');

                                                case 2:
                                                    _context21.next = 4;
                                                    return _this7.service.getContacts(_this7.user.id);

                                                case 4:
                                                    chatContacts = _context21.sent;
                                                    i = 1;


                                                    chatContacts = chatContacts.sort(function (contact1, contact2) {
                                                        return contact1.to[0] < contact2.to[0];
                                                    });

                                                    while (i < chatContacts.length) {
                                                        if (chatContacts[i - 1].to[0] === chatContacts[i].to[0]) {
                                                            chatContacts.splice(i, 1);
                                                        } else {
                                                            ++i;
                                                        }
                                                    }

                                                    _this7.chatContacts = chatContacts.sort(function (contact1, contact2) {
                                                        return contact1.timestamp < contact2.timestamp;
                                                    });

                                                case 9:
                                                case 'end':
                                                    return _context21.stop();
                                            }
                                        }
                                    }, _callee21, _this7);
                                }));

                                return function (_x19) {
                                    return _ref18.apply(this, arguments);
                                };
                            }());

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('submitSurvey', function () {
                                var _ref19 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee22(json) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
                                        while (1) {
                                            switch (_context22.prev = _context22.next) {
                                                case 0:
                                                    if (_this7.activePres) {
                                                        _this7.service.submitSurvey(_this7.activePres.id, json);
                                                    }

                                                case 1:
                                                case 'end':
                                                    return _context22.stop();
                                            }
                                        }
                                    }, _callee22, _this7);
                                }));

                                return function (_x20) {
                                    return _ref19.apply(this, arguments);
                                };
                            }());

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('reloadWithShortCodeUrl', function (shortCodeUrl) {
                                if (!shortCodeUrl) {
                                    return;
                                }

                                try {
                                    var query = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this7.$route.query));

                                    query.shortCode = shortCodeUrl;
                                    _this7.$router.push({
                                        path: '/',
                                        query: query
                                    });
                                    _this7.$route.query.shortCode = encodeURIComponent(shortCodeUrl);
                                } catch (e) {
                                    console.log(e);
                                }
                            });

                            __WEBPACK_IMPORTED_MODULE_8__router_index__["b" /* EventBus */].$on('tweetSlide', function (tweet, callback) {
                                _this7.service.tweetSlide(tweet, _this7.user);

                                if (callback) {
                                    callback();
                                }
                            });

                        case 18:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, _this7);
        }))();
    }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__javascript_classes_utils_time__ = __webpack_require__(78);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// TODO: add time stamp



// Constants
var ANONYMOUS_IMG = '/static/img/anonymous.svg';

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        messageData: {},
        person: {},
        user: {}
    },

    computed: {
        userPicture: function userPicture() {
            return this.user && this.user.pictureUrl && this.user.pictureUrl !== '' ? this.user.pictureUrl : ANONYMOUS_IMG;
        },
        pictureUrl: function pictureUrl() {
            return this.person && this.person.pictureUrl && this.person.pictureUrl !== '' ? this.person.pictureUrl : ANONYMOUS_IMG;
        },
        getTimeStamp: function getTimeStamp() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1__javascript_classes_utils_time__["a" /* default */].formatFromNow(this.messageData.timestamp, function (key) {
                return _this.$t('str.' + key);
            });
        }
    },

    methods: {
        openCard: function openCard() {
            this.$emit('openPersonCard', this.person);
            __WEBPACK_IMPORTED_MODULE_0__router_index__["c" /* LeadBus */].$emit('recordLead', {
                type: 'attendee-profile-card',
                data: {
                    profileCardOf: this.person.id
                }
            });
        }
    }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chat_ChatListItem__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chat_ChatListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_chat_ChatListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        chatlistitem: __WEBPACK_IMPORTED_MODULE_0__components_chat_ChatListItem___default.a
    },

    props: {
        contacts: {},
        user: {},
        person: {}
    },

    computed: {
        isEmpty: function isEmpty() {
            return this.otherContacts.length === 0;
        },
        otherContacts: function otherContacts() {
            var _this = this;

            return this.contacts ? this.contacts.filter(function (contact) {
                return contact.to[0] !== _this.user.id;
            }) : [];
        }
    },

    watch: {
        contacts: function contacts() {
            this.selectedDefaultPerson();
        }
    },

    methods: {
        openPeopleTab: function openPeopleTab() {
            __WEBPACK_IMPORTED_MODULE_1__router_index__["b" /* EventBus */].$emit('openPeople');
        },
        selectedDefaultPerson: function selectedDefaultPerson() {
            if (this.otherContacts.length > 0) {
                __WEBPACK_IMPORTED_MODULE_1__router_index__["b" /* EventBus */].$emit('openChat', this.otherContacts[0].toInfo);
            }
        }
    }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__javascript_classes_utils_time__ = __webpack_require__(78);
//
//
//
//
//
//
//
//
//
//
//
//
//





var ANONYMOUS_IMG = "/static/img/anonymous.svg";
var MAX_VISIBLE_MESSAGE_LENGTH = 25;
var MAX_VISIBLE_NAME_LENGTH = 25;

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        contact: {},
        user: {},
        isSelected: Boolean
    },

    computed: {
        fullName: function fullName() {
            var fullName = this.contact.toInfo.firstName + ' ' + this.contact.toInfo.lastName;

            if (fullName.length > MAX_VISIBLE_NAME_LENGTH) {
                fullName = fullName.substring(0, MAX_VISIBLE_NAME_LENGTH) + ' . . .';
            }

            return fullName;
        },
        lastMessage: function lastMessage() {
            var message = this.contact.lastMessage;

            if (!message) {
                return '';
            }

            if (message.length > MAX_VISIBLE_MESSAGE_LENGTH) {
                message = message.substring(0, MAX_VISIBLE_MESSAGE_LENGTH) + ' . . .';
            }

            return message;
        },
        pictureUrl: function pictureUrl() {
            return this.contact && this.contact.toInfo && this.contact.toInfo.pictureUrl && this.contact.toInfo.pictureUrl !== '' ? this.contact.toInfo.pictureUrl : ANONYMOUS_IMG;
        },
        timeStamp: function timeStamp() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1__javascript_classes_utils_time__["a" /* default */].formatFromNow(this.contact.timestamp, function (key) {
                return _this.$t('str.' + key);
            });
        }
    },

    methods: {
        openChat: function openChat() {
            __WEBPACK_IMPORTED_MODULE_0__router_index__["b" /* EventBus */].$emit('openChat', this.contact.toInfo);

            if (window.screen.width < 600) {
                // Only close if screen is small to show both
                __WEBPACK_IMPORTED_MODULE_0__router_index__["b" /* EventBus */].$emit('closeHistory');
            }
        }
    }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chat_ChatBox__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chat_ChatBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_chat_ChatBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chat_ChatContacts__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chat_ChatContacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_chat_ChatContacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PersonCard__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PersonCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PersonCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__javascript_classes_utils_navigator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var POLL_TIMEOUT = 30000;

/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        chatbox: __WEBPACK_IMPORTED_MODULE_0__components_chat_ChatBox___default.a,
        chatContacts: __WEBPACK_IMPORTED_MODULE_1__components_chat_ChatContacts___default.a,
        personcard: __WEBPACK_IMPORTED_MODULE_2__components_PersonCard___default.a
    },

    props: {
        presentation: {},
        peopleMap: {},
        chatList: {},
        contacts: {},
        user: {},
        person: {}
    },

    data: function data() {
        return {
            chatText: '',
            viewPerson: undefined,
            historyOpen: window.screen.width > 450, // By default only open if there is enough space to show both
            pollTimeout: undefined,
            messagesIEHackStyle: {},
            messagesSending: [],
            lastMessagesSentCount: 0
        };
    },


    computed: {
        isEmpty: function isEmpty() {
            return !this.chatList || !this.chatList.length;
        },
        placeholder: function placeholder() {
            if (this.person === undefined) {
                return this.$t('str.SelectAContactToChatWith');
            }

            return this.$t('str.ChatWith', {
                firstname: this.person.firstName,
                lastname: this.person.lastName
            });
        },
        backgroundMessage: function backgroundMessage() {
            return 'background-message ' + (this.historyOpen ? 'small' : '');
        },
        chatSubmit: function chatSubmit() {
            return 'chatSubmit ' + (this.historyOpen ? 'small' : '');
        }
    },

    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_4__router_index__["b" /* EventBus */].$on('closeHistory', function () {
            _this.historyOpen = false;
        });

        __WEBPACK_IMPORTED_MODULE_4__router_index__["b" /* EventBus */].$emit('getPeople', this.presentation.id);
        __WEBPACK_IMPORTED_MODULE_4__router_index__["b" /* EventBus */].$emit('getContacts', this.user.id);

        this.showLastMessages();

        // Poll new messages
        this.pollTimeout = setInterval(function () {
            if (_this.person) {
                __WEBPACK_IMPORTED_MODULE_4__router_index__["b" /* EventBus */].$emit('getMessages', _this.person.id);
            }
        }, POLL_TIMEOUT);

        // IE hack
        if (__WEBPACK_IMPORTED_MODULE_3__javascript_classes_utils_navigator__["a" /* default */].isIE()) {
            var updateHeight = function updateHeight() {
                _this.messagesIEHackStyle = {
                    height: parseInt(_this.$el.offsetHeight) - 60 + "px",
                    "overflow-y": "scroll"
                };
            };

            document.body.addEventListener("mselementresize", function () {
                updateHeight();
            });
            updateHeight();
        }
    },
    beforeDestroy: function beforeDestroy() {
        if (this.pollTimeout) {
            clearInterval(this.pollTimeout);
        }
    },


    watch: {
        chatList: function chatList(list) {
            this.showLastMessages();

            // Remove the sending messages as we received confirmation
            // from the server that they were received.
            if (!list) {
                return;
            }

            var newMessagesSentCount = 0;

            for (var i = 0; i < list.length; ++i) {
                if (list[i].from === this.user.id) {
                    ++newMessagesSentCount;
                }
            };

            this.messagesSending.splice(0, newMessagesSentCount - this.lastMessagesSentCount);
            this.lastMessagesSentCount = newMessagesSentCount;
        }
    },

    methods: {
        toggleTray: function toggleTray() {
            if (!this.user) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_4__router_index__["b" /* EventBus */].$emit('getContacts', this.user.id);
            this.historyOpen = !this.historyOpen;
        },
        submitText: function submitText() {
            var _this2 = this;

            if (!this.chatText || this.chatText === '' || !this.person || !this.user) {
                return;
            }

            var message = this.chatText.trim();

            this.messagesSending.push({
                from: this.user.id,
                message: message,
                timestamp: new Date()
            });

            __WEBPACK_IMPORTED_MODULE_4__router_index__["b" /* EventBus */].$emit('postMessage', message, this.person.id);
            this.chatText = '';

            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_4__router_index__["b" /* EventBus */].$emit('getMessages', _this2.person.id);
            }, 100);

            __WEBPACK_IMPORTED_MODULE_4__router_index__["b" /* EventBus */].$emit('getContacts', this.user.id);
            __WEBPACK_IMPORTED_MODULE_4__router_index__["c" /* LeadBus */].$emit('recordLead', {
                type: 'SendMessage',
                data: {
                    messageSentTo: this.person.id
                }
            });
        },
        getPerson: function getPerson(personId) {
            return this.peopleMap && this.peopleMap.get ? this.peopleMap.get(personId) : {};
        },
        openPersonCard: function openPersonCard(person) {
            this.viewPerson = person;
        },
        personCardClosed: function personCardClosed() {
            this.viewPerson = undefined;
        },
        showLastMessages: function showLastMessages() {
            var _this3 = this;

            if (this.$refs.chat === undefined) {
                return;
            }

            setTimeout(function () {
                _this3.$refs.chat.scrollTop = _this3.$refs.chat.scrollHeight;
            }, 100);
        }
    }
});

// TODO: change sizing according to media

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		service: Object
	},

	data: function data() {
		return {
			email: '',
			password: '',
			show: false,
			shouldRegister: false,
			errorMessage: undefined,
			isLoggingIn: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		setTimeout(function () {
			_this.show = true;
		}, 1);
	},


	methods: {
		login: function login() {
			var _this2 = this;

			if (!this.email || !this.password || this.email.trim() === '' || this.password.trim() === '') {
				return;
			}

			this.errorMessage = undefined;
			this.isLoggingIn = true;

			this.service.login('dialogloop', window.location.href, this.email, this.password).then(function () {
				_this2.close();
			}).catch(function (err) {
				_this2.isLoggingIn = false;
				console.log(err);
				_this2.errorMessage = _this2.$t('str.LoginFailed');
			});
		},
		close: function close() {
			this.show = false;
		},
		afterHidden: function afterHidden() {
			this.onAnimationEnd();
			this.$emit('close');

			if (this.shouldRegister) {
				this.$emit('register');
			}
		},
		register: function register() {
			this.shouldRegister = true;
			this.close();
		},
		stopClickPropagation: function stopClickPropagation() {
			if (event && event.stopPropagation) {
				event.stopPropagation();
			}
		},
		onAnimationStart: function onAnimationStart() {
			document.body.style.overflowY = 'hidden';
			this.$el.style.overflowY = 'hidden';
		},
		onAnimationEnd: function onAnimationEnd() {
			document.body.style.overflowY = 'auto';
			this.$el.style.overflowY = 'auto';
		}
	}
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_login_Register__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_login_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_login_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_login_DLLogin__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_login_DLLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_login_DLLogin__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

    components: {
        register: __WEBPACK_IMPORTED_MODULE_0__components_login_Register___default.a,
        'dl-login': __WEBPACK_IMPORTED_MODULE_1__components_login_DLLogin___default.a
    },

    props: {
        service: Object
    },

    data: function data() {
        return {
            modal: undefined
        };
    },


    methods: {
        register: function register() {
            this.modal = 'register';
        },
        dlLogin: function dlLogin() {
            this.modal = 'dlLogin';
        },
        isModal: function isModal(type) {
            return type === this.modal;
        },
        closeModal: function closeModal() {
            this.modal = undefined;
        },
        login: function login(socialNetwork) {
            this.service.login(socialNetwork, window.location.href);
        }
    }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var CAPTCHA_SIGKEY = '6LfsJyETAAAAAL89cTI6B4ka56Yr-HQsb_WPv6iY';
var regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		service: Object
	},

	data: function data() {
		return {
			firstname: '',
			lastname: '',
			email: '',
			password1: '',
			password2: '',
			show: false,
			rcaptSigKey: CAPTCHA_SIGKEY,
			rcaptId: 0,
			errorMessage: undefined,
			invalidFields: 0,
			keys: {
				firstname: 0x01,
				lastname: 0x02,
				email: 0x04,
				password1: 0x10,
				password2: 0x20,
				captcha: 0x40
			},
			isRegistering: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		setTimeout(function () {
			_this.show = true;
		}, 1);
	},


	methods: {
		signup: function signup() {
			var _this2 = this;

			if (!window.grecaptcha) {
				console.error("Undefined captcha");
				return;
			}

			window.g_recaptcha_response = window.grecaptcha.getResponse(this.rcapt_id);

			this.invalidFields = 0;
			this.errorMessage = undefined;

			if (!window.g_recaptcha_response || window.g_recaptcha_response.length === 0) {
				this.invalidFields |= this.keys.captcha;
			}

			this.invalidFields |= this.firstname.trim() === '' ? this.keys.firstname : 0;
			this.invalidFields |= this.lastname.trim() === '' ? this.keys.lastname : 0;
			this.invalidFields |= this.password1.trim() === '' ? this.keys.password1 : 0;
			this.invalidFields |= this.password2.trim() === '' ? this.keys.password2 : 0;
			this.invalidFields |= regEmail.test(this.email) ? 0 : this.keys.email;

			if (this.password1 !== this.password2) {
				this.invalidFields |= this.keys.password1;
				this.invalidFields |= this.keys.password2;
			}

			if (this.invalidFields && this.invalidFields === this.keys.password1 | this.keys.password2 && this.password1.trim() !== '') {
				this.errorMessage = this.$t('str.FailRegisterPassordMisMatch');
				return;
			}

			if (this.invalidFields === this.keys.email) {
				this.errorMessage = this.$t('str.FailRegisterInvalidEmail');
				return;
			}

			if (this.invalidFields) {
				this.errorMessage = this.$t('str.FailRegisterMissingData');
				return;
			}

			// Save it in case the user changes it during registration
			var email = this.email;
			var password = this.password1;

			this.isRegistering = true;

			this.service.registerUser(this.firstname, this.lastname, email, password).then(function () {
				_this2.service.login('dialogloop', window.location.href, email, password).then(function () {
					_this2.close();
				}).catch(function (err) {
					_this2.isRegistering = false;
					console.log(err);
					_this2.errorMessage = _this2.$t('str.LoginFailed');
				});
			}).catch(function (err) {
				_this2.isRegistering = false;
				console.log(err);
				_this2.errorMessage = _this2.$t('str.FailRegisterUnknownReason');
			});
		},
		reset: function reset() {
			this.firstname = '';
			this.lastname = '';
			this.password1 = '';
			this.password2 = '';
			this.email = '';
		},
		close: function close() {
			this.show = false;
		},
		afterHidden: function afterHidden() {
			this.onAnimationEnd();
			this.$emit('close');
		},
		stopClickPropagation: function stopClickPropagation() {
			if (event && event.stopPropagation) {
				event.stopPropagation();
			}
		},
		onAnimationStart: function onAnimationStart() {
			document.body.style.overflowY = 'hidden';
			this.$el.style.overflowY = 'hidden';
		},
		onAnimationEnd: function onAnimationEnd() {
			document.body.style.overflowY = 'default';
			this.$el.style.overflowY = 'auto';

			if (!this.show) {
				return;
			}

			if (window.grecaptcha) {
				this.rcaptId = window.grecaptcha.render(this.$el.querySelector('[name="captcha"]'), {
					sitekey: this.rcaptSigKey
				});
			}
		}
	}
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__javascript_classes_utils_time__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__javascript_classes_utils_identifier__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__javascript_classes_utils_language__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__javascript_classes_utils_navigator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_question_QuestionReplyBox__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_question_QuestionReplyBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_question_QuestionReplyBox__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// Constants
var ANONYMOUS_IMG = '/static/img/anonymous.svg';

/* harmony default export */ __webpack_exports__["default"] = ({

    components: {
        questionreplybox: __WEBPACK_IMPORTED_MODULE_7__components_question_QuestionReplyBox___default.a
    },

    props: {
        question: {},
        peopleMap: {},
        person: {},
        user: {}
    },

    data: function data() {
        return {
            showReplies: false,
            replyText: ''
        };
    },


    computed: {
        pictureUrl: function pictureUrl() {
            return this.person && this.person.pictureUrl && this.person.pictureUrl !== '' ? this.person.pictureUrl : ANONYMOUS_IMG;
        },
        getTimestamp: function getTimestamp() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3__javascript_classes_utils_time__["a" /* default */].formatFromNow(this.question.timestamp, function (key) {
                return _this.$t('str.' + key);
            });
        },
        isPlurial: function isPlurial() {
            return __WEBPACK_IMPORTED_MODULE_5__javascript_classes_utils_language__["a" /* default */].isPlural(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.question.props).length) ? 2 : 1;
        }
    },

    methods: {
        likeQuestion: function likeQuestion() {
            if (this.question && this.question.voted === false) {
                __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit('likeQuestion', this.question);
            }
        },
        getPerson: function getPerson(index) {
            return index !== undefined && this.peopleMap && this.peopleMap.get ? this.peopleMap.get(this.question.replies[index].replyBy) : {};
        },
        replyToQuestion: function replyToQuestion() {
            var reply = {
                comment: this.replyText.trim()
            };

            if (reply.comment !== '') {
                reply.questionId = this.question.id;
                __WEBPACK_IMPORTED_MODULE_2__router_index__["b" /* EventBus */].$emit('postQuestionProps', reply);
                this.replyText = '';
            }
        },
        viewReplies: function viewReplies() {
            var _this2 = this;

            this.showReplies = true;

            setTimeout(function () {
                _this2.$refs.replyInput.focus();
            }, 50);
        },
        toggleReplies: function toggleReplies() {
            var _this3 = this;

            this.showReplies = !this.showReplies;

            if (this.showReplies) {
                var offsetHeight = this.$el.offsetTop; // Cache the value before the div gets expanded

                setTimeout(function () {
                    _this3.$emit("showChildAtPosition", offsetHeight);

                    if (!__WEBPACK_IMPORTED_MODULE_6__javascript_classes_utils_navigator__["a" /* default */].isMobile()) {
                        _this3.$refs.replyInput.focus();
                    }
                }, 50);
            }
        },
        openPersonCard: function openPersonCard(person) {
            if (person) {
                this.$emit('openPersonCard', person);
            } else {
                this.$emit('openPersonCard', this.person);
            }

            __WEBPACK_IMPORTED_MODULE_2__router_index__["c" /* LeadBus */].$emit('recordLead', {
                type: 'attendee-profile-card',
                data: {
                    profileCardOf: this.person.id
                }
            });
        },
        replyFocus: function replyFocus() {
            if (typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1) {
                this.$refs.replyInput.scrollIntoView();
            }
        }
    }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        reply: {},
        person: {}
    },

    computed: {
        pictureUrl: function pictureUrl() {
            return this.person && this.person.pictureUrl && this.person.pictureUrl !== '' ? this.person.pictureUrl : '/static/img/anonymous.svg';
        }
    },

    methods: {
        openPersonCard: function openPersonCard() {
            this.$emit('openPersonCard', this.person);
            __WEBPACK_IMPORTED_MODULE_0__router_index__["c" /* LeadBus */].$emit('recordLead', {
                type: 'attendee-profile-card',
                data: {
                    profileCardOf: this.person.id
                }
            });
        }
    }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_question_QuestionBox__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_question_QuestionBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_question_QuestionBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PersonCard__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PersonCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PersonCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        questionbox: __WEBPACK_IMPORTED_MODULE_1__components_question_QuestionBox___default.a,
        personcard: __WEBPACK_IMPORTED_MODULE_2__components_PersonCard___default.a,
        spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default.a
    },

    props: {
        peopleMap: {},
        questions: {},
        user: {}
    },

    data: function data() {
        return {
            questionText: '',
            viewPerson: undefined,
            lastQuestionsCount: 0
        };
    },


    computed: {
        isEmpty: function isEmpty() {
            return this.questions !== undefined && !this.questions.length;
        },
        filteredQuestions: function filteredQuestions() {
            if (!this.questions) {
                return [];
            }

            var filtered = [];

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.questions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var questionContainer = _step.value;

                    if (questionContainer.question && questionContainer.question.length > 0) {
                        filtered.push(questionContainer);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return filtered;
        }
    },

    watch: {
        questions: function questions() {
            if (this.lastQuestionsCount !== this.questions.length) {
                this.showLastQuestions();
            }
        }
    },

    mounted: function mounted() {
        this.showLastQuestions();
    },


    methods: {
        submitQuestion: function submitQuestion() {
            if (this.questionText === '') {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_3__router_index__["b" /* EventBus */].$emit('postQuestion', this.questionText.trim());
            this.questionText = '';
        },
        getPerson: function getPerson(index) {
            return this.peopleMap.get ? this.peopleMap.get(this.questions[index].orignatorId) : {};
        },
        openPersonCard: function openPersonCard(person) {
            this.viewPerson = person;
        },
        personCardClosed: function personCardClosed() {
            this.viewPerson = undefined;
        },
        showChildAtPosition: function showChildAtPosition(offsetHeight) {
            if (offsetHeight !== undefined) {
                this.$refs.questions.scrollTop = offsetHeight;
            }
        },
        showLastQuestions: function showLastQuestions() {
            var _this = this;

            if (this.$refs.questions === undefined || !this.questions) {
                return;
            }

            this.lastQuestionsCount = this.questions.length;

            setTimeout(function () {
                _this.$refs.questions.scrollTop = _this.$refs.questions.scrollHeight;
            }, 100);
        }
    }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var DocXML = function () {
    function DocXML() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DocXML);

        this.BaseDoc = document.implementation.createDocument(null, null, null);
        this.WordDoc = this.BaseDoc.createElement('w:wordDocument');
        this.BaseDoc.appendChild(this.WordDoc);
        this.WordDoc.setAttribute('xmlns:w', 'http://schemas.openxmlformats.org/wordprocessingml/2006/main');
        this.WordDoc.setAttribute('xmlns:v', 'urn:schemas-microsoft-com:vml');
        this.WordDoc.setAttribute('xmlns:r', 'http://schemas.openxmlformats.org/officeDocument/2006/relationships');
        this.WordBody = this.BaseDoc.createElement('w:body');
        this.WordDoc.appendChild(this.WordBody);
        this.NumShapes = 1;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DocXML, [{
        key: 'addText',
        value: function addText(text) {
            var p = this.BaseDoc.createElement('w:p');
            this.WordBody.appendChild(p);
            var r = this.BaseDoc.createElement('w:r');
            p.appendChild(r);
            var t = this.BaseDoc.createElement('w:t');
            r.appendChild(t);
            var textNode = this.BaseDoc.createTextNode(text);
            t.appendChild(textNode);
        }
    }, {
        key: 'addPageBreak',
        value: function addPageBreak() {
            var p = this.BaseDoc.createElement('w:p');
            this.WordBody.appendChild(p);
            var r = this.BaseDoc.createElement('w:r');
            p.appendChild(r);
            var br = this.BaseDoc.createElement('w:br');
            br.setAttribute('w:type', 'page');
            r.appendChild(br);
        }
    }, {
        key: 'addImage',
        value: function addImage(width, height) {
            var lwidth = width;
            var lheight = height;
            if (width > 576) {
                lwidth = 576;
                lheight = height / width * lwidth;
            }
            var p = this.BaseDoc.createElement('w:p');
            this.WordBody.appendChild(p);
            var r = this.BaseDoc.createElement('w:r');
            p.appendChild(r);
            var pict = this.BaseDoc.createElement('w:pict');
            r.appendChild(pict);
            var shape = this.BaseDoc.createElement('v:shape');
            pict.appendChild(shape);
            shape.setAttribute('id', 'myShape' + this.NumShapes);
            shape.setAttribute('type', '#_x0000_t75');
            shape.setAttribute('style', 'width:' + lwidth + '; height:' + lheight + ';');
            var imgdata = this.BaseDoc.createElement('v:imagedata');
            shape.appendChild(imgdata);
            imgdata.setAttribute('r:id', 'rId' + this.NumShapes);
            this.NumShapes = this.NumShapes + 1;
        }
    }, {
        key: 'getString',
        value: function getString() {
            var xmlText = new XMLSerializer().serializeToString(this.BaseDoc);
            xmlText = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' + xmlText;
            return xmlText;
        }
    }]);

    return DocXML;
}();

/* harmony default export */ __webpack_exports__["a"] = (DocXML);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jszip__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_saver__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rels__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DocXML__ = __webpack_require__(245);







var Document = function () {
    function Document() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Document);

        this.NumImg = 1;
        this.zip = new __WEBPACK_IMPORTED_MODULE_2_jszip___default.a();
        this.rels = new __WEBPACK_IMPORTED_MODULE_4__rels__["a" /* default */]();
        this.docXML = new __WEBPACK_IMPORTED_MODULE_5__DocXML__["a" /* default */]();
        this.filesLeft = 0;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Document, [{
        key: 'addImage',
        value: function addImage(imgURL, text) {
            var _this = this;

            this.filesLeft++;
            this.rels.addImage('image' + this.NumImg + '.jpg');
            var currentNum = this.NumImg;
            this.NumImg = this.NumImg + 1;
            var img = new Image();
            img.crossOrigin = 'app.dialogloop.com';
            img.onload = function () {
                var canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                _this.docXML.addImage(img.width, img.height);
                _this.docXML.addText(text);
                _this.docXML.addPageBreak();
                var ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL('image/png');
                _this.zip.file('image' + currentNum + '.jpg', dataURL.replace(/^data:image\/(png|jpg);base64,/, ''), { base64: true });
                _this.filesLeft--;
                if (_this.filesLeft === 0) {
                    _this.zip.folder('_rels').file('document.xml.rels', _this.rels.getString());
                    _this.zip.folder('_rels').file('.rels', '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n                <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">\n                  <Relationship Id="MyRelationship" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="document.xml"/>\n                </Relationships>');
                    _this.zip.file('document.xml', _this.docXML.getString());
                    _this.zip.file('[Content_Types].xml', '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n                <Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">\n                  <Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>\n                  <Override PartName="/document.xml" ContentType="application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml"/>\n                  <Default Extension="jpg" ContentType="image/jpeg"/>\n                </Types>');
                    _this.zip.generateAsync({ type: 'blob' }).then(function (content) {
                        // Force down of the Zip file
                        __WEBPACK_IMPORTED_MODULE_3_file_saver___default.a.saveAs(content, 'DialogLoop-Slides.docx');
                    });
                }
            };
            img.src = imgURL + '?timestamp=' + Date.now() + '&random=' + Math.random() * 10000000000000000000000;
        }
    }, {
        key: 'downloadDocument',
        value: function downloadDocument() {
            setTimeout(this.callback, 6000);
        }
    }, {
        key: 'callback',
        value: function callback() {
            if (this.filesLeft !== 0) {
                setTimeout(this.callback, 1000);
            } else {
                this.zip.folder('_rels').file('.rels', this.rels.getString());
                this.zip.generateAsync({ type: 'blob' }).then(function (content) {
                    // Force down of the Zip file
                    __WEBPACK_IMPORTED_MODULE_3_file_saver___default.a.saveAs(content, 'archive.zip');
                });
            }
        }
    }]);

    return Document;
}();

/* harmony default export */ __webpack_exports__["a"] = (Document);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Rels = function () {
    function Rels() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Rels);

        this.BaseDoc = document.implementation.createDocument(null, null, null);
        this.Relationships = this.BaseDoc.createElement('Relationships');
        this.BaseDoc.appendChild(this.Relationships);
        this.Relationships.setAttribute('xmlns', 'http://schemas.openxmlformats.org/package/2006/relationships');
        this.rIdNum = 1;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Rels, [{
        key: 'addImage',
        value: function addImage(imgPath) {
            var Relationship = this.BaseDoc.createElement('Relationship');
            this.Relationships.appendChild(Relationship);
            Relationship.setAttribute('Type', 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/image');
            Relationship.setAttribute('Id', 'rId' + this.rIdNum);
            Relationship.setAttribute('Target', imgPath);
            this.rIdNum = this.rIdNum + 1;
        }
    }, {
        key: 'getString',
        value: function getString() {
            var xmlText = new XMLSerializer().serializeToString(this.BaseDoc);
            xmlText = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' + xmlText;
            return xmlText;
        }
    }]);

    return Rels;
}();

/* harmony default export */ __webpack_exports__["a"] = (Rels);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);





var LanguageUtils = function () {
    function LanguageUtils() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LanguageUtils);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LanguageUtils, null, [{
        key: 'isPlural',
        value: function isPlural(count) {
            if (count === 1) {
                return 1;
            }

            if (count > 1) {
                return 2;
            }

            // Count = 0
            // French is singular
            if (Vue.config.lang.indexOf('fr') === 0) {
                return 1;
            }

            // Default return plurial
            return 2;
        }
    }]);

    return LanguageUtils;
}();

/* harmony default export */ __webpack_exports__["a"] = (LanguageUtils);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

function initVue() {
    new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
        el: '#app',
        router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
        template: '<App/>',
        components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
    });
}

// TODO: Move this in a shared lib (It should actually already be)
var Url = {
    getValueParam: function getValueParam(url, key, defaultValue) {
        var regex = new RegExp('[?&#]' + key.replace(/[[\]]/g, '\\$&') + '(=([^&#]*)|&|#|$)');
        var results = regex.exec(url);

        if (results && results.length > 1 && results[2]) {
            return decodeURIComponent(results[2].replace(/\+/g, ''));
        }

        return defaultValue;
    }
};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.lang = Url.getValueParam(window.location.href, 'lang', window.navigator.language);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.fallbackLang = 'en-US';

var retrieveLocale = function retrieveLocale(locale) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var request = new XMLHttpRequest();

        request.onreadystatechange = function () {
            if (this.readyState !== 4) {
                return;
            }

            if (this.status === 200) {
                __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].locale(locale, { str: JSON.parse(this.responseText) });
                resolve();
            } else {
                console.log('Unable to retrieve the locale: ' + locale);
                reject();
            }
        };

        request.open('GET', 'locales/' + locale + '.json', true);
        request.send();
    });
};

retrieveLocale(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.lang).then(initVue).catch(function () {
    if (__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.fallbackLang === __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.lang) {
        initVue();
    } else {
        retrieveLocale(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.fallbackLang).then(initVue).catch(initVue);
    }
});

/***/ }),
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/attach-file.svg";

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chat_selected.svg";

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chat_unselected.svg";

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dialogloop-signin-button.svg";

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/download-red.svg";

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/enter_white.svg";

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/facebook-button.svg";

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/facebook.svg";

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fullscreen.svg";

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/like-red.svg";

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/like.svg";

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/link-red.svg";

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/link.svg";

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/linkedin-button.svg";

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/linkedin.svg";

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-dialogloop-with-title.svg";

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/notes_unselected.svg";

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_unselected.svg";

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/person_card_chat_icon.svg";

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/plus.svg";

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/poll.svg";

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qr_code.png";

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/questions_unselected.svg";

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/refresh.svg";

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sessions_unselected.svg";

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/share.svg";

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/speaker-notes.svg";

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/twitter-bird-only-red.svg";

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/twitter-bird-only.svg";

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/twitter-button.svg";

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/twitter.svg";

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/unchecked.svg";

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/x.svg";

/***/ }),
/* 423 */,
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(326)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(477),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(337)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(490),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(320)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(471),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(481),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(470),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(483),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(491),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(324)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(475),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(328)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(479),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(327)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(478),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(332)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(484),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(331)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(482),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(458),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(322)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(473),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(314)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(465),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(468),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(316)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(467),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(488),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(461),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(334)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(487),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(474),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(312)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(463),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(321)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(472),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(309)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(460),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(315)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(466),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(469),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(329)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(480),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(456),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(333)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(485),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(336)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(489),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(313)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(464),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(486),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dl-register-container",
    on: {
      "click": _vm.close
    }
  }, [_c('transition', {
    attrs: {
      "name": "dl-register-toggle"
    },
    on: {
      "after-leave": _vm.afterHidden,
      "before-enter": _vm.onAnimationStart,
      "before-leave": _vm.onAnimationStart,
      "after-enter": _vm.onAnimationEnd
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "dl-register",
    on: {
      "click": function($event) {
        _vm.stopClickPropagation($event)
      }
    }
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('str.CreateAccount')))]), _vm._v(" "), _c('div', {
    staticClass: "line-container"
  }, [_c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('str.FirstName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }],
    class: _vm.invalidFields & _vm.keys.firstname ? 'invalid' : '',
    attrs: {
      "placeholder": _vm.$t('str.YourFirstName'),
      "disabled": _vm.isRegistering
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('str.LastName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastname),
      expression: "lastname"
    }],
    class: _vm.invalidFields & _vm.keys.lastname ? 'invalid' : '',
    attrs: {
      "placeholder": _vm.$t('str.YourLastName'),
      "disabled": _vm.isRegistering
    },
    domProps: {
      "value": (_vm.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('str.EmailAddress')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: _vm.invalidFields & _vm.keys.email ? 'invalid' : '',
    attrs: {
      "placeholder": _vm.$t('str.Email'),
      "disabled": _vm.isRegistering
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line-container"
  }, [_c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('str.Password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    class: _vm.invalidFields & _vm.keys.password1 ? 'invalid' : '',
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('str.Password'),
      "disabled": _vm.isRegistering
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('str.ReConfirmPassword')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    class: _vm.invalidFields & _vm.keys.password2 ? 'invalid' : '',
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('str.ReConfirmPassword'),
      "disabled": _vm.isRegistering
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('str.Captcha')))]), _vm._v(" "), _c('div', [_c('div', {
    class: ['g-recaptcha', _vm.invalidFields & _vm.keys.captcha ? 'invalid' : ''],
    attrs: {
      "name": "captcha",
      "data-sitekey": _vm.rcaptSigKey
    }
  })])]), _vm._v(" "), (!!_vm.errorMessage) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "footer"
  }, [_c('button', {
    staticClass: "bt-reset",
    attrs: {
      "disabled": _vm.isRegistering
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Reset')))]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.isRegistering
    },
    on: {
      "click": _vm.signup
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Signup')))])])]), _vm._v(" "), _c('a', {
    staticClass: "close-button",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resource-panel"
  }, [_c('div', {
    staticClass: "resource-list"
  }, [(!_vm.isSurveysEmpty) ? _c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "resource-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(410)
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('str.Surveys')) + "\n            ")]), _vm._v(" "), _c('div', [_c('ul', [_c('li', {
    staticClass: "resources"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(421)
    }
  }), _vm._v(" "), _vm._l((_vm.surveys), function(survey, index) {
    return _c('a', {
      key: index,
      staticClass: "survey item",
      on: {
        "click": function($event) {
          _vm.launchSurvey(survey)
        }
      }
    }, [_vm._v(_vm._s(survey.title))])
  }), _vm._v(" "), _c('p', {
    staticClass: "resource-info"
  }, [_vm._v("(" + _vm._s(_vm.$t('str.TakeTheSurvey')) + ")")])], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.showFiles) ? _c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "resource-header"
  }, [_c('img', {
    staticClass: "file",
    attrs: {
      "src": __webpack_require__(390)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('str.Files')))])]), _vm._v(" "), _c('div', [_c('ul', _vm._l((_vm.presentation.props.Resources[_vm.slideNum].Files), function(file, index) {
    return _c('li', {
      key: index,
      staticClass: "resources"
    }, [_c('div', [_c('img', {
      attrs: {
        "src": __webpack_require__(394)
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.openFile(file.label)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(file.label) + "\n                                "), _c('p', {
      staticClass: "resource-info"
    }, [_vm._v("(" + _vm._s(file.size / 1000) + " " + _vm._s(_vm.$t('str.KB')) + ")")])])])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.showLinks) ? _c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "resource-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(402)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('str.Links')))])]), _vm._v(" "), _c('div', [_c('ul', _vm._l((_vm.presentation.props.Resources[_vm.slideNum].Links), function(link, index) {
    return _c('li', {
      key: index,
      staticClass: "resources"
    }, [_c('img', {
      staticClass: "link",
      attrs: {
        "src": __webpack_require__(401)
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "item",
      attrs: {
        "href": link.data,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          _vm.recordLead('link', link.label, link.data)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(link.label) + "\n                        ")])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.showNotes) ? _c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "resource-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(416)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('str.SpeakerNotes')))])]), _vm._v(" "), _c('div', [_c('ul', _vm._l((_vm.presentation.props.Resources[_vm.slideNum].Notes), function(note, index) {
    return _c('li', {
      key: index,
      staticClass: "resources"
    }, [_c('div', {
      staticClass: "notes-display"
    }, [_c('a', {
      staticClass: "note-label"
    }, [_vm._v(_vm._s(note.label))]), _vm._v(" "), _c('p', {
      staticClass: "note-content"
    }, [_vm._v(_vm._s(note.data))])])])
  }))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "resource-panel-close"
  }, [_c('a', {
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  })
},staticRenderFns: []}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: ['contact-list', _vm.isSelected ? 'selected' : ''],
    on: {
      "click": _vm.openChat
    }
  }, [_c('img', {
    staticClass: "contact-img",
    attrs: {
      "src": _vm.pictureUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-box"
  }, [_c('div', {
    staticClass: "contact-content"
  }, [_c('div', {
    staticClass: "message-timestamp"
  }, [_vm._v(_vm._s(_vm.timeStamp))]), _vm._v(" "), _c('div', {
    staticClass: "contact-name"
  }, [_vm._v(_vm._s(_vm.fullName))]), _vm._v(" "), _c('div', {
    staticClass: "last-message"
  }, [_vm._v(_vm._s(_vm.lastMessage))])])])])
},staticRenderFns: []}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tweet-card-container"
  }, [_c('div', {
    staticClass: "tweet-card"
  }, [_c('div', [_c('div', {
    staticClass: "tweet-card-header"
  }, [_c('div', [_c('h5', [_vm._v(_vm._s(_vm.$t('str.ComposeNewTweet')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-times",
    on: {
      "click": _vm.close
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tweet-card-slide"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.slideUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tweet-card-comment"
  }, [_c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    attrs: {
      "name": "user-text",
      "maxlength": "280",
      "placeholder": _vm.$t('str.WhatIsHappening')
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tweet-card-footer"
  }, [_c('div', [_c('label', [_vm._v(_vm._s(_vm.message.length) + " / 280")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.tweetSlide
    }
  }, [_vm._v(_vm._s(_vm.$t('str.TWEET')))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "person-card"
  }, [_c('a', {
    staticClass: "close-button",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), (_vm.attendee.pictureUrl) ? _c('img', {
    staticClass: "card-image",
    attrs: {
      "src": _vm.attendee.pictureUrl,
      "onerror": "this.onerror = \"null\"; this.src = \"/static/img/anonymous.svg\""
    }
  }) : _c('img', {
    staticClass: "card-image",
    attrs: {
      "src": __webpack_require__(34)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.attendee.firstName) + " " + _vm._s(_vm.attendee.lastName))]), _vm._v(" "), _c('div', {
    staticClass: "bottom-content"
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.attendee.headline))]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.attendee.location))]), _vm._v(" "), _c('div', {
    staticClass: "social-icons"
  }, [_vm._l((this.attendee.social), function(network, index) {
    return _c('div', {
      key: index,
      staticClass: "inline-list"
    }, [_c('socialIcons', {
      attrs: {
        "attendee": _vm.attendee,
        "network": network
      }
    })], 1)
  }), _vm._v(" "), (_vm.attendee.id !== _vm.user.id) ? _c('a', {
    staticClass: "chat-icon",
    on: {
      "click": function($event) {
        _vm.openChat(_vm.attendee)
      }
    }
  }, [_c('img', {
    staticClass: "dl-logo",
    attrs: {
      "src": __webpack_require__(408)
    }
  })]) : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "chat-display"
  }, [(_vm.user.id === _vm.messageData.from) ? _c('div', {
    staticClass: "box right"
  }, [_c('div', {
    staticClass: "msg-content user-msg"
  }, [_c('div', {
    staticClass: "dialog-arrow-user"
  }), _vm._v(" "), _c('div', {
    staticClass: "timestamp left"
  }, [_vm._v(_vm._s(_vm.getTimeStamp))]), _vm._v(" "), _c('div', {
    staticClass: "sender-name user",
    on: {
      "click": _vm.openCard
    }
  }, [_vm._v(_vm._s(_vm.user.firstName))]), _vm._v(" "), _c('div', {
    staticClass: "msg-text black"
  }, [_vm._v(_vm._s(_vm.messageData.message))])])]) : _c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "picture-icon",
    attrs: {
      "src": _vm.pictureUrl
    },
    on: {
      "click": _vm.openCard
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg-content contact-msg"
  }, [_c('div', {
    staticClass: "timestamp right"
  }, [_vm._v(_vm._s(_vm.getTimeStamp))]), _vm._v(" "), (_vm.person) ? _c('div', {
    staticClass: "sender-name black",
    on: {
      "click": _vm.openCard
    }
  }, [_vm._v(_vm._s(_vm.person.firstName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "msg-text"
  }, [_vm._v(_vm._s(_vm.messageData.message))]), _vm._v(" "), _c('div', {
    staticClass: "dialog-arrow"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "questionTray"
  }, [_c('div', {
    ref: "questions",
    staticClass: "questions"
  }, [_c('ul', {
    staticClass: "questionList"
  }, _vm._l((_vm.filteredQuestions), function(question, index) {
    return _c('questionbox', {
      key: index,
      attrs: {
        "question": question,
        "person": _vm.getPerson(index),
        "peopleMap": _vm.peopleMap,
        "user": _vm.user
      },
      on: {
        "openPersonCard": function($event) {
          _vm.openPersonCard($event)
        },
        "showChildAtPosition": _vm.showChildAtPosition
      }
    })
  })), _vm._v(" "), (_vm.isEmpty) ? _c('div', {
    staticClass: "background-message"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('str.NoQuestionsAsked')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "questionSubmit"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questionText),
      expression: "questionText"
    }],
    staticClass: "questionText",
    attrs: {
      "maxlength": "500",
      "placeholder": _vm.$t('str.EnterYourQuestionHere')
    },
    domProps: {
      "value": (_vm.questionText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitQuestion($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.questionText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "chars"
  }, [_vm._v(" " + _vm._s(_vm.questionText.length) + " / 500 ")]), _vm._v(" "), _c('img', {
    staticClass: "submitButton",
    attrs: {
      "src": __webpack_require__(395)
    },
    on: {
      "click": _vm.submitQuestion
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "question-text-arrow"
  }), _vm._v(" "), (this.viewPerson) ? _c('personcard', {
    attrs: {
      "attendee": this.viewPerson,
      "user": _vm.user
    },
    on: {
      "cardClosed": _vm.personCardClosed
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cardContainer"
  }, [_c('div', {
    staticClass: "card",
    on: {
      "click": _vm.openPresentation
    }
  }, [_c('div', {
    staticClass: "top-half"
  }, [_c('div', {
    staticClass: "presenter"
  }, [(_vm.presenterInfo) ? _c('img', {
    staticClass: "presenterPhoto",
    attrs: {
      "src": _vm.presenterInfo.pictureURL,
      "onerror": "this.onerror = \"null\"; this.src = \"/static/img/anonymous.svg\""
    }
  }) : (_vm.presenterProfiles) ? _c('img', {
    staticClass: "presenterPhoto",
    attrs: {
      "src": _vm.presenterProfiles.profiles[0].pictureURL,
      "onerror": "this.onerror = \"null\"; this.src = \"/static/img/anonymous.svg\""
    }
  }) : _c('img', {
    staticClass: "presenterPhoto",
    attrs: {
      "src": __webpack_require__(34)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slidePreview"
  }, [_c('img', {
    staticClass: "slidePicture",
    attrs: {
      "src": _vm.presentation.previewUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-half"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(this.presentation.title))]), _vm._v(" "), (_vm.presenterInfo) ? _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.presenterInfo.displayName))]) : (_vm.presenterProfiles) ? _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.presenterProfiles.profiles[0].displayName))]) : _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('str.DialogLoop')))])])])])
},staticRenderFns: []}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chatTray"
  }, [_c('a', {
    staticClass: "drop-down-menu",
    on: {
      "click": function($event) {
        _vm.toggleTray()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('div', {
    staticClass: "chat-wrapper"
  }, [_c('div', [(_vm.historyOpen) ? _c('chatContacts', {
    staticClass: "side-nav",
    attrs: {
      "user": _vm.user,
      "contacts": _vm.contacts,
      "person": _vm.person
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "chat-container",
    attrs: {
      "disabled": !this.person
    }
  }, [_c('div', {
    ref: "chat",
    staticClass: "chat"
  }, [(_vm.isEmpty) ? _c('div', {
    class: _vm.backgroundMessage
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('str.NoMessages')))])]) : _c('ul', {
    staticClass: "chatList",
    style: (_vm.messagesIEHackStyle),
    attrs: {
      "name": "messages"
    }
  }, [_vm._l((_vm.chatList), function(messageData, index) {
    return _c('chatbox', {
      key: index,
      attrs: {
        "messageData": messageData,
        "person": _vm.getPerson(messageData.from),
        "user": _vm.user
      },
      on: {
        "openPersonCard": function($event) {
          _vm.openPersonCard($event)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.messagesSending), function(messageData, index) {
    return _c('chatbox', {
      key: _vm.chatList.length + index,
      attrs: {
        "messageData": messageData,
        "person": _vm.user,
        "user": _vm.user
      },
      on: {
        "openPersonCard": function($event) {
          _vm.openPersonCard($event)
        }
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    class: _vm.chatSubmit
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chatText),
      expression: "chatText"
    }],
    staticClass: "chat-text",
    attrs: {
      "placeholder": _vm.placeholder,
      "disabled": !this.person
    },
    domProps: {
      "value": (_vm.chatText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitText($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chatText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "submit-button",
    attrs: {
      "src": __webpack_require__(175)
    },
    on: {
      "click": _vm.submitText
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chat-arrow-small"
  })])]), _vm._v(" "), (this.viewPerson) ? _c('personcard', {
    attrs: {
      "attendee": this.viewPerson,
      "user": _vm.user
    },
    on: {
      "cardClosed": _vm.personCardClosed
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "overlay",
    staticClass: "tooltip-overlay",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    ref: "container",
    staticClass: "tool-container",
    style: (_vm.containerStyle)
  }, [_c('div', {
    staticClass: "tool-wrapper"
  }, [_c('div', {
    staticClass: "tool-items"
  }, [_c('a', {
    staticClass: "tool-item",
    on: {
      "click": _vm.shareOnFacebook
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    staticClass: "tool-item",
    on: {
      "click": _vm.shareOnLinkedIn
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })]), _vm._v(" "), _c('a', {
    staticClass: "tool-item",
    attrs: {
      "href": _vm.mailHref
    },
    on: {
      "click": _vm.shareInMail
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])]), _vm._v(" "), _c('div', {
    ref: "arrow",
    staticClass: "arrow-down",
    style: (_vm.arrow)
  })])])])
},staticRenderFns: []}

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sessionTray"
  }, [_c('notification-bar', {
    attrs: {
      "text": _vm.notificationText
    },
    on: {
      "notification-click": _vm.onNotificationClicked
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sessionList"
  }, _vm._l((_vm.presentationsGrouped), function(presentation, index) {
    return _c('div', {
      key: index
    }, [_c('sessioncard', {
      attrs: {
        "presentation": presentation
      }
    })], 1)
  })), _vm._v(" "), (_vm.isEmpty) ? _c('div', {
    staticClass: "background-message"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('str.NoSessionsAvailable')))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('str.PleaseTryAgain')))]), _vm._v(" "), _c('div', {
    staticClass: "retry"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(411)
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retryUrl),
      expression: "retryUrl"
    }],
    staticClass: "input-retry",
    domProps: {
      "value": (_vm.retryUrl)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.retry($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.retryUrl = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "spinner-container"
  }, [_c('spinner')], 1) : _c('button', {
    staticClass: "bt-retry",
    on: {
      "click": _vm.retry
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Go')))])])])]) : _vm._e(), _vm._v(" "), (!_vm.isReady) ? _c('spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dl-login-container",
    on: {
      "click": _vm.close
    }
  }, [_c('transition', {
    attrs: {
      "name": "dl-login-toggle"
    },
    on: {
      "after-leave": _vm.afterHidden,
      "before-enter": _vm.onAnimationStart,
      "before-leave": _vm.onAnimationStart,
      "after-enter": _vm.onAnimationEnd
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "dl-login",
    on: {
      "click": function($event) {
        _vm.stopClickPropagation($event)
      }
    }
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('str.LoginWithDialogLoop')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "placeholder": _vm.$t('str.Email'),
      "disabled": _vm.isLoggingIn
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('str.Password'),
      "disabled": _vm.isLoggingIn
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', [_c('button', {
    attrs: {
      "disabled": _vm.isLoggingIn
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Login')))])]), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('str.NeedAnAccount')))]), _vm._v(" "), _c('p', [_c('a', {
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Register')))])])]), _vm._v(" "), _c('a', {
    staticClass: "close-button",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerbar"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "dropdown-button"
  }, [(_vm.user.pictureUrl) ? _c('img', {
    attrs: {
      "src": _vm.user.pictureUrl
    },
    on: {
      "click": _vm.toggleAccountMenu
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(34)
    },
    on: {
      "click": _vm.toggleAccountMenu
    }
  })]), _vm._v(" "), (_vm.menuOpen) ? _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('accountmenu', {
    attrs: {
      "user": _vm.user,
      "service": _vm.service
    },
    on: {
      "closeMenu": function($event) {
        _vm.closeMenu()
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "brand-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(405)
    }
  })])
}]}

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drawer"
  }, [(_vm.trayType === 'Chat') ? _c('div', {
    staticClass: "chat-header-arrow"
  }) : _vm._e(), _vm._v(" "), (_vm.trayType === 'Chat') ? _c('div', {
    staticClass: "chat-header"
  }, [_c('div', {
    staticClass: "title chatTitle"
  }, [_vm._v(_vm._s(_vm.trayType))]), _vm._v(" "), _c('a', {
    staticClass: "btn-right",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]) : _c('div', {
    staticClass: "tray-header"
  }, [(_vm.trayType === 'Questions') ? _c('img', {
    staticClass: "header-icon",
    attrs: {
      "src": __webpack_require__(178)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.trayType === 'People') ? _c('img', {
    staticClass: "header-icon",
    attrs: {
      "src": __webpack_require__(177)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.trayType === 'Sessions') ? _c('img', {
    staticClass: "header-icon",
    attrs: {
      "src": __webpack_require__(179)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.trayType))]), _vm._v(" "), (_vm.presentation) ? _c('a', {
    staticClass: "btn-right",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e()]), _vm._v(" "), (_vm.trayType === 'Sessions') ? _c('sessionstray', {
    attrs: {
      "presentations": _vm.presentationList,
      "isLoading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.trayType === 'Questions') ? _c('questiontray', {
    attrs: {
      "peopleMap": _vm.peopleMap,
      "questions": _vm.questionList,
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.trayType === 'People') ? _c('peopletray', {
    attrs: {
      "people": _vm.peopleList,
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.trayType === 'Chat') ? _c('chattray', {
    attrs: {
      "presentation": _vm.presentation,
      "person": _vm.person,
      "user": _vm.user,
      "contacts": _vm.chatContacts,
      "chatList": _vm.chatList,
      "peopleMap": _vm.peopleMap
    },
    on: {
      "updateChat": function($event) {
        _vm.updateChat($event)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contactList"
  }, [(_vm.isEmpty) ? _c('div', {
    staticClass: "open-people-list"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.openPeopleTab
    }
  }, [_vm._v(_vm._s(_vm.$t("str.SelectContactInTheSession")))])]) : _c('ul', {
    staticClass: "contacts"
  }, _vm._l((_vm.otherContacts), function(contact, index) {
    return _c('chatlistitem', {
      key: index,
      attrs: {
        "user": _vm.user,
        "contact": contact,
        "isSelected": _vm.person && contact.to[0] === _vm.person.id
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-app"
  }, [(_vm.presentation !== undefined) ? _c('div', [_c('visualpanel', {
    attrs: {
      "progressiveReveal": _vm.progressiveReveal,
      "user": _vm.user,
      "service": _vm.service,
      "slideList": _vm.slideList,
      "presentation": _vm.presentation,
      "syncSlideNum": _vm.syncSlideNum
    },
    on: {
      "newCurrentSlide": function($event) {
        _vm.getCurrentSlide($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-title-bar"
  }, [_c('div', {
    staticClass: "presenter-icon"
  }, [_c('img', {
    staticClass: "presenter-portrait",
    attrs: {
      "src": _vm.pictureUrl,
      "onerror": "this.onerror = \"null\"; this.src = \"/static/img/anonymous.svg\""
    },
    on: {
      "click": function($event) {
        _vm.togglePresenterCard()
      }
    }
  }), _vm._v(" "), (_vm.presentation.props.PresenterProfiles && _vm.presentation.props.PresenterProfiles.profiles.length > 1) ? _c('span', {
    staticClass: "presenter-count"
  }, [_vm._v(_vm._s(_vm.presentation.props.PresenterProfiles.profiles.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "session-title"
  }, [_vm._v(_vm._s(_vm.presentation.title))]), _vm._v(" "), _c('div', {
    staticClass: "resources-tab"
  }, [(_vm.isResourceAvailable) ? _c('img', {
    staticClass: "arrow",
    class: _vm.isResourceOpen ? 'rotate' : '',
    attrs: {
      "src": __webpack_require__(108)
    },
    on: {
      "click": function($event) {
        _vm.toggleTray()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isResourceAvailable && _vm.isResourceOpen) ? _c('resourcestray', {
    attrs: {
      "surveys": _vm.surveys,
      "currentSlide": _vm.currentSlide,
      "slideList": _vm.slideList,
      "presentation": _vm.presentation,
      "user": _vm.user
    },
    on: {
      "closeResources": _vm.toggleTray
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.cardOpen) ? _c('presentercard', {
    attrs: {
      "profileIndex": _vm.profileIndex,
      "presentation": _vm.presentation
    },
    on: {
      "scrollProfile": function($event) {
        _vm.scrollProfile($event)
      },
      "closeCard": function($event) {
        _vm.closePresenterCard($event)
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isSurveyVisible) ? _c('div', {
    staticClass: "survey-container"
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.dismissSurvey
    }
  }), _vm._v(" "), _c('survey', {
    attrs: {
      "survey": _vm.jsonSurvey,
      "css-path": "survey-1.2.0.css",
      "localization-path": "survey/localization",
      "user": _vm.user,
      "onSubmit": _vm.onSubmitSurvey,
      "onFail": _vm.onFailSurvey
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "WebApp"
  }, [(!!_vm.notificationForAll) ? _c('notification-bar', {
    attrs: {
      "text": _vm.notificationForAll
    },
    on: {
      "notification-click": _vm.onNotificationClicked
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bar-container"
  }, [_c('headerbar', {
    attrs: {
      "user": _vm.user,
      "service": _vm.service
    }
  }), _vm._v(" "), (!!_vm.notificationText) ? _c('notification-bar', {
    attrs: {
      "text": _vm.notificationText
    }
  }) : _vm._e(), _vm._v(" "), _c('sessionapp', {
    attrs: {
      "surveys": _vm.surveys,
      "progressiveReveal": _vm.progressiveReveal,
      "user": _vm.user,
      "service": _vm.service,
      "currentSlide": _vm.currentSlide,
      "presentation": _vm.activePres,
      "slideList": _vm.sortedSlides,
      "syncSlideNum": _vm.syncSlideNum
    },
    on: {
      "currentSlide": function($event) {
        _vm.getCurrentSlide($event)
      }
    }
  }), _vm._v(" "), _c('bottombar', {
    attrs: {
      "currentSlide": _vm.currentSlide,
      "chatContacts": _vm.chatContacts,
      "chatList": _vm.chatList,
      "slideList": _vm.sortedSlides,
      "presentation": _vm.activePres,
      "presentationList": _vm.presentationList,
      "peopleList": _vm.peopleList,
      "questionList": _vm.questionList,
      "peopleMap": _vm.peopleMap,
      "user": _vm.user,
      "isLoading": _vm.isLoading,
      "isAllowedToListSessions": _vm.isAllowedToListSessions
    },
    on: {
      "getPresentations": _vm.getPresentations
    }
  })], 1), _vm._v(" "), _c('leadgen', {
    attrs: {
      "service": _vm.service,
      "activePres": _vm.activePres,
      "user": _vm.user
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "peopleTray",
    on: {
      "scroll": function($event) {
        _vm.scroll($event)
      }
    }
  }, [_c('div', {
    staticClass: "peopleContainer"
  }, [_c('div', {
    staticClass: "peopleList"
  }, [_vm._l((_vm.people), function(person, index) {
    return _c('div', {
      key: index,
      staticClass: "icon-wrapper"
    }, [_c('personicon', {
      attrs: {
        "attendee": person
      },
      on: {
        "openCard": _vm.openCard
      }
    })], 1)
  }), _vm._v(" "), (_vm.isEmpty) ? _c('div', {
    staticClass: "background-message"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('str.NobodyInTheSession')))])]) : _vm._e()], 2), _vm._v(" "), (_vm.attendee) ? _c('personcard', {
    attrs: {
      "attendee": _vm.attendee,
      "user": _vm.user
    },
    on: {
      "cardClosed": _vm.cardClosed
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.people === undefined) ? _c('spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-bar",
    style: (_vm.styleNotification)
  }, [_c('table', {
    style: (_vm.styleTable)
  }, [_c('tr', [_c('td', {
    staticClass: "side-col"
  }), _vm._v(" "), _c('td', {
    staticClass: "large-col"
  }, [_c(_vm.htmlText, {
    tag: "component"
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "side-col"
  }, [_c('a', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.hide($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-menu"
  }, [_c('ul', {
    staticClass: "dropdown-content"
  }, [_c('li', [_c('div', {
    staticClass: "account-button"
  }, [_c('a', {
    attrs: {
      "id": "profile"
    },
    on: {
      "click": function($event) {
        _vm.toggleAccountSettings()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('str.MyProfile')))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "account-button"
  }, [_c('a', {
    attrs: {
      "id": "logout"
    },
    on: {
      "click": function($event) {
        _vm.Logout()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Logout')))])])])]), _vm._v(" "), (_vm.modalOpen) ? _c('profilemanagement', {
    attrs: {
      "user": _vm.user,
      "service": _vm.service
    },
    on: {
      "closeModal": _vm.close
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-presenter-container",
    on: {
      "click": _vm.close
    }
  }, [_c('transition', {
    attrs: {
      "name": "card-presenter-toggle"
    },
    on: {
      "after-leave": _vm.afterHidden
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "card-presenter",
    on: {
      "click": function($event) {
        _vm.stopClickPropagation($event)
      }
    }
  }, [_c('div', {
    staticClass: "card-image-container"
  }, [(_vm.presentation.props.PresenterProfiles && _vm.presentation.props.PresenterProfiles.profiles.length > 1) ? _c('a', {
    staticClass: "prev-next-button prev",
    on: {
      "click": function($event) {
        _vm.scrollProfile('left')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left align-arrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.presentation.props.PresenterInfo) ? _c('img', {
    staticClass: "card-image",
    attrs: {
      "src": _vm.presentation.props.PresenterInfo.pictureURL,
      "onerror": "this.onerror = \"null\"; this.src = \"/static/img/anonymous.svg\""
    }
  }) : (_vm.presentation.props.PresenterProfiles) ? _c('img', {
    staticClass: "card-image",
    attrs: {
      "src": _vm.presentation.props.PresenterProfiles.profiles[_vm.profileIndex].pictureURL,
      "onerror": "this.onerror = \"null\"; this.src = \"/static/img/anonymous.svg\""
    }
  }) : _c('img', {
    staticClass: "card-image",
    attrs: {
      "src": __webpack_require__(34)
    }
  }), _vm._v(" "), (_vm.presentation.props.PresenterProfiles && _vm.presentation.props.PresenterProfiles.profiles.length > 1) ? _c('a', {
    staticClass: "prev-next-button next",
    on: {
      "click": function($event) {
        _vm.scrollProfile('right')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right align-arrow"
  })]) : _vm._e()]), _vm._v(" "), (_vm.presentation.props.PresenterInfo) ? _c('h5', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.presentation.props.PresenterInfo.displayName))]) : (_vm.presentation.props.PresenterProfiles) ? _c('h5', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.presentation.props.PresenterProfiles.profiles[_vm.profileIndex].displayName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "link-collection"
  }, [(_vm.presentation.props.PresenterInfo) ? _c('div', {
    staticClass: "card-links"
  }, _vm._l((_vm.presentation.props.PresenterInfo.items), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('presenterLink', {
      attrs: {
        "item": item
      }
    })], 1)
  })) : (_vm.presentation.props.PresenterProfiles) ? _c('div', {
    staticClass: "card-links"
  }, _vm._l((_vm.presentation.props.PresenterProfiles.profiles[_vm.profileIndex].items), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('presenterLink', {
      attrs: {
        "item": item
      }
    })], 1)
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-presenter-footer"
  }, [_c('a', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Close')))])]), _vm._v(" "), _c('a', {
    staticClass: "close-button",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('figure', {
    staticClass: "person-icon"
  }, [(_vm.attendee.pictureUrl) ? _c('img', {
    attrs: {
      "src": _vm.attendee.pictureUrl,
      "onerror": "this.onerror = \"null\"; this.src = \"/static/img/anonymous.svg\""
    },
    on: {
      "click": _vm.openPersonCard
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(34)
    },
    on: {
      "click": _vm.openPersonCard
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.attendee.firstName) + " " + _vm._s(_vm.attendee.lastName))])])])
},staticRenderFns: []}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('str.DialogLoopLogin')))]), _vm._v(" "), _c('a', {
    staticClass: "socialnetwork",
    on: {
      "click": function($event) {
        _vm.login('linkedin')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(403)
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "socialnetwork",
    on: {
      "click": function($event) {
        _vm.login('facebook')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(396)
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "socialnetwork",
    on: {
      "click": function($event) {
        _vm.login('twitter')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(419)
    }
  })]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.dlLogin
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(393)
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('str.NeedAnAccount')))]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "link-register",
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Register')))])])]), _vm._v(" "), (_vm.isModal('register')) ? _c('register', {
    attrs: {
      "service": _vm.service
    },
    on: {
      "close": _vm.closeModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isModal('dlLogin')) ? _c('dl-login', {
    attrs: {
      "service": _vm.service
    },
    on: {
      "close": _vm.closeModal,
      "register": _vm.register
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'carouselScreen': (_vm.isMobileDevice && _vm.isLandscape)
    },
    on: {
      "touchmove": _vm.stopScroll
    }
  }, [_c('div', {
    ref: "carouselContainer",
    staticClass: "carousel",
    style: (_vm.containerStyle),
    on: {
      "touchmove": _vm.moveTouch,
      "touchstart": _vm.startTouch,
      "touchend": _vm.moveStop,
      "touchleave": _vm.mouseLeave,
      "mousedown": _vm.moveStart,
      "mouseup": _vm.moveStop,
      "mouseout": _vm.mouseLeave,
      "mouseover": _vm.mouseOver
    }
  }, [_c('div', {
    ref: "carouselSlider",
    staticClass: "image-container",
    style: (_vm.sliderStyle)
  }, _vm._l((_vm.slideList), function(slide, index) {
    return (_vm.checkProgressiveReveal(index)) ? _c('div', {
      key: index,
      staticClass: "images",
      style: (_vm.imageStyle(slide))
    }) : _vm._e()
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', [(_vm.showFullscreen && _vm.isFullScreenSupported) ? _c('div', {
    staticClass: "fullscreenButton",
    on: {
      "click": _vm.switchFullScreen
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(398)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isLeftArrowVisible) ? _c('div', {
    staticClass: "arrowButtonLeft",
    on: {
      "click": function($event) {
        _vm.changeSlide(_vm.currentSlide - 1);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(108)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isRightArrowVisible) ? _c('div', {
    staticClass: "arrowButtonRight",
    on: {
      "click": function($event) {
        _vm.changeSlide(_vm.currentSlide + 1);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(108)
    }
  })]) : _vm._e()])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-container"
  }, [_c('div', [_c('div', {
    staticClass: "account-tray"
  }, [_c('div', {
    staticClass: "account-header"
  }, [_c('div', [(_vm.user.pictureUrl) ? _c('img', {
    staticClass: "circle",
    attrs: {
      "src": _vm.user.pictureUrl
    }
  }) : _c('img', {
    staticClass: "circle",
    attrs: {
      "src": __webpack_require__(34)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('str.ConnectYourSocialAccounts')))]), _vm._v(" "), _c('a', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "account-body"
  }, [_c('div', [_c('ul', {
    staticClass: "social-accounts"
  }, _vm._l((_vm.socialMedias), function(title, socialMediaKey) {
    return _c('li', {
      key: socialMediaKey,
      staticClass: "account"
    }, [_c('h3', {
      staticClass: "account-title"
    }, [_vm._v(_vm._s(title))]), _vm._v(" "), (_vm.getUserSocialMediaProfile(socialMediaKey)) ? _c('img', {
      staticClass: "profile-picture circle",
      attrs: {
        "src": _vm.getProfilePicture(socialMediaKey)
      }
    }) : _c('i', {
      staticClass: "social-profile-icon circle",
      class: _vm.socialMediaIcon(socialMediaKey)
    }), _vm._v(" "), _c('p', [(_vm.isConnected(socialMediaKey)) ? _c('a', {
      attrs: {
        "href": _vm.getProfileUrl(socialMediaKey),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))]) : _vm._e()]), _vm._v(" "), (_vm.isConnected(socialMediaKey)) ? _c('a', {
      staticClass: "secondary-content",
      on: {
        "click": function($event) {
          _vm.unlinkAccount(socialMediaKey)
        }
      }
    }, [_c('img', {
      staticClass: "account-btn circle",
      attrs: {
        "src": __webpack_require__(422)
      }
    })]) : _c('a', {
      staticClass: "secondary-content",
      on: {
        "click": function($event) {
          _vm.linkAccount(socialMediaKey)
        }
      }
    }, [_c('img', {
      staticClass: "account-btn circle",
      attrs: {
        "src": __webpack_require__(409)
      }
    })])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "account-footer"
  }, [_c('div', [_c('a', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Close')))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-link"
  }, [_c('a', {
    staticClass: "tool-item"
  }, [_c('i', {
    class: _vm.item.icon
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.item.href,
      "target": "_blank"
    },
    on: {
      "click": _vm.recordLead
    }
  }, [_vm._v(_vm._s(_vm.item.label))])])
},staticRenderFns: []}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "chat-item"
  }, [_c('div', {
    staticClass: "message"
  }, [_c('img', {
    staticClass: "askerIcon",
    attrs: {
      "src": _vm.pictureUrl
    },
    on: {
      "click": function($event) {
        _vm.openPersonCard(_vm.person)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message-span"
  }, [_c('div', {
    staticClass: "message-user-name"
  }, [(_vm.person) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.openPersonCard(_vm.person)
      }
    }
  }, [_vm._v(_vm._s(_vm.person.firstName) + " " + _vm._s(_vm.person.lastName))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "message-text"
  }, [_vm._v(_vm._s(_vm.question.question))])]), _vm._v(" "), _c('div', {
    staticClass: "message-bottom-menu"
  }, [_c('span', {
    staticClass: "message-timestamp"
  }, [_vm._v(_vm._s(_vm.getTimestamp))]), _vm._v(" "), _c('span', {
    staticClass: "message-reply-button",
    on: {
      "click": function($event) {
        _vm.viewReplies()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Reply')))]), _vm._v(" "), (_vm.question.props !== null) ? _c('span', {
    staticClass: "message-comments",
    on: {
      "click": function($event) {
        _vm.toggleReplies()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$tc('str.CommentsCount', _vm.isPlurial, {
    count: Object.keys(_vm.question.props).length
  })) + " "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "message-likes"
  }, [(!_vm.question.voted) ? _c('i', {
    staticClass: "fa fa-thumbs-o-up",
    on: {
      "click": function($event) {
        _vm.likeQuestion()
      }
    }
  }, [_vm._v(" ")]) : _c('i', {
    staticClass: "fa fa-thumbs-up"
  }, [_vm._v(" ")]), _vm._v("\n                " + _vm._s(_vm.question.votes) + "\n            ")])])]), _vm._v(" "), (_vm.showReplies) ? _c('div', {
    staticClass: "message-reply-section"
  }, [_c('ul', {
    staticClass: "message-replies"
  }, _vm._l((_vm.question.replies), function(reply, index) {
    return _c('questionreplybox', {
      key: index,
      staticClass: "message-reply",
      attrs: {
        "reply": reply,
        "person": _vm.getPerson(index)
      },
      on: {
        "openPersonCard": function($event) {
          _vm.openPersonCard($event)
        }
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "message-reply-text"
  }, [(_vm.user.pictureUrl) ? _c('img', {
    staticClass: "message-reply-icon",
    attrs: {
      "src": _vm.user.pictureUrl
    }
  }) : _c('img', {
    staticClass: "message-reply-icon",
    attrs: {
      "src": __webpack_require__(34)
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replyText),
      expression: "replyText"
    }],
    ref: "replyInput",
    staticClass: "message-reply-text-box",
    attrs: {
      "maxlength": "500",
      "placeholder": _vm.$t('str.EnterYourReplyHere')
    },
    domProps: {
      "value": (_vm.replyText)
    },
    on: {
      "focus": _vm.replyFocus,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.replyToQuestion($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.replyText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "message-reply-submit",
    attrs: {
      "src": __webpack_require__(175)
    },
    on: {
      "click": _vm.replyToQuestion
    }
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slideAppTop"
  }, [_c('div', {
    staticClass: "slideContainer"
  }, [_c('div', {
    staticClass: "slideShow"
  }, [_c('carousel', {
    attrs: {
      "presentation": _vm.presentation,
      "progressiveReveal": _vm.progressiveReveal,
      "slideList": _vm.slideList,
      "syncSlideNum": _vm.syncSlideNum,
      "syncSlide": _vm.syncSlide
    },
    on: {
      "calculatedSlide": function($event) {
        _vm.slideCalculated($event)
      },
      "syncSlideEvent": function($event) {
        _vm.changeSyncSlide($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "slideMenu"
  }, [_c('div', {
    staticClass: "slideLeftMenu"
  }, [_c('div', {
    staticClass: "slideNumber"
  }, [_vm._v(_vm._s(_vm.$t('str.Of', {
    current: _vm.currentSlide + 1,
    count: _vm.slideList.length
  })))]), _vm._v(" "), (!_vm.syncSlide) ? _c('div', {
    staticClass: "syncSlides",
    on: {
      "click": function($event) {
        _vm.changeSyncSlide(true)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(413)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "slideRightMenu"
  }, [_c('div', {
    staticClass: "likeButton",
    on: {
      "click": _vm.likeSlide
    }
  }, [(_vm.slideLiked) ? _c('img', {
    attrs: {
      "src": __webpack_require__(399)
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(400)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "twitterButton",
    on: {
      "click": _vm.openTweetUI
    }
  }, [(!_vm.slideTweeted) ? _c('img', {
    attrs: {
      "src": __webpack_require__(418)
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(417)
    }
  })]), _vm._v(" "), _c('div', {
    ref: "shareBtn",
    staticClass: "shareButton",
    on: {
      "click": function($event) {
        _vm.toggleShareOptions($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(415)
    }
  })])])])]), _vm._v(" "), (_vm.tweet) ? _c('tweetslideui', {
    attrs: {
      "twitterProfile": _vm.twitterProfile,
      "currentSlide": _vm.currentSlide,
      "slideList": _vm.slideList,
      "user": _vm.user,
      "socialMedia": _vm.socialMedia
    },
    on: {
      "closeTweetUI": _vm.toggleTweetIcon
    }
  }) : _vm._e(), _vm._v(" "), (!!_vm.anchorOptions) ? _c('shareoptions', {
    attrs: {
      "slideList": _vm.slideList,
      "currentSlide": _vm.currentSlide,
      "presentation": _vm.presentation,
      "anchor": _vm.anchorOptions
    },
    on: {
      "close": _vm.closeShare
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.network.profileUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.recordLead
    }
  }, [(_vm.network.network === 'linkedin') ? _c('img', {
    attrs: {
      "src": __webpack_require__(404)
    }
  }) : (_vm.network.network === 'facebook') ? _c('img', {
    attrs: {
      "src": __webpack_require__(397)
    }
  }) : (_vm.network.network === 'twitter') ? _c('img', {
    attrs: {
      "src": __webpack_require__(420)
    }
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "message-reply"
  }, [_c('img', {
    attrs: {
      "src": _vm.pictureUrl
    },
    on: {
      "click": _vm.openPersonCard
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "reply-username"
  }, [_c('span', {
    on: {
      "click": _vm.openPersonCard
    }
  }, [_vm._v(_vm._s(_vm.person.firstName) + " " + _vm._s(_vm.person.lastName))])]), _vm._v(" "), _c('p', {
    staticClass: "reply-text"
  }, [_vm._v(_vm._s(_vm.reply.comment))])])])
},staticRenderFns: []}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottombar"
  }, [_c('transition', {
    attrs: {
      "name": "openTray"
    },
    on: {
      "before-enter": _vm.onAnimationStart,
      "after-enter": _vm.onAnimationEnd
    }
  }, [(_vm.isBottomTrayVisible) ? _c('bottomtray', {
    attrs: {
      "presentation": _vm.presentation,
      "person": _vm.person,
      "user": _vm.user,
      "trayType": _vm.trayContent,
      "chatContacts": _vm.chatContacts,
      "chatList": _vm.chatList,
      "presentationList": _vm.presentationList,
      "isLoading": _vm.isLoading,
      "peopleList": _vm.peopleList,
      "questionList": _vm.questionList,
      "peopleMap": _vm.peopleMap
    },
    on: {
      "closeTray": _vm.closeTray
    }
  }) : _vm._e(), _vm._v(" "), (_vm.trayContent === 'Notes') ? _c('notestray', {
    attrs: {
      "currentSlide": _vm.currentSlide,
      "presentation": _vm.presentation,
      "slideList": _vm.slideList,
      "user": _vm.user
    },
    on: {
      "closeTray": _vm.closeTray
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('ul', {
    staticClass: "bottom-menu"
  }, [_c('li', {
    attrs: {
      "disabled": !_vm.isAllowedToListSessions
    },
    on: {
      "click": _vm.openSessions
    }
  }, [(_vm.trayContent === 'Sessions') ? _c('img', {
    attrs: {
      "src": __webpack_require__(179)
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(414)
    }
  })]), _vm._v(" "), (this.presentation) ? _c('li', {
    on: {
      "click": _vm.openQuestions
    }
  }, [_c('div', [(_vm.trayContent === 'Questions') ? _c('img', {
    attrs: {
      "src": __webpack_require__(178)
    }
  }) : _c('img', {
    class: {
      notify: _vm.newQuestion
    },
    attrs: {
      "src": __webpack_require__(412)
    }
  }), _vm._v(" "), (_vm.newQuestion) ? _c('div', {
    staticClass: "notification-bubble"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.presentation) ? _c('li', {
    on: {
      "click": _vm.openPeople
    }
  }, [_c('div', [(_vm.trayContent === 'People') ? _c('img', {
    attrs: {
      "src": __webpack_require__(177)
    }
  }) : _c('img', {
    class: {
      notify: _vm.newPerson
    },
    attrs: {
      "src": __webpack_require__(407)
    }
  }), _vm._v(" "), (_vm.newPerson) ? _c('div', {
    staticClass: "notification-bubble"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.presentation) ? _c('li', {
    class: _vm.trayContent === 'Chat' ? 'selected' : '',
    on: {
      "click": _vm.openChat
    }
  }, [(_vm.trayContent === 'Chat') ? _c('img', {
    attrs: {
      "src": __webpack_require__(391)
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(392)
    }
  })]) : _vm._e(), _vm._v(" "), (this.presentation) ? _c('li', {
    on: {
      "click": _vm.openNotes
    }
  }, [(_vm.trayContent === 'Notes') ? _c('img', {
    attrs: {
      "src": __webpack_require__(176)
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(406)
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notes-drawer"
  }, [_c('div', {
    staticClass: "notes-tray-header"
  }, [_c('img', {
    staticClass: "notes-icon",
    attrs: {
      "src": __webpack_require__(176)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "notes-title"
  }, [_vm._v(_vm._s(_vm.$t('str.Notes')))]), _vm._v(" "), _c('div', {
    staticClass: "notes-buttons"
  }, [_c('transition-group', {
    attrs: {
      "name": "wave"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDirty === false),
      expression: "isDirty === false"
    }],
    key: 1,
    staticClass: "autosaving",
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v("s")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDirty === false),
      expression: "isDirty === false"
    }],
    key: 2,
    staticClass: "autosaving",
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDirty === false),
      expression: "isDirty === false"
    }],
    key: 3,
    staticClass: "autosaving",
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v("v")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDirty === false),
      expression: "isDirty === false"
    }],
    key: 4,
    staticClass: "autosaving",
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v("e")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDirty === false),
      expression: "isDirty === false"
    }],
    key: 5,
    staticClass: "autosaving",
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v("d")])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "title": _vm.$t('str.emailNotes')
    },
    on: {
      "click": _vm.emailNotes
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "title": _vm.$t('str.copyToClipboard')
    },
    on: {
      "click": _vm.copyToClipboard
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })]), _vm._v(" "), _c('a', {
    staticClass: "notes-btn-right",
    attrs: {
      "title": _vm.$t('str.Close')
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "notes-body"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userNotes),
      expression: "userNotes"
    }],
    staticClass: "note-content",
    attrs: {
      "name": "user-notes",
      "placeholder": _vm.$t('str.MyPrivateNote')
    },
    domProps: {
      "value": (_vm.userNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userNotes = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "notes-arrow"
  })])])
},staticRenderFns: []}

/***/ }),
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Item__ = __webpack_require__(35);








var Contact = function (_Item) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Contact, _Item);

    function Contact() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Contact);

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Contact.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Contact)).apply(this, arguments));
    }

    return Contact;
}(__WEBPACK_IMPORTED_MODULE_4__Item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Contact);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Item__ = __webpack_require__(35);








var Message = function (_Item) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Message, _Item);

    function Message() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Message);

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Message.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Message)).apply(this, arguments));
    }

    return Message;
}(__WEBPACK_IMPORTED_MODULE_4__Item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Message);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Item__ = __webpack_require__(35);








var Presentation = function (_Item) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Presentation, _Item);

    function Presentation(data) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Presentation);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Presentation.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Presentation)).call(this, data));

        if (!_this.props) {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this);
        }

        if (_this.props.PresenterInfo) {
            _this.props.PresenterInfo = JSON.parse(_this.props.PresenterInfo);
        }

        if (_this.props.PresenterProfiles) {
            _this.props.PresenterProfiles = JSON.parse(_this.props.PresenterProfiles);
        }

        if (_this.props.Resources) {
            _this.props.Resources = JSON.parse(_this.props.Resources);
        }

        if (_this.props.SurveyInstances) {
            _this.props.SurveyInstances = JSON.parse(_this.props.SurveyInstances);
        }

        if (_this.props.Surveys) {
            _this.props.Surveys = JSON.parse(_this.props.Surveys);

            for (var i = 0; i < _this.props.Surveys.length; i++) {
                _this.props.Surveys[i] = JSON.parse(_this.props.Surveys[i]);
            }
        }
        return _this;
    }

    // Added data


    return Presentation;
}(__WEBPACK_IMPORTED_MODULE_4__Item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Presentation);

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Item__ = __webpack_require__(35);








var Survey = function (_Item) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Survey, _Item);

    function Survey() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Survey);

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Survey.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Survey)).apply(this, arguments));
    }

    return Survey;
}(__WEBPACK_IMPORTED_MODULE_4__Item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Survey);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Person__ = __webpack_require__(111);








var User = function (_Person) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(User, _Person);

    function User() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, User);

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (User.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(User)).apply(this, arguments));
    }

    return User;
}(__WEBPACK_IMPORTED_MODULE_4__Person__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(cname) {
        if (!document || !document.cookie) {
            return "";
        }

        var name = cname + "=";
        var ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];

            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }

            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }

        return "";
    },
    set: function set(cname, cvalue, exHours) {
        if (!document) {
            return;
        }

        var d = new Date();

        d.setTime(d.getTime() + exHours * 60 * 60 * 1000);
        document.cookie = cname + "=" + cvalue + "; expires=" + d.toUTCString();
    }
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);




var regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

var StringEx = function () {
    function StringEx() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, StringEx);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(StringEx, null, [{
        key: 'isValidEmailFormat',
        value: function isValidEmailFormat(email) {
            return regEmail.test(email);
        }
    }]);

    return StringEx;
}();

/* harmony default export */ __webpack_exports__["a"] = (StringEx);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Url = function () {
    function Url() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Url);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Url, null, [{
        key: 'getParam',
        value: function getParam(url, name, defaultValue) {
            if (!url || !name) {
                return;
            }

            var regexp = new RegExp('[?&#]' + name + '=');
            var start = url.search(regexp);

            if (start < 0) {
                return defaultValue;
            }

            start += name.length + 2;

            var end = url.substr(start).search(/[?&#]/);

            return url.substr(start, end >= 0 ? end : undefined);
        }
    }, {
        key: 'removeParam',
        value: function removeParam(url, name) {
            if (url) {
                return url.replace(new RegExp('[?&#/]' + name + '=[^/&#]*', 'gi'), '');
            }
        }
    }, {
        key: 'paramsArray',
        value: function paramsArray(url) {
            if (!url) {
                return [];
            }

            var start = url.search(/[?#]/);

            if (start < 0) {
                return [];
            }

            var startQuestionMark = url.search(/[?]/, start);

            if (startQuestionMark >= 0) {
                start = startQuestionMark;
            }

            var end = url.substr(start + 1).search(/[#]/);

            return url.substr(start + 1, end < 0 ? undefined : end).replace(/[\/#?]/g, '').split('&');
        }
    }]);

    return Url;
}();

/* harmony default export */ __webpack_exports__["a"] = (Url);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);





/**
 * @description packages useful request properties into an object
 * @param {XMLHttpRequest} xhr the underlying request object
 * @returns {{}}
 */
var craftResponse = function craftResponse(xhr) {
    var response = {
        status: 0,
        statusText: '',
        response: {},
        responseText: '',
        responseUrl: '',
        DONE: 0,
        OPENED: 0
    };

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(response).forEach(function (key) {
        return response[key] = xhr[key];
    });

    return response;
};

/**
 * @property {{}} options
 * @property {XHMLHttpRequest} xhr
 * @property {Promise} promise
 * @property {{}} response
 */

var XHRPromise = function () {
    /**
     * @description Initializes a new request 
     * @param {string} method
     * @param {string} url
     */
    function XHRPromise(method, url) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, XHRPromise);

        if (typeof method !== 'string' || typeof url !== 'string') throw new Error('Invalid args exception');
        this.options = {};
        this.options.method = method;
        this.options.url = url;
        this.xhr = null;
        this.response = {};
    }

    /**
     * @description adds new parameters to the current request 
     * @param {{}} params key value pair object
     */


    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(XHRPromise, [{
        key: 'addParams',
        value: function addParams(params) {
            if ((typeof params === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(params)) !== 'object') throw new Error('Invalid args exception');
            this.options.params = params;
            if (this.options.method === 'GET') {
                var encoded = this.encodeURIObject(params);
                this.options.url = this.options.url.concat('?', encoded);
            }
        }

        /**
         * @description adds new headers to the current request 
         * @param {{}} headers key value pair object
         */

    }, {
        key: 'addHeaders',
        value: function addHeaders(headers) {
            var _this = this;

            if ((typeof headers === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(headers)) !== 'object') throw new Error('Invalid args exception');
            if (typeof this.options.headers === 'undefined') this.options.headers = {};
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(headers).forEach(function (key) {
                return _this.options.headers[key] = headers[key];
            });
        }
    }, {
        key: 'addPayload',
        value: function addPayload(payload, contentType) {
            this.options.payload = payload;
            this.addHeaders({
                'Content-type': contentType
            });
        }

        /**
         * @description Format the response
         * @param {string} type Format type. Supported values: JSON, String. Default: String
         */

    }, {
        key: 'setResponseType',
        value: function setResponseType() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "String";

            this.responseType = type;
        }

        /**
         * @description stringify, join, and encode key vlue pairs 
         * @param {{}} params key value pair object
         * @returns {string}
         */

    }, {
        key: 'encodeURIObject',
        value: function encodeURIObject(params) {
            if ((typeof params === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(params)) !== 'object') throw new Error('Invalid args exception');
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(params).map(function (key) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
            }).join('&');
        }

        /**
         * @summary Use the provided options to craft and send a request, this instances 
         * underlying xhr and promise will be created. When the xhr request resolves the
         * this instances request object will be filled.
         */

    }, {
        key: 'createAndSend',
        value: function createAndSend() {
            var _this2 = this;

            var xhr = new XMLHttpRequest();

            // Credentials
            if (this.options.username && this.options.password) {
                xhr.open(this.options.method, this.options.url, true, this.options.username, this.options.password);
            } else {
                xhr.open(this.options.method, this.options.url);
            }

            // headers in config
            if (this.options.headers) {
                __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.options.headers).forEach(function (key) {
                    return xhr.setRequestHeader(key, _this2.options.headers[key]);
                });
            }

            var self = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                xhr.onload = function () {
                    var response = craftResponse(xhr);

                    if (this.status >= 200 && this.status < 300) {
                        if (self.responseType === 'JSON') {
                            var data = void 0;

                            try {
                                data = JSON.parse(response.responseText);
                            } catch (e) {
                                this.dlog.error('Request failed: ' + url);
                                this.dlog.error(e);
                                reject("Unable to parse the Json response");
                                return;
                            }

                            resolve(data);
                        } else if (self.responseType === 'String') {
                            resolve(response.responseText);
                        } else {
                            resolve(response);
                        }
                    } else {
                        reject(response);
                    }
                };

                xhr.onerror = function () {
                    reject(craftResponse(xhr));
                };

                // Params will be ignored in get request
                // in constructor url modified with params on GET 
                if (_this2.options.payload) {
                    xhr.send(_this2.options.payload);
                } else {
                    xhr.send(_this2.options.params);
                }
            });
        }
    }]);

    return XHRPromise;
}();

/* harmony default export */ __webpack_exports__["a"] = (XHRPromise);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_Identifier__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utils_DLog__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Items_Question__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Items_Person__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Items_Slide__ = __webpack_require__(182);











function parseJson(str, dlog, callback) {
    var json = void 0;

    try {
        json = JSON.parse(str);
    } catch (e) {
        if (dlog) {
            dlog.error('BroadcastManager parseJSON - Error when parsing: ' + str);
        }

        return;
    }

    if (callback && json !== undefined) {
        callback(json);
    }

    return json;
}

var BroadcastManager = function () {
    function BroadcastManager(baseUrl, presentation, token) {
        var _this = this;

        var logger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new __WEBPACK_IMPORTED_MODULE_6__Utils_DLog__["a" /* default */]();

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, BroadcastManager);

        this.dlog = logger;
        this.webSocket = new WebSocket('wss://' + baseUrl + presentation.websocket + '?auth_code=' + token.replace('Bearer ', ''));
        this.webSocket.binaryType = 'arraybuffer';

        this.webSocket.onopen = function () {
            logger.debug('BroadcastManager constructor - Websocket opened for presentation: ' + presentation.id);
        };

        this.webSocket.onmessage = function (msg) {
            _this.webSocketEventHandler(msg);
        };

        this.webSocket.onclose = function () {
            logger.debug('BroadcastManager constructor - Websocket closed for presentation: ' + presentation.id);
        };

        this.webSocket.onerror = function (err) {
            logger.debug('BroadcastManager constructor - Websocket error for presentation: ' + presentation.id + ' - ' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(err));
        };
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(BroadcastManager, [{
        key: 'destroy',
        value: function destroy() {
            if (this.websocket) {
                this.close();
            }

            this.listeners = undefined;
        }
    }, {
        key: 'addListener',
        value: function addListener(eventName, callback) {
            if (!eventName || !callback) {
                this.dlog.debug('BroadcastManager addEventListener - Invalid arguments');
                return;
            }

            if (!this.listeners) {
                this.listeners = {};
            }

            if (!this.listeners[eventName]) {
                this.listeners[eventName] = {};
            }

            var id = __WEBPACK_IMPORTED_MODULE_5__Utils_Identifier__["a" /* default */].guid();

            this.listeners[eventName][id] = callback;

            return {
                eventName: eventName,
                id: id
            };
        }
    }, {
        key: 'removeListener',
        value: function removeListener(eventObjectId) {
            if (!eventObjectId || !eventObjectId.id || !eventObjectId.eventName) {
                this.dlog.debug('BroadcastManager removeListener - Invalid arguments');
                return;
            }

            if (this.listeners && this.listeners[eventObjectId.eventName]) {
                delete this.listeners[eventObjectId.eventName];
            }
        }
    }, {
        key: 'triggerEvent',
        value: function triggerEvent(eventName, data) {
            var _this2 = this;

            if (eventName === undefined || !this.listeners || !this.listeners[eventName]) {
                return;
            }

            setTimeout(function () {
                var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.listeners[eventName]);

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var key = _step.value;

                        _this2.listeners[eventName][key](data);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }, 0);
        }
    }, {
        key: 'webSocketEventHandler',
        value: function webSocketEventHandler(msg) {
            var _this3 = this;

            var len = msg.data.byteLength;
            var dataView = new DataView(msg.data);
            var webSocketHeader = dataView.getUint32(0);
            var jsonInfo = '';
            var WSV1_SLIDE_INFO_INDEX = 61;

            if (len > WSV1_SLIDE_INFO_INDEX) {
                var dstU8 = new Uint8Array(dataView.buffer, WSV1_SLIDE_INFO_INDEX, len - WSV1_SLIDE_INFO_INDEX);
                jsonInfo = new TextDecoder('utf-8').decode(dstU8);
            }

            if (len <= 0 || webSocketHeader !== 1) {
                return;
            }

            var frameType = dataView.getUint32(4); // frameType starts at byte 4

            switch (frameType) {
                case 2:
                    // FRAME_QUESTION_RECEIVED
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Question Received" - ' + jsonInfo);

                    parseJson(jsonInfo, this.dlog, function (json) {
                        _this3.triggerEvent('questionAdded', new __WEBPACK_IMPORTED_MODULE_7__Items_Question__["a" /* default */](json));
                    });

                    break;

                case 3:
                    // FRAME_QUESTION_LIKED_RECEIVED
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Question liked" - ' + jsonInfo);

                    parseJson(jsonInfo, this.dlog, function (json) {
                        _this3.triggerEvent('questionLiked', new __WEBPACK_IMPORTED_MODULE_7__Items_Question__["a" /* default */](json));
                    });

                    break;

                case 4:
                    // MESSAGE_ADD_PERSON
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Attendee added" - ' + jsonInfo);

                    parseJson(jsonInfo, this.dlog, function (json) {
                        _this3.triggerEvent('attendeeJoined', new __WEBPACK_IMPORTED_MODULE_8__Items_Person__["a" /* default */](json));
                    });

                    break;

                case 5:
                    // MESSAGE_REMOVE_PERSON
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Attendee removed" - ' + jsonInfo);
                    this.triggerEvent('attendeeLeft', jsonInfo);
                    break;

                case 6:
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Slide changed" - ' + jsonInfo);

                    parseJson(jsonInfo, this.dlog, function (json) {
                        _this3.triggerEvent('slideChanged', new __WEBPACK_IMPORTED_MODULE_9__Items_Slide__["a" /* default */](json));
                    });

                    break;

                case 7:
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Start survey" - ' + jsonInfo);

                    parseJson(jsonInfo, this.dlog, function (json) {
                        _this3.triggerEvent('surveyStarted', json);
                    });

                    break;

                case 11:
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Slides uploaded" - ' + jsonInfo);
                    this.triggerEvent('slidesUploaded', jsonInfo);
                    break;

                case 12:
                    // SlideUploaded
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Slide uploaded" - ' + jsonInfo);
                    this.triggerEvent('slideUploaded', jsonInfo);
                    break;

                case 13:
                    // UpdatedPresentation
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Presentation updated" - ' + jsonInfo);
                    this.triggerEvent('presentationUpdated', jsonInfo);
                    break;

                case 15:
                    // SlideDeleted
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Slide deleted" - ' + jsonInfo);
                    this.triggerEvent('slideDeleted', jsonInfo);
                    break;

                case 16:
                    // DeletedPresentation
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Presentation deleted" - ' + jsonInfo);
                    this.triggerEvent('presentationDeleted', jsonInfo);
                    break;

                case 17:
                    // StopSurveyMsg
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Survey stopped" - ' + jsonInfo);

                    parseJson(jsonInfo, this.dlog, function (json) {
                        _this3.triggerEvent('surveyStopped', json);
                    });

                    break;

                case 23:
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Question updated" - ' + jsonInfo);

                    parseJson(jsonInfo, this.dlog, function (json) {
                        _this3.triggerEvent('questionPropsUpdated', new __WEBPACK_IMPORTED_MODULE_7__Items_Question__["a" /* default */](json));
                    });

                    break;

                case 1001:
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Message 1001" - ' + jsonInfo);
                    this.triggerEvent('1001', jsonInfo);
                    break;

                case 1002:
                    // Room or Group insights. this is a DataScience bot message
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Message 1002" - ' + jsonInfo);
                    this.triggerEvent('1002', jsonInfo);
                    break;

                case 1003:
                    // Individual insights. this is a DataScience bot message
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Message 1003" - ' + jsonInfo);
                    this.triggerEvent('1003', jsonInfo);
                    break;

                default:
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received undefined event ' + jsonInfo);
                    break;
            }
        }
    }]);

    return BroadcastManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (BroadcastManager);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Items_Presentation__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Items_User__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Items_Person__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Items_Question__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Items_Slide__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Utils_XHRPromise__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__WebSockets_BroadcastManager__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Items_Message__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Items_Contact__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Items_Survey__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Utils_Cookie__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Utils_Identifier__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Utils_DLog__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Utils_Url__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Utils_StringEx__ = __webpack_require__(502);























var defaultBaseUrl = 'api.dialogloop.com';
var registerBearer = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2Nlc3MiOiJhZGRfdXNlciIsImV4cCI6MTU4Mjk0MzY4NywiaXNzIjoiZGlhbG9nbG9vcC5jb20ifQ.FczSvQOd7-QsVY95-gKTpQ9RoALU7k0Vbh51gb26kU95TyqQDbyUtgG-vBeax_gTK0yTLO1v8jDOAQHzQdx9troDCRm0c8HeWI0_YHDYKl0Qov-nIdEgvNtjwJ8FJy8K0lv3_M9X_UzofGjDGPr1Z9_d6-WgSOwo3ufoszwbcEs';

var DLService = function () {

    /**
     * @description Initializes a new service object 
     * @param {string} host
     * @param {string} version
     */
    function DLService() {
        var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultBaseUrl;
        var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'v1';

        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, DLService);

        console.log('Using host: ' + host + ', version: ' + version);

        this.dlog = new __WEBPACK_IMPORTED_MODULE_19__Utils_DLog__["a" /* default */]();
        this.apiOptions = {
            host: host,
            version: version,
            auth: ''
        };
        this.cache = {};
    }

    /**
     * @description Register a new user
     * @param {string} firstname
     * @param {string} lastname
     * @param {string} email
     * @param {string} password
     * @return Promise
     */


    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(DLService, [{
        key: 'registerUser',
        value: function registerUser(firstname, lastname, email, password) {
            var _this = this;

            if (!firstname || !lastname || !__WEBPACK_IMPORTED_MODULE_21__Utils_StringEx__["a" /* default */].isValidEmailFormat(email) || !password || firstname.trim() === '' || lastname.trim() === '' || password.trim() === '') {
                this.dlog.error('DLService.registerUser: Invalid argument');
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.registerUser with: ' + firstname + ', ' + lastname + ', ' + email + ', ' + password);

            return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var xhrp = new __WEBPACK_IMPORTED_MODULE_12__Utils_XHRPromise__["a" /* default */]('POST', 'https://' + defaultBaseUrl + '/v1/users');

                xhrp.addHeaders({
                    Authorization: 'Bearer ' + registerBearer
                });

                xhrp.addPayload(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
                    name: firstname + ' ' + lastname,
                    firstname: firstname,
                    lastname: lastname,
                    username: email,
                    email: email,
                    password: password
                }), 'application/json; charset=UTF-8');

                xhrp.createAndSend().then(resolve).catch(function (err) {
                    err = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(err);
                    _this.dlog.error('DLService.registerUser - Request error: ' + err);
                    reject({
                        code: 404,
                        message: err
                    });
                });
            });
        }

        /**
         * \brief   Login to social network or DialogLoop
         * \param[in] socialNetwork     Social network associated to login url: linked, twitter, facebook, dialogloop
         * \param[in] url   Optional Current url
         * \param[in] email  Optional Email of the user to log in
         * \param[in] password  Optional Password associated
         * \return Promise
         */

    }, {
        key: 'login',
        value: function login(socialNetwork, url, email, password) {
            var _this2 = this;

            socialNetwork = socialNetwork.toLowerCase();

            if (socialNetwork !== 'linkedin' && socialNetwork !== 'twitter' && socialNetwork !== 'facebook' && socialNetwork !== 'dialogloop') {
                this.dlog.error('DLService.login: Invalid argument: ' + socialNetwork);
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments");
            }

            if (socialNetwork === 'dialogloop' && (!email || !password || email.trim() === '' || password.trim() === '')) {
                this.dlog.error('DLService.login: Invalid arguments to login to DialogLoop. Provide an email and password');
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.login with: ' + socialNetwork + ', ' + email + ', ' + password);

            return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (socialNetwork === 'dialogloop') {
                    var params = __WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].paramsArray(__WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].removeParam(url, "error_code"));

                    params.push(_this2.getRdParameter());

                    var formEl = document.createElement("form");
                    formEl.style.display = "none";
                    formEl.setAttribute("method", "post");
                    formEl.setAttribute("action", 'https://' + defaultBaseUrl + '/authorize');

                    var sEl = document.createElement("input");
                    sEl.setAttribute("name", "s");
                    sEl.setAttribute("value", params.join('&'));
                    formEl.appendChild(sEl);

                    var emailEl = document.createElement("input");
                    emailEl.setAttribute("name", "email");
                    emailEl.setAttribute("value", email);
                    formEl.appendChild(emailEl);

                    var passwordEl = document.createElement("input");
                    passwordEl.setAttribute("name", "password");
                    passwordEl.setAttribute("value", password);
                    formEl.appendChild(passwordEl);

                    document.body.appendChild(formEl);
                    formEl.submit();
                } else {
                    window.location.href = _this2.getLoginUrl(socialNetwork, url);
                }
            });
        }

        /**
         * \brief   Set log level to print in the console.
         * \param[in] level Level of logs to print: NONE = 0, ERROR = 1, WARNING = 2, INFO = 3, DEBUG = 4
         */

    }, {
        key: 'setLogLevel',
        value: function setLogLevel(level) {
            this.dlog.level = level;
        }

        /**
         * @description Join the user to the sessions
         * \param[in] {object} connection   Details of the connection.
         * \return Promise if user data. If we cannot join, we return an error.
         *         Error code is 401 if we require the application to show a login page.
         * \example
         * this.service.login({
         *   url: window.location.href
         * }).then((user) => {
         *   this.user = user;
         *   this.init();
         * }).catch((err) => {
         *   if (err.code === 401) {
         *     console.log('Show login page with social network selection to get user ID from server');
         *   } else {
         *     console.error(err);
         *   }
         * });
         */

    }, {
        key: 'join',
        value: function join(connection) {
            var _this3 = this;

            if (connection === undefined) {
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject({
                    code: 400,
                    message: "Invalid arguments"
                });
            }

            var userId = connection.userId ? connection.userId : __WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].getParam(connection.url, "userId");

            if (userId === undefined) {
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject({
                    code: 401,
                    message: "No user Id. Redirect to login page."
                });
            }

            this.dlog.debug('DLService.join with connection ' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(connection));

            var auth = __WEBPACK_IMPORTED_MODULE_17__Utils_Cookie__["a" /* default */].get("DialoopKey");

            if (!auth) {
                var testAuth = connection.testAuth ? connection.testAuth : __WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].getParam(connection.url, 'testAuth');

                if (!testAuth) {
                    this.dlog.error('DLService.join - Could not get authentication key DialoopKey');

                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject({
                        code: 404,
                        message: "Missing DialogLoopKey cookie"
                    });
                }

                auth = testAuth;
            }

            this.dialogLoopKey = auth;

            return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var url = 'https://' + _this3.apiOptions.host + '/' + _this3.apiOptions.version + '/user/' + userId;
                var xhrp = new __WEBPACK_IMPORTED_MODULE_12__Utils_XHRPromise__["a" /* default */]('GET', url);

                xhrp.addHeaders({
                    Authorization: 'Bearer ' + auth
                });

                xhrp.createAndSend().then(function (response) {
                    var user = new __WEBPACK_IMPORTED_MODULE_8__Items_User__["a" /* default */](JSON.parse(response.responseText).data);
                    _this3.apiOptions.auth = 'Bearer ' + user.token;
                    resolve(user);
                }).catch(function (err) {
                    err = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(err);
                    _this3.dlog.error('DLService.login - Request error: ' + err);
                    reject({
                        code: 404,
                        message: err
                    });
                });
            });
        }

        /**
         * \brief Get connection details
         * \return Promise with string details of the connection
         */

    }, {
        key: 'getConnection',
        value: function getConnection(url) {
            var _this4 = this;

            this.dlog.debug('DLService.getConnection with url ' + url);

            return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this4.getSession({
                    url: url
                }).then(function (handle) {
                    var result = {
                        dialogloopkey: _this4.dialogLoopKey,
                        token: _this4.apiOptions.auth
                    };

                    if (handle.session) {
                        result.session = handle.session;
                    } else if (data.presentation) {
                        result.presentation = handle.presentation;
                    }

                    resolve(result);
                }).catch(reject);
            });
        }

        /**
         * \brief  Get the details of the session
         * \params[in] connection Details of the connection.
         * \return Promise with the handle to the session or the presentation
         * \example
         * DLService.getSession({
         *   url: window.location.href
         * }).then(async (handle) => {
         *   if (handle.session) {
         *     this.presentationList = await this.getPresentations(this.$route.query.handle);
         *   } else if (handle.presentation) {
         *     this.presentation = await this.service.getPresentation(this.$route.query.s);
         *   } else {
         *     console.error("An unexpected error has occured");
         *   }
         * });
         */

    }, {
        key: 'getSession',
        value: function getSession(connection) {
            var _this5 = this;

            if (!connection) {
                this.dlog.error("DLService.getSession - Invalid arguments");
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments");
            }

            return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this5.dlog.debug('DLService.getSession with connection: ' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(connection));

                var userId = connection.userId ? connection.userId : __WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].getParam(connection.url, 'userId');
                var s = connection.s ? connection.s : __WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].getParam(connection.url, 's');
                var handle = connection.handle ? connection.handle : __WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].getParam(connection.url, 'handle');
                var shortCodeFull = connection.shortCode ? connection.shortCode : __WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].getParam(connection.url, 'shortCode');
                var exp = connection.exp ? connection.exp : __WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].getParam(connection.url, 'exp');
                var testAuth = connection.testAuth ? connection.testAuth : __WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].getParam(connection.url, 'testAuth');

                function resolveData() {
                    if (s === undefined) {
                        resolve({
                            session: handle
                        });
                    } else {
                        resolve({
                            presentation: s
                        });
                    }
                }

                if (shortCodeFull === undefined) {
                    resolveData();
                    return;
                }

                var shortCodeUrl = decodeURIComponent(shortCodeFull);
                var shortCode = shortCodeUrl.substr(shortCodeUrl.lastIndexOf('/') + 1);

                _this5.dlog.debug('DLService.getSession decode url with shortCode: ' + shortCodeUrl);

                _this5.authenticatedRequest('c/' + shortCode, 'GET', 'JSON', {
                    host: "https://dialog.live"
                }).then(function (shortCodeData) {
                    _this5.dlog.debug('DLService.getSession shortCode has returned with: ' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(shortCodeData));

                    if (shortCodeData && shortCodeData.exists && shortCodeData.url && __WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].getParam(shortCodeData.url, 'state') !== 'Deleted') {
                        s = __WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].getParam(shortCodeData.url, 's');
                        handle = __WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].getParam(shortCodeData.url, 'handle', __WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].getParam(shortCodeData.url, 'h'));
                    }

                    resolveData();
                }).catch(function (err) {
                    _this5.dlog.error('Unable to get the data for the the shortCode: ' + shortCode);
                    reject('Invalid response from the server');
                });
            });
        }

        /**
         * \brief   Get user profile
         * \param[in] userId    User Id
         * \return User profile on success, else undefined
         * \return Promise
         */

    }, {
        key: 'getUser',
        value: function getUser(userId) {
            var _this6 = this;

            if (userId === undefined) {
                this.dlog.error("DLService.getUser - Invalid arguments");
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.getUser with user Id: ' + userId);

            return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                    var response;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this6.authenticatedRequest('user/' + userId);

                                case 2:
                                    response = _context.sent;

                                    if (response) {
                                        _context.next = 7;
                                        break;
                                    }

                                    _this6.dlog.error('Unable to get the user with Id: ' + userId);
                                    reject('Unable to get the user');
                                    return _context.abrupt('return');

                                case 7:

                                    resolve(new __WEBPACK_IMPORTED_MODULE_8__Items_User__["a" /* default */](response.data));

                                case 8:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this6);
                }));

                return function (_x3, _x4) {
                    return _ref.apply(this, arguments);
                };
            }());
        }

        /**
         * \brief   Get all presentations in the session
         * \param[in] sessionId    Id of the session
         * \return Array of Presentation objects on success, else undefined
         */

    }, {
        key: 'getPresentations',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(sessionId) {
                var response;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(sessionId === undefined)) {
                                    _context2.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.getPresentations - Invalid arguments");
                                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.getPresentations with session Id: ' + sessionId);

                                _context2.next = 6;
                                return this.authenticatedRequest('presentations', 'GET', 'JSON', {
                                    params: {
                                        handle: sessionId
                                    }
                                });

                            case 6:
                                response = _context2.sent;

                                if (!(!response || !response.data || !response.data.Presentations)) {
                                    _context2.next = 10;
                                    break;
                                }

                                this.dlog.error('Unable to get the user with Id: ' + userId);
                                return _context2.abrupt('return');

                            case 10:
                                return _context2.abrupt('return', response.data.Presentations.map(function (pres) {
                                    return new __WEBPACK_IMPORTED_MODULE_7__Items_Presentation__["a" /* default */](pres);
                                }));

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getPresentations(_x5) {
                return _ref2.apply(this, arguments);
            }

            return getPresentations;
        }()

        /**
         * \brief   Get description of the presentation
         * \param[in] presentationId    Id of the presentation
         * \return Presentation object on success, else undefined
         */

    }, {
        key: 'getPresentation',
        value: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(presentationId) {
                var response;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(presentationId === undefined)) {
                                    _context3.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.getPresentation - Invalid arguments");
                                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.getPresentation with presentation Id: ' + presentationId);

                                _context3.next = 6;
                                return this.authenticatedRequest('presentations/' + presentationId);

                            case 6:
                                response = _context3.sent;

                                if (response) {
                                    _context3.next = 10;
                                    break;
                                }

                                this.dlog.error('Unable to get the presentation with Id: ' + presentationId);
                                return _context3.abrupt('return');

                            case 10:
                                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_7__Items_Presentation__["a" /* default */](response.data));

                            case 11:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function getPresentation(_x6) {
                return _ref3.apply(this, arguments);
            }

            return getPresentation;
        }()

        /**
         * \brief   Get people in the presentation
         * \param[in] presentationId    Id of the presentation
         * \return Array of Person objects on success, else undefined
         */

    }, {
        key: 'getPeople',
        value: function () {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(presentationId) {
                var response;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!(presentationId === undefined)) {
                                    _context4.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.getPeople - Invalid arguments");
                                return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.getPeople with presentation Id: ' + presentationId);

                                _context4.next = 6;
                                return this.authenticatedRequest('presentations/' + presentationId + '/people');

                            case 6:
                                response = _context4.sent;

                                if (!(!response || !response.data)) {
                                    _context4.next = 10;
                                    break;
                                }

                                this.dlog.error('Unable to get the people in the presentation with Id: ' + presentationId);
                                return _context4.abrupt('return');

                            case 10:
                                return _context4.abrupt('return', response.data.map(function (person) {
                                    return new __WEBPACK_IMPORTED_MODULE_9__Items_Person__["a" /* default */](person);
                                }));

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function getPeople(_x7) {
                return _ref4.apply(this, arguments);
            }

            return getPeople;
        }()

        /**
         * \brief   Get questions in the presentation
         * \param[in] presentationId    Id of the presentation
         * \return Array of Question objects on success, else undefined
         */

    }, {
        key: 'getQuestions',
        value: function () {
            var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(presentationId) {
                var _this7 = this;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!(presentationId === undefined)) {
                                    _context6.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.getQuestions - Invalid arguments");
                                return _context6.abrupt('return', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.getQuestions with presentation Id: ' + presentationId);

                                if (!this.cache.questions) {
                                    this.cache.questions = {};
                                }

                                if (!this.cache.questions[presentationId]) {
                                    this.cache.questions[presentationId] = [];
                                }

                                return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                    _this7.dlog.debug('get questions start');
                                    var limit = 100;
                                    var questions = _this7.cache.questions[presentationId];

                                    var getPartialQuestions = function () {
                                        var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(offset) {
                                            var url, response, newQuestions;
                                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                                                while (1) {
                                                    switch (_context5.prev = _context5.next) {
                                                        case 0:
                                                            _this7.dlog.debug('get questions offset: ' + offset);
                                                            url = 'presentations/' + presentationId + '/questions?limit=' + limit;


                                                            if (offset != undefined) {
                                                                url += '&offset=' + offset;
                                                            }

                                                            _context5.next = 5;
                                                            return _this7.authenticatedRequest(url);

                                                        case 5:
                                                            response = _context5.sent;


                                                            if (response && response.data && response.data.questions) {
                                                                if (response.data.questions.length > 0) {
                                                                    newQuestions = response.data.questions;


                                                                    if (questions.length > 0) {
                                                                        newQuestions = response.data.questions.slice(1); // Remove first one as it is equal to the last one from a previous call
                                                                    }

                                                                    questions = questions.concat(newQuestions.map(function (question) {
                                                                        return new __WEBPACK_IMPORTED_MODULE_10__Items_Question__["a" /* default */](question);
                                                                    }));
                                                                }

                                                                if (response.data.questions.length < limit) {
                                                                    _this7.cache.questions[presentationId] = questions;
                                                                    resolve(JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(questions)));
                                                                } else {
                                                                    setTimeout(function () {
                                                                        getPartialQuestions(response.data.next);
                                                                    }, 1);
                                                                }
                                                            } else {
                                                                _this7.dlog.error('Unable to get the question in the presentation with Id: ' + presentationId);
                                                                reject('Unable to get the questions');
                                                            }

                                                        case 7:
                                                        case 'end':
                                                            return _context5.stop();
                                                    }
                                                }
                                            }, _callee5, _this7);
                                        }));

                                        return function getPartialQuestions(_x9) {
                                            return _ref6.apply(this, arguments);
                                        };
                                    }();

                                    getPartialQuestions(questions.length > 0 ? questions[questions.length - 1].id : undefined);
                                }));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function getQuestions(_x8) {
                return _ref5.apply(this, arguments);
            }

            return getQuestions;
        }()

        /**
         * \brief   Get messages between a user and his contact
         * \param[in] userId    Id of the user
         * \param[in] contactId    Id of the contact
         * \return Promise with array of Message objects on success, else undefined
         */

    }, {
        key: 'getMessages',
        value: function getMessages(userId, contactId) {
            var _this8 = this;

            if (userId === undefined || !contactId) {
                this.dlog.error("DLService.getMessages - Invalid arguments");
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.getMessages between user: ' + userId + ' and contact: ' + contactId);

            if (!this.cache.messages) {
                this.cache.messages = {};
            }

            if (!this.cache.messages[userId]) {
                this.cache.messages[userId] = {};
            }

            if (!this.cache.messages[userId][contactId]) {
                this.cache.messages[userId][contactId] = [];
            }

            return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this8.dlog.debug('get Messages start');
                var limit = 100;
                var messages = _this8.cache.messages[userId][contactId];

                var getPartialMessages = function () {
                    var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(offset) {
                        var url, response;
                        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                            while (1) {
                                switch (_context7.prev = _context7.next) {
                                    case 0:
                                        _this8.dlog.debug('get Messages offset: ' + offset);
                                        url = 'user/' + userId + '/messages/contacts/' + contactId + '?limit=' + limit;


                                        if (offset != undefined) {
                                            url += '&offset=' + offset;
                                        }

                                        _context7.next = 5;
                                        return _this8.authenticatedRequest(url);

                                    case 5:
                                        response = _context7.sent;


                                        if (response && response.data && response.data.messages) {
                                            if (response.data.messages.length > 0) {
                                                messages = messages.concat(response.data.messages.map(function (message) {
                                                    return new __WEBPACK_IMPORTED_MODULE_14__Items_Message__["a" /* default */](message);
                                                }));
                                            }

                                            if (response.data.messages.length < limit) {
                                                _this8.cache.messages[userId][contactId] = messages;
                                                resolve(JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(messages)));
                                            } else {
                                                setTimeout(function () {
                                                    getPartialMessages(response.data.next);
                                                }, 1);
                                            }
                                        } else {
                                            _this8.dlog.error('Unable to get the messages between the user: ' + userId + ' and the contact: ' + contactId);
                                            reject('Unable to get the messages');
                                        }

                                    case 7:
                                    case 'end':
                                        return _context7.stop();
                                }
                            }
                        }, _callee7, _this8);
                    }));

                    return function getPartialMessages(_x10) {
                        return _ref7.apply(this, arguments);
                    };
                }();

                getPartialMessages(messages.length > 0 ? messages[messages.length - 1].messageId : undefined);
            });
        }

        /**
         * \brief   Get contacts of a user
         * \param[in] userId    Id of the user
         * \return Array of Contact objects on success, else undefined
         */

    }, {
        key: 'getContacts',
        value: function () {
            var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(userId) {
                var response;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (!(userId === undefined)) {
                                    _context8.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.getContacts - Invalid arguments");
                                return _context8.abrupt('return', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.getContacts of user: ' + userId);

                                _context8.next = 6;
                                return this.authenticatedRequest('user/' + userId + '/messages/contacts');

                            case 6:
                                response = _context8.sent;

                                if (!(!response || !response.data)) {
                                    _context8.next = 10;
                                    break;
                                }

                                this.dlog.error('Unable to get the contacts for the user Id: ' + userId);
                                return _context8.abrupt('return');

                            case 10:
                                return _context8.abrupt('return', response.data.map(function (contact) {
                                    return new __WEBPACK_IMPORTED_MODULE_15__Items_Contact__["a" /* default */](contact);
                                }));

                            case 11:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function getContacts(_x11) {
                return _ref8.apply(this, arguments);
            }

            return getContacts;
        }()

        /**
         * \brief   Get description of a survey within a presentation
         * \param[in] presentationId    Id of the presentation
         * \param[in] surveyId    Id of the survey
         * \return Survey object on success, else undefined
         */

    }, {
        key: 'getSurvey',
        value: function () {
            var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9(presentationId, surveyId) {
                var response;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (!(presentationId === undefined || !surveyId)) {
                                    _context9.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.getSurvey - Invalid arguments");
                                return _context9.abrupt('return', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.getSurvey in presentation: ' + presentationId + ' with Id: ' + surveyId);

                                _context9.next = 6;
                                return this.authenticatedRequest('presentations/' + presentationId + '/surveys/' + surveyId);

                            case 6:
                                response = _context9.sent;

                                if (response) {
                                    _context9.next = 10;
                                    break;
                                }

                                this.dlog.error('Unable to get the survey in the presentation with Id: ' + presentationId);
                                return _context9.abrupt('return');

                            case 10:
                                return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_16__Items_Survey__["a" /* default */](response));

                            case 11:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function getSurvey(_x12, _x13) {
                return _ref9.apply(this, arguments);
            }

            return getSurvey;
        }()

        /**
         * \brief   Get slides of a presentation
         * \param[in] presentationId    Id of the presentation
         * \return Array of Slide object on success, else undefined
         */

    }, {
        key: 'getSlides',
        value: function () {
            var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10(presentationId) {
                var response;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                if (!(presentationId === undefined)) {
                                    _context10.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.getSlides - Invalid arguments");
                                return _context10.abrupt('return', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.getSlides of presentation: ' + presentationId);

                                _context10.next = 6;
                                return this.authenticatedRequest('presentations/' + presentationId + '/slides');

                            case 6:
                                response = _context10.sent;

                                if (!(!response || !response.data)) {
                                    _context10.next = 10;
                                    break;
                                }

                                this.dlog.error('Unable to get the slides in the presentation with Id: ' + presentationId);
                                return _context10.abrupt('return');

                            case 10:
                                return _context10.abrupt('return', response.data.map(function (slide) {
                                    return new __WEBPACK_IMPORTED_MODULE_11__Items_Slide__["a" /* default */](slide);
                                }));

                            case 11:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function getSlides(_x14) {
                return _ref10.apply(this, arguments);
            }

            return getSlides;
        }()

        /**
         * \brief   Submit survey response
         * \param[in] presentationId    Id of the presentation
         * \param[in] surveyResponse    Responses from the survey
         * \return Promise
         */

    }, {
        key: 'submitSurvey',
        value: function submitSurvey(presentationId, surveyResponse) {
            if (presentationId === undefined || !surveyResponse) {
                console.log("DLService.submitSurvey - Invalid arguments");
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.submitSurvey for presentation: ' + presentationId);

            return this.authenticatedRequest('presentations/' + presentationId + '/submitSurvey', 'POST', null, {
                payload: {
                    data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(surveyResponse),
                    type: 'application/json; charset=UTF-8'
                }
            });
        }

        /**
         * \brief   Post a question
         * \param[in] presentationId    Id of the presentation
         * \param[in] userId    Id of the user
         * \param[in] question  Question object
         * \return Promise
         */

    }, {
        key: 'postQuestion',
        value: function postQuestion(presentationId, userId, question) {
            if (presentationId === undefined || !userId || !question) {
                this.dlog.error("DLService.postQuestion - Invalid arguments");
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.postQuestion with Id: ' + question.id + ' in presentation Id: ' + presentationId + ' from user Id: ' + userId);

            return this.authenticatedRequest('presentations/' + presentationId + '/questions', 'POST', null, {
                payload: {
                    data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
                        Question: question,
                        PersonId: userId
                    }),
                    type: 'application/json; charset=UTF-8'
                }
            });
        }

        /**
         * \brief   Reply to a question
         * \param[in] presentationId    Id of the presentation
         * \param[in] userId    Id of the user
         * \param[in] questionId    Id of the question
         * \param[in] reply    String of the reply
         * \return Promise
         */

    }, {
        key: 'replyQuestion',
        value: function replyQuestion(presentationId, userId, questionId, reply) {
            if (presentationId === undefined || userId === undefined || questionId === undefined || reply === undefined) {
                this.dlog.error("DLService.replyQuestion - Invalid arguments");
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.replyQuestion with presentation Id: ' + presentationId + ' and question Id: ' + questionId + ' from user Id: ' + userId);

            var question = {
                id: questionId,
                props: {}
            };

            question.props[__WEBPACK_IMPORTED_MODULE_18__Utils_Identifier__["a" /* default */].guid()] = {
                timestamp: Date.now(),
                replyBy: userId,
                comment: reply
            };

            return this.authenticatedRequest('presentations/' + presentationId + '/question/' + questionId, 'POST', null, {
                payload: {
                    data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(question),
                    type: 'application/json; charset=UTF-8'
                }
            });
        }

        /**
         * \brief   Post a message from a user to its contact
         * \param[in] presentationId    Id of the presentation
         * \param[in] userId    Id of the user
         * \param[in] userId    Id of the contact
         * \param[in] message  Message object
         * \return Promise
         */

    }, {
        key: 'postMessage',
        value: function postMessage(presentationId, userId, contactId, message) {
            if (presentationId === undefined || userId === undefined || contactId === undefined || !message) {
                this.dlog.error("DLService.postMessage - Invalid arguments");
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.postMessage in presentation Id: ' + presentationId + ' from user Id: ' + userId + ' to contact Id: ' + contactId);

            return this.authenticatedRequest('user/' + userId + '/messages', 'POST', null, {
                payload: {
                    data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
                        message: message,
                        from: userId,
                        to: contactId,
                        presId: presentationId
                    }),
                    type: 'application/json; charset=UTF-8'
                }
            });
        }

        /**
         * \brief   Disconnect user from social media
         * \param[in] userId    Id of the user
         * \param[in] socialMedia    Social media to disconnect the user from. Valid values are: LinkedIn, Twitter, Facebook
         * \return Promise
         */

    }, {
        key: 'unlinkAccount',
        value: function unlinkAccount(userId, socialMedia) {
            if (userId === undefined || !socialMedia) {
                this.dlog.error("DLService.unlinkAccount - Invalid arguments");
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.unlinkAccount with user Id: ' + userId + ' from ' + socialMedia);

            return this.authenticatedRequest('user/' + userId + '/unlink?provider=' + socialMedia, 'POST', null);
        }

        /**
         * \brief   Like a question
         * \param[in] presentationId    Id of the presentation
         * \param[in] userId    Id of the user who likes the question
         * \param[in] questionId    Id of the question
         * \return Promise
         */

    }, {
        key: 'likeQuestion',
        value: function likeQuestion(presentationId, userId, questionId) {
            if (presentationId === undefined || userId === undefined || questionId === undefined) {
                this.dlog.error("DLService.likeQuestion - Invalid arguments");
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.likeQuestion with presentation Id: ' + presentationId + ' between user Id: ' + userId + ' and question Id: ' + questionId);

            return this.authenticatedRequest('presentations/' + presentationId + '/question/' + questionId + '/like', 'POST', null, {
                payload: {
                    data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
                        VoteFor: true,
                        Id: questionId,
                        PersonId: userId
                    }),
                    type: 'application/json; charset=UTF-8'
                }
            });
        }

        /**
         * \brief   Like a slide
         * \param[in] presentationId    Id of the presentation
         * \param[in] slideId    Id of the slide
         * \return Promise
         */

    }, {
        key: 'likeSlide',
        value: function () {
            var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11(presentationId, slideId) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                if (!(presentationId === undefined || slideId === undefined)) {
                                    _context11.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.likeSlide - Invalid arguments");
                                return _context11.abrupt('return', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.likeSlide with presentation Id: ' + presentationId + ' and slide Id: ' + slideId);

                                return _context11.abrupt('return', this.authenticatedRequest('presentations/' + presentationId + '/slide/' + slideId + '/like', 'POST', null, {
                                    payload: {
                                        data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
                                            vote: true,
                                            id: slideId
                                        }),
                                        type: 'application/json; charset=UTF-8'
                                    }
                                }));

                            case 5:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function likeSlide(_x15, _x16) {
                return _ref11.apply(this, arguments);
            }

            return likeSlide;
        }()

        /**
         * \brief   Join a user to a presentation
         * \param[in] presentationId    Id of the presentation
         * \param[in] user    User object
         * \return Promise
         */

    }, {
        key: 'joinPresentation',
        value: function joinPresentation(presentation, user) {
            var _this9 = this;

            if (presentation === undefined || presentation.id === undefined || presentation.websocket === undefined || !user) {
                this.dlog.error("DLService.joinPresentation - Invalid arguments");
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.joinPresentation ' + user.id + ' in presentation Id: ' + presentation.id);

            return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this9.authenticatedRequest('presentations/' + presentation.id + '/people', 'POST', null, {
                    payload: {
                        data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(user),
                        type: 'application/json; charset=UTF-8'
                    }
                }).then(function () {
                    if (_this9.broadcastman) {
                        _this9.broadcastman.destroy();
                    }

                    _this9.broadcastman = new __WEBPACK_IMPORTED_MODULE_13__WebSockets_BroadcastManager__["a" /* default */](_this9.apiOptions.host, presentation, _this9.apiOptions.auth, _this9.dlog);

                    var updateCache = function updateCache(question) {
                        if (_this9.cache.questions === undefined || _this9.cache.questions[presentation.id] === undefined) {
                            return;
                        }

                        for (var i = 0; i < _this9.cache.questions[presentation.id].length; ++i) {
                            if (_this9.cache.questions[presentation.id][i].id === question.id) {
                                _this9.cache.questions[presentation.id][i].merge(question);
                                break;
                            }
                        }
                    };

                    _this9.broadcastman.addListener('questionPropsUpdated', updateCache);
                    _this9.broadcastman.addListener('questionLiked', updateCache);

                    resolve();
                }).catch(reject);
            });
        }

        /**
         * \brief   Analytics: Post tracking data. TODO: Refactor
         * \param[in] data    Json data to post
         * \return Promise
         */

    }, {
        key: 'postLead',
        value: function postLead(data) {
            if (!data) {
                this.dlog.error("DLService.postLead - Invalid arguments");
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("Invalid arguments");
            }

            var leadGenAccessKey = 'WtzemScOj95LSsM4hXupB7XmZCtfBYHN6In1Q0k2';
            var url = 'https://tyza0aojfd.execute-api.us-east-1.amazonaws.com/test/leadgen';
            var xhrp = new __WEBPACK_IMPORTED_MODULE_12__Utils_XHRPromise__["a" /* default */]('POST', url);
            xhrp.addPayload(data, 'application/json; charset=UTF-8');
            xhrp.addHeaders({
                'x-api-key': leadGenAccessKey
            });

            return xhrp.createAndSend();
        }

        /**
         * \brief   Register listener for event. DLService.setupListeners must be called before using this api.
         * \param[in] eventName   Event name to listen. Value can be on of the following: 
         *                        attendeeJoined, attendeeLeft, surveyStarted, surveyStopped, slidesUploaded,
         *                        slideUploaded, slideChanged, slideDeleted, presentationUpdated, presentationDeleted,
         *                        questionAdded, questionLiked, questionPropsUpdated, 1001, 1002, 1003
         * \param[in] callback    Callback when receiving the event
         * \return  Event object Id. Use to remove the listener.
         */

    }, {
        key: 'addEventListener',
        value: function addEventListener(eventName, callback) {
            if (!eventName || !callback) {
                this.dlog.error("DLService.addEventListener - Invalid arguments");
                return;
            }

            this.dlog.debug('DLService.addEventListener with eventName: ' + eventName);

            if (this.broadcastman) {
                this.broadcastman.addListener(eventName, callback);
            } else {
                this.dlog.error("DLService.addEventListener - Uninitialized broadcastmanager. Make sure to call DLService.setupListeners before DLService.addEventListener");
            }
        }

        /**
         * \brief   Unregister listener for event.
         * \param[in] eventObjectId   Event object id returned by DLService.addEventListener
         */

    }, {
        key: 'removeEventListener',
        value: function removeEventListener(eventObjectId) {
            if (!eventObjectId || !eventObjectId.eventName) {
                this.dlog.error("DLService.removeEventListener - Invalid arguments");
                return;
            }

            this.dlog.debug('DLService.removeEventListener with eventName: ' + eventObjectId.eventName);

            if (this.broadcastman) {
                this.broadcastman.removeListener(eventObjectId);
            } else {
                this.dlog.error("DLService.removeEventListener - Uninitialized broadcastmanager. Make sure to call DLService.setupListeners before DLService.addEventListener");
            }
        }

        /**
         * \brief   Tweet information about a slide
         * \param[in] tweet   tweet object to describe slide.
         */

    }, {
        key: 'tweetSlide',
        value: function tweetSlide(tweet, user) {
            if (!tweet || !user || !user.token) {
                this.dlog.error("DLService.tweetSlide - Invalid arguments");
                return;
            }

            var xmlhttp = new XMLHttpRequest();

            xmlhttp.oTweet = tweet;
            xmlhttp.open('POST', 'https://' + this.apiOptions.host + '/v1/tweet');
            xmlhttp.setRequestHeader('Authorization', 'Bearer ' + user.token);
            xmlhttp.send(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(tweet));
        }

        // ************************************************************************
        //
        //                               PRIVATE
        //
        // ************************************************************************

        /**
         * \brief   Send authenticated request. User must be logged in before send api requests
         * \param[in] url   API url
         * \param[in] method    Method for url. Default: GET
         * \param[in] responseType  Fomrat of the response. Default: JSON
         * \return  Promise
         */

    }, {
        key: 'authenticatedRequest',
        value: function authenticatedRequest(url) {
            var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
            var responseType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'JSON';
            var extraParams = arguments[3];

            if (!this.apiOptions || !this.apiOptions.auth) {
                this.dlog.error("DLService.authenticatedRequest - User not logged in");
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject("User not logged in");
            }

            var host = extraParams && extraParams.host ? extraParams.host : 'https://' + this.apiOptions.host;
            var xhrp = new __WEBPACK_IMPORTED_MODULE_12__Utils_XHRPromise__["a" /* default */](method, host + '/' + this.apiOptions.version + '/' + url);

            xhrp.setResponseType(responseType);
            xhrp.addHeaders({
                'Authorization': this.apiOptions.auth
            });

            this.dlog.debug('DLService.authenticatedRequest: ' + method + ' ' + host + '/' + this.apiOptions.version + '/' + url + ' (response: ' + responseType + ')');

            if (extraParams !== undefined) {
                if (extraParams.params) {
                    xhrp.addParams(extraParams.params);
                }

                if (extraParams.headers) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(extraParams.headers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var header = _step.value;

                            xhrp.addHeaders(header);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }

                if (extraParams.payload) {
                    xhrp.addPayload(extraParams.payload.data, extraParams.payload.type);
                }
            }

            return xhrp.createAndSend();
        }

        /**
         * \brief   Get login url for social network
         * \param[in] socialNetwork     Social network associated to login url: linked, twitter, facebook
         * \return Login url
         */

    }, {
        key: 'getLoginUrl',
        value: function getLoginUrl(socialNetwork, url) {
            socialNetwork = socialNetwork.toLowerCase();

            if (socialNetwork !== 'linkedin' && socialNetwork !== 'twitter' && socialNetwork !== 'facebook') {
                this.dlog.error('DLService.getLoginUrl: Invalid argument: ' + socialNetwork);
                return;
            }

            var params = __WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].paramsArray(__WEBPACK_IMPORTED_MODULE_20__Utils_Url__["a" /* default */].removeParam(url, "error_code"));

            params.push(this.getRdParameter());

            var cloneArgs = '?' + params.join('&');

            this.dlog.debug('DLService.getLoginUrl: https://' + this.apiOptions.host + '/auth/' + socialNetwork + cloneArgs);

            return 'https://' + this.apiOptions.host + '/auth/' + socialNetwork + cloneArgs;
        }

        /**
         * \brief Get rd parameter
         * \return String RD parameter
         */

    }, {
        key: 'getRdParameter',
        value: function getRdParameter() {
            var rd = void 0;

            if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
                rd = 7;
            } else {
                rd = 8;
            }

            return 'rd=' + rd;
        }
    }]);

    return DLService;
}();

/* harmony default export */ __webpack_exports__["a"] = (DLService);

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(518), __esModule: true };

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(519), __esModule: true };

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(520), __esModule: true };

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(523), __esModule: true };

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(524), __esModule: true };

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(526), __esModule: true };

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(527), __esModule: true };

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(112);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(566);


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(127);
__webpack_require__(126);
module.exports = __webpack_require__(551);


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(3);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(553);
module.exports = __webpack_require__(3).Object.assign;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(554);
var $Object = __webpack_require__(3).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(555);
var $Object = __webpack_require__(3).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(556);
module.exports = __webpack_require__(3).Object.getPrototypeOf;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(557);
module.exports = __webpack_require__(3).Object.keys;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(558);
module.exports = __webpack_require__(3).Object.setPrototypeOf;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(561);
module.exports = __webpack_require__(3).Object.values;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(205);
__webpack_require__(126);
__webpack_require__(127);
__webpack_require__(559);
__webpack_require__(562);
__webpack_require__(563);
module.exports = __webpack_require__(3).Promise;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(560);
__webpack_require__(205);
__webpack_require__(564);
__webpack_require__(565);
module.exports = __webpack_require__(3).Symbol;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(126);
__webpack_require__(127);
module.exports = __webpack_require__(125).f('iterator');


/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(38);
var toLength = __webpack_require__(203);
var toAbsoluteIndex = __webpack_require__(550);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(45);
var gOPS = __webpack_require__(119);
var pIE = __webpack_require__(56);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(54);
var call = __webpack_require__(536);
var isArrayIter = __webpack_require__(534);
var anObject = __webpack_require__(16);
var toLength = __webpack_require__(203);
var getIterFn = __webpack_require__(204);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 533 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(55);
var ITERATOR = __webpack_require__(9)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(53);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(16);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(118);
var descriptor = __webpack_require__(73);
var setToStringTag = __webpack_require__(74);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(37)(IteratorPrototype, __webpack_require__(9)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(9)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(76)('meta');
var isObject = __webpack_require__(29);
var has = __webpack_require__(36);
var setDesc = __webpack_require__(30).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(44)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var macrotask = __webpack_require__(202).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(53)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(45);
var gOPS = __webpack_require__(119);
var pIE = __webpack_require__(56);
var toObject = __webpack_require__(75);
var IObject = __webpack_require__(191);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(44)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(30);
var anObject = __webpack_require__(16);
var getKeys = __webpack_require__(45);

module.exports = __webpack_require__(28) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(38);
var gOPN = __webpack_require__(194).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(45);
var toIObject = __webpack_require__(38);
var isEnum = __webpack_require__(56).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(37);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(29);
var anObject = __webpack_require__(16);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(54)(Function.call, __webpack_require__(193).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var core = __webpack_require__(3);
var dP = __webpack_require__(30);
var DESCRIPTORS = __webpack_require__(28);
var SPECIES = __webpack_require__(9)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(122);
var defined = __webpack_require__(114);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(122);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var get = __webpack_require__(204);
module.exports = __webpack_require__(3).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(528);
var step = __webpack_require__(539);
var Iterators = __webpack_require__(55);
var toIObject = __webpack_require__(38);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(192)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(12);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(542) });


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(118) });


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(28), 'Object', { defineProperty: __webpack_require__(30).f });


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(75);
var $getPrototypeOf = __webpack_require__(195);

__webpack_require__(197)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(75);
var $keys = __webpack_require__(45);

__webpack_require__(197)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(12);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(547).set });


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(72);
var global = __webpack_require__(8);
var ctx = __webpack_require__(54);
var classof = __webpack_require__(188);
var $export = __webpack_require__(12);
var isObject = __webpack_require__(29);
var aFunction = __webpack_require__(71);
var anInstance = __webpack_require__(529);
var forOf = __webpack_require__(532);
var speciesConstructor = __webpack_require__(201);
var task = __webpack_require__(202).set;
var microtask = __webpack_require__(541)();
var newPromiseCapabilityModule = __webpack_require__(117);
var perform = __webpack_require__(198);
var promiseResolve = __webpack_require__(199);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(9)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(546)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(74)($Promise, PROMISE);
__webpack_require__(548)(PROMISE);
Wrapper = __webpack_require__(3)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(538)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(8);
var has = __webpack_require__(36);
var DESCRIPTORS = __webpack_require__(28);
var $export = __webpack_require__(12);
var redefine = __webpack_require__(200);
var META = __webpack_require__(540).KEY;
var $fails = __webpack_require__(44);
var shared = __webpack_require__(121);
var setToStringTag = __webpack_require__(74);
var uid = __webpack_require__(76);
var wks = __webpack_require__(9);
var wksExt = __webpack_require__(125);
var wksDefine = __webpack_require__(124);
var enumKeys = __webpack_require__(531);
var isArray = __webpack_require__(535);
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(29);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(123);
var createDesc = __webpack_require__(73);
var _create = __webpack_require__(118);
var gOPNExt = __webpack_require__(544);
var $GOPD = __webpack_require__(193);
var $DP = __webpack_require__(30);
var $keys = __webpack_require__(45);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(194).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(56).f = $propertyIsEnumerable;
  __webpack_require__(119).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(72)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(37)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(12);
var $values = __webpack_require__(545)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(12);
var core = __webpack_require__(3);
var global = __webpack_require__(8);
var speciesConstructor = __webpack_require__(201);
var promiseResolve = __webpack_require__(199);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(12);
var newPromiseCapability = __webpack_require__(117);
var perform = __webpack_require__(198);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(124)('asyncIterator');


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(124)('observable');


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(567);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 567 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//


/*!
* Survey.js v1.2.0
* (c) 2015-2017 Innowaytion
*/
(function () {
  'use strict';

  var builtVersion = "1.2.0";console.log("Using Survey Conduct " + builtVersion), window.DLOOP || (window.DLOOP = {});var DLOOP = window.DLOOP;DLOOP.createSurvey = function (a, b, c) {
    if (!a) return void console.error("Undefined container element");if (b || (b = {}), c || (c = {}), c.version || (c.version = builtVersion), "string" == typeof b) try {
      b = JSON.parse(b);
    } catch (a) {
      return void console.error(a);
    }if (!_version.check(b)) return _templates.loadUnsupported(a, _version.get(b)), void (c.onFail && c.onFail("Unsupported Json version (" + _version.get(b) + ")"));var d = _localize.init(c);if (b.questions && 0 !== b.questions.length) {
      for (var e = _themeEditingFactory.create(c), f = _playerFactory.create(e), g = _templates.loadQuestion(a, c, e, d, f, c.version), h = _themeFactory.create(b.resources, b.theme, g), i = [], j = 0; j < b.questions.length; ++j) {
        var k = _questionsFactory.create(b.questions[j], h, f, e, b.resources, c);k && i.push(k);
      }return !1 !== c.autoStart && f.start(i, g), { start: function start() {
          return f.start(i, g);
        }, next: function next() {
          return f.loadNextQuestion();
        }, previous: function previous() {
          return f.loadPreviousQuestion();
        }, getResults: function getResults() {
          return f.getResults();
        } };
    }if (c && c.onFail) {
      c.onFail("Empty survey: No questions found");var l = document.createElement("div");l.className = "conduct empty-survey", d.string("NoQuestionsFound", "The survey is empty", function (a) {
        l.innerHTML = a;
      }), a.innerHTML = "", a.appendChild(l);
    }
  };var _questionsFactory = function () {
    var a = {};return { register: function register(b) {
        var c = b();return c && c.type && c.create ? a[c.type] ? void console.error("Duplicate quesiton factory") : void (a[c.type] = c.create) : void console.error("Invalid question factory");
      }, create: function create(b, c, d, e, f, g) {
        if (!b) return void console.error("Invalid argument");var h = b.groupType ? b.groupType : b.type;return a[h] ? a[h](b, c, d, e, f, g) : void console.error("Unsupported question type: " + h);
      } };
  }.call(),
      loadCss = function loadCss(a, b) {
    for (var c = b ? a.replace(/.*\//, "") : a, d = document.getElementsByTagName("link"), e = 0; e < d.length; ++e) {
      if ((b ? d[e].getAttribute("href").replace(/.*\//, "") : d[e].getAttribute("href")) === c) return;
    }var f = document.getElementsByTagName("head")[0],
        g = document.createElement("link");g.rel = "stylesheet", g.type = "text/css", g.href = a, f.appendChild(g);
  },
      loadScript = function loadScript(a, b) {
    var c;if (!b) return void console.error("Undefined path for script");var d = document.createElement("script");return d.src = b, d.addEventListener("load", function () {
      c && c();
    }, !1), a.appendChild(d), { then: function then(a) {
        return c = a, loadScript;
      } };
  },
      _localize = function () {
    var a = {},
        b = {},
        c = function c(_c, d) {
      if (_c && (d && (a[_c] || (a[_c] = []), a[_c].push(d)), a[_c] && b[_c])) {
        for (var e = 0; e < a[_c].length; ++e) {
          a[_c][e]();
        }a[_c] = [];
      }
    };return { init: function init(a) {
        var d,
            e = { string: function string(a, e, f) {
            f || console.error("Undefined callback"), c(d, function () {
              f(b[d] && b[d][a] ? b[d][a] : e || a);
            });
          }, element: function element(a) {
            c(d, function () {
              if (b[d]) for (var c = a.querySelectorAll("[rel^='localize:']"), e = 0; e < c.length; ++e) {
                var f = c[e].getAttribute("rel").substr(9);b[d][f] && (c[e].innerHTML = b[f]);
              }
            });
          }, changeLocale: function changeLocale(e) {
            if (e && e !== d) {
              if (d = e, b[e]) return void c(d);var f;if (f = a && a.localesPath ? a.localesPath + "/local/" + e + ".json" : document.location.href.substr(0, document.location.href.lastIndexOf("/") + 1) + "../survey/localization/" + e + ".json", 0 === document.location.origin.indexOf("file://")) return void loadScript(document.body, f).then(function () {
                DLOOP.locales ? (b[e] = DLOOP.locales, c(d)) : console.error("Could not find the locales");
              });var g = new XMLHttpRequest();g.overrideMimeType("application/json"), g.onreadystatechange = function () {
                if (4 === this.readyState) {
                  if (200 === this.status) try {
                    b[e] = JSON.parse(this.responseText);
                  } catch (a) {
                    console.error(a);
                  } else console.warn("Locale not found: " + e), b[e] = {};c(d);
                }
              }, g.open("GET", f, !0), g.send();
            }
          } };return e.changeLocale(a.locale ? a.locale : navigator.language), e;
      } };
  }.call(),
      _playerFactory = function () {
    return { create: function create(a) {
        var b,
            c,
            d = [],
            e = [],
            f = function f(a) {
          if (!(a >= d.length)) return b = a, c.resetAnswerEl(), d[b].load(c), e.push(b), c.update(), b;
        },
            g = { start: function start(a, b) {
            if (d = a, e = [], c = b, d.length > 0) return f(0);console.warn("No questions loaded");
          }, canLoadPrevQuestion: function canLoadPrevQuestion() {
            return e.length > 1 && !a.isEditing();
          }, canLoadNextQuestion: function canLoadNextQuestion() {
            if (a.isEditing()) return !1;if (b >= d.length) return !1;if (!d[b].canLoadNextQuestion()) return !1;var c = d[b].getNextQuestionIndex();return -1 !== c && (void 0 === c ? !(b + 1 >= d.length) : null !== c);
          }, canSubmit: function canSubmit() {
            if (0 === d.length || a.isEditing()) return !1;for (var b = 0; b < e.length; ++b) {
              var c = d[e[b]];if (c.getResponse() && c.getResponse().response) return !0;
            }return !1;
          }, isFirstQuestion: function isFirstQuestion() {
            return 0 === b;
          }, isLastQuestion: function isLastQuestion() {
            return d[b].getNextQuestionIndex();
          }, loadPreviousQuestion: function loadPreviousQuestion() {
            if (g.canLoadPrevQuestion()) {
              var a = e[e.length - 2];return e.splice(e.length - 2, 2), f(a);
            }
          }, loadNextQuestion: function loadNextQuestion() {
            if (g.canLoadNextQuestion()) {
              var a = g.getNextQuestionIndex();return void 0 === a ? b + 1 >= d.length ? void console.log("No more questions") : f(b + 1) : null !== a ? f(a) : void 0;
            }
          }, getResults: function getResults() {
            for (var a = [], b = 0; b < e.length; ++b) {
              var c = d[e[b]],
                  f = c.getResponse();f && a.push(f);
            }return a;
          }, getNextQuestionIndex: function getNextQuestionIndex() {
            if (b < d.length) return d[b].getNextQuestionIndex();
          }, getCurrentQuestionIndex: function getCurrentQuestionIndex() {
            return b;
          }, getQuestionIndexFromId: function getQuestionIndexFromId(a) {
            if (void 0 !== a) {
              if ("none" === a) return -1;for (var b in d) {
                if (a === d[b].id) return parseInt(b);
              }console.warn("Unable to find the index of the question: id = " + a);
            }
          } };return g;
      } };
  }.call();_questionsFactory.register(function () {
    var a = { Firstname: "firstName", Lastname: "lastName", Email: "email", Headline: "headline" },
        b = function b(a, _b, c, d, e) {
      var f = document.createElement("li"),
          g = document.createElement("h2");g.innerHTML = a.label, "mandatory" === a.status && (g.innerHTML += "<sup>*</sup>");var h = document.createElement("input");h.maxLength = 100, h.value = a.value ? a.value : "";var i = function i() {
        a.value = h.value, d.updateTemplate();
      };return h.addEventListener("keyup", i), h.addEventListener("input", i), f.appendChild(g), f.appendChild(h), c.applyThemeToUnselectedAnswer(h), f;
    };return { type: "contactQuestion", create: function create(c, d, e, f, g, h) {
        var i = {},
            j = _createDefaultQuestion(i, c, e, d),
            k = h && h.userInfo ? h.userInfo : void 0;if (j) return c && c.fields ? i.fields = c.fields : i.fields = [], j.override("load", function (c) {
          for (var e = document.createElement("ul"), f = 0; f < i.fields.length; ++f) {
            var g = i.fields[f];g.label && (!g.value && a[g.label] && k && k[a[g.label]] && (g.value = k[a[g.label]]), e.appendChild(b(g, 0, d, j)));
          }return c.appendChild(e), c;
        }), j.override("getResponse", function (a) {
          var b = {};k && k.id && (b.id = k.id);for (var c = 0; c < i.fields.length; ++c) {
            var d = i.fields[c];if (d.value) b[d.label] = d.value;else if (d.isMandatory) return a;
          }return a.response = b, a;
        }), j.override("canLoadNextQuestion", function () {
          if (!0 !== i.answerRequired) return !0;for (var a = 0; a < i.fields.length; ++a) {
            var b = i.fields[a];if ("mandatory" === b.status && (!b.value || "" === b.value)) return !1;
          }return !0;
        }), i;
      } };
  }), _questionsFactory.register(function () {
    function a(a) {
      if (a) {
        var b = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;return a.replace(b, function (a) {
          return '<a href="' + a + '" target="_blank">' + a + "</a>";
        });
      }
    }return { type: "infoQuestion", create: function create(b, c, d, e, f, g) {
        var h = {},
            i = _createDefaultQuestion(h, b, d, c);if (i) return i.renderQuestionText = function (a) {
          a.setTitle();
        }, i.override("load", function (b) {
          var c = document.createElement("p");return c.className = "title", h.text && (c.innerHTML = a(h.text.replace(/\n/g, "<br/>"))), b.appendChild(c), b;
        }), i.override("getResponse", function (a) {
          return a.response = "", a;
        }), h;
      } };
  }), _questionsFactory.register(function () {
    var a = function a(_a, b, c, d, e, f) {
      if (void 0 !== _a.image || void 0 !== _a.text) {
        var g = document.createElement("li");if (_a.selected && (g.className += " selected"), void 0 !== _a.image && f && f.images) {
          var h = document.createElement("img");h.src = f.images[_a.image], g.appendChild(h);
        }if (_a.text) {
          var i = document.createElement("span");i.innerHTML = _a.text, g.appendChild(i);
        }return e.isEditing() || g.addEventListener("click", function () {
          if (b.allowMultiSelection) _a.selected ? g.className = g.className.replace(/selected/g, "") : g.className += " selected", _a.selected = !_a.selected;else {
            var c,
                e = _a.selected;for (c = 0; c < b.answers.length; ++c) {
              b.answers[c].selected = !1;
            }var f = g.parentNode.querySelectorAll("li");for (c = 0; c < f.length; ++c) {
              f[c].className = f[c].className.replace(/selected/g, "");
            }e || (_a.selected = !0, g.className += " selected");
          }d.updateTemplate();
        }, !1), c.applyThemeToUnselectedAnswer(g), c.applyThemeToSelectedAnswer(g), e.registerEditableItem("answers", g), g;
      }
    };return { type: "multiChoiceQuestion", create: function create(b, c, d, e, f, g) {
        var h = {},
            i = _createDefaultQuestion(h, b, d, c);if (i) return h.allowMultiSelection = b.allowMultiSelection, h.isRightAnswersExist = b.isRightAnswersExist, h.answers = b.answers ? JSON.parse(JSON.stringify(b.answers)) : [], i.override("load", function (b) {
          var d = document.createElement("ul"),
              g = h.answers;if (h.isRightAnswersExist) for (var j = 0; j < h.answers.length; ++j) {
            var k = Math.floor(Math.random() * h.answers.length),
                l = Math.floor(Math.random() * h.answers.length);if (k !== l) {
              var m = g[k];g[k] = g[l], g[l] = m;
            }
          }for (var n in g) {
            var o = a(g[n], h, c, i, e, f);o && d.appendChild(o);
          }b.appendChild(d);
        }), i.override("getResponse", function (a) {
          var b = [];for (var c in h.answers) {
            h.answers[c].selected && b.push(h.answers[c].id);
          }if (b.length > 0) return a.response = b, a;
        }), i.override("canLoadNextQuestion", function () {
          if (!0 !== h.answerRequired) return !0;for (var a in h.answers) {
            if (h.answers[a].selected) return !0;
          }return !1;
        }), i.override("getNextQuestionIndex", function (a) {
          if (!h.allowMultiSelection) for (var b in h.answers) {
            var c = h.answers[b];if (c.selected) {
              if (c.nextQuestionId) {
                var e = d.getQuestionIndexFromId(c.nextQuestionId);if (void 0 !== e) return e;
              }break;
            }
          }return a;
        }), h;
      } };
  }), _questionsFactory.register(function () {
    return { type: "openQuestion", create: function create(a, b, c, d, e, f) {
        var g = {},
            h = _createDefaultQuestion(g, a, c, b);if (h) return g.maxLength = a.maxLength, h.override("load", function (a) {
          var c,
              d = document.createElement("div"),
              e = document.createElement("textarea"),
              f = function f() {
            c && (c.innerHTML = "Maximum characters: " + e.value.length + "/" + g.maxLength, e.value.length >= g.maxLength ? c.style.color = "red" : c.style.color = "inherit", e.value.length > 0 ? g.response = e.value : g.response = void 0, h.updateTemplate());
          };e.placeholder = "Type your answer here", g.response && (e.innerHTML = g.response), g.maxLength || (g.maxLength = 500), e.setAttribute("maxlength", g.maxLength), e.addEventListener("keyup", f, !1), e.addEventListener("input", f, !1), d.appendChild(e);var i = document.createElement("div");i.className = "footer", c = document.createElement("div"), i.appendChild(c), f(), d.appendChild(i), b.applyThemeToUnselectedAnswer(e), a.appendChild(d);
        }), h.override("getResponse", function (a) {
          if (g.response && "" !== g.response) return a.response = g.response, a;
        }), h.override("canLoadNextQuestion", function () {
          return !0 !== g.answerRequired || void 0 !== g.response && "" !== g.response;
        }), g;
      } };
  });var _createDefaultQuestion = function _createDefaultQuestion(a, b, c, d) {
    if (!a || !b) return void console.error("Invalid arguments");if (!b.id || !b.type) return void console.error("Invalid question. Missing id or type");var e;a.type = b.type, a.id = b.id, a.text = b.text ? b.text : void 0, a.groupType = b.groupType ? b.groupType : void 0, a.placeHolderTitle = "Question", a.answerRequired = b.answerRequired, a.answerRequiredToSubmit = !1 !== b.answerRequiredToSubmit, a.nextQuestionId = b.nextQuestionId, a.theme = b.theme, a.load = function (b) {
      e = b, d.load(a.theme), f.renderQuestionText(e);var c = e.getAnswerEl();return c.className = a.groupType, c;
    }, a.getResponse = function () {
      return { questionId: a.id, response: void 0 };
    }, a.canLoadNextQuestion = function () {
      return !0;
    }, a.getNextQuestionIndex = function () {
      if (a.hasOwnProperty("nextQuestionId")) return c.getQuestionIndexFromId(a.nextQuestionId);
    };var f = { override: function override(b, c) {
        if (c) {
          var d = a[b];a[b] = function () {
            return c(d ? d.apply(this, arguments) : void 0);
          };
        } else console.error("Undefined function to override");
      }, renderQuestionText: function renderQuestionText(b) {
        if (!a.text) return void b.setTitle();var c = a.text.replace(/\n/g, "<br/>");a.answerRequired && (c += "<sup>*</sup>"), b.setTitle(c);
      }, updateTemplate: function updateTemplate() {
        e && e.update();
      } };return f;
  };_questionsFactory.register(function () {
    var a = function a(_a2, b) {
      for (var c = 0; c < _a2.answers.length; ++c) {
        if (_a2.answers[c].id === b.id) return c;
      }return -1;
    },
        b = function b(_b2, c, d, e, f) {
      if (void 0 !== _b2.image || void 0 !== _b2.text) {
        var g = document.createElement("li");if (g.setAttribute("draggable", !0), void 0 !== _b2.image && f && f.images) {
          var h = document.createElement("img");h.src = f.images[_b2.image], g.appendChild(h);
        }if (_b2.text) {
          var i = document.createElement("span");i.innerHTML = _b2.text, g.appendChild(i);
        }var j = document.createElement("button");j.innerHTML = "&#8593";var k = document.createElement("button");return k.innerHTML = "&#8595;", j.addEventListener("click", function () {
          if (!d.isEditing) {
            var e = a(c, _b2);if (!(e < 1)) {
              c.answers.splice(e, 1), c.answers.splice(e - 1, 0, _b2);var f = g.previousSibling;f && g.parentNode.insertBefore(g, f);
            }
          }
        }), k.addEventListener("click", function () {
          if (!d.isEditing) {
            var e = a(c, _b2);if (!(e > c.answers.length - 2)) {
              c.answers.splice(e, 1), c.answers.splice(e + 1, 0, _b2);var f = g.nextSibling;f && g.parentNode.insertBefore(g, f.nextSibling);
            }
          }
        }), g.appendChild(j), g.appendChild(k), g.addEventListener("dragstart", function (a) {
          c.answerDragged = _b2;
        }, !1), d.applyThemeToUnselectedAnswer(g), e.registerEditableItem("answers", g), g;
      }
    };return { type: "sortQuestion", create: function create(a, c, d, e, f, g) {
        var h = {},
            i = _createDefaultQuestion(h, a, d, c);if (i) return h.largestLabel = a.largestLabel, h.smallestLabel = a.smallestLabel, h.answers = a.answers ? JSON.parse(JSON.stringify(a.answers)) : [], i.override("load", function (a) {
          var d = document.createElement("div");if (h.largestLabel) {
            var g = document.createElement("h2");g.innerHTML = h.largestLabel, d.appendChild(g);
          }var i = document.createElement("ul");for (var j in h.answers) {
            var k = b(h.answers[j], h, c, e, f);k && i.appendChild(k);
          }if (i.addEventListener("dragover", function (a) {
            console.log("drag over");
          }, !1), i.addEventListener("drop", function (a) {
            console.log("drop");
          }, !1), d.appendChild(i), h.smallestLabel) {
            var l = document.createElement("h2");l.innerHTML = h.smallestLabel, d.appendChild(l);
          }return a.appendChild(d), a;
        }), i.override("getResponse", function (a) {
          var b = [];for (var c in h.answers) {
            b.push(h.answers[c].id);
          }return a.response = b, a;
        }), h;
      } };
  }), console.log("Using Survey Conduct " + builtVersion), window.DLOOP || (window.DLOOP = {});var DLOOP = window.DLOOP;DLOOP.createSurvey = function (a, b, c) {
    if (!a) return void console.error("Undefined container element");if (b || (b = {}), c || (c = {}), c.version || (c.version = builtVersion), "string" == typeof b) try {
      b = JSON.parse(b);
    } catch (a) {
      return void console.error(a);
    }if (!_version.check(b)) return _templates.loadUnsupported(a, _version.get(b)), void (c.onFail && c.onFail("Unsupported Json version (" + _version.get(b) + ")"));var d = _localize.init(c);if (b.questions && 0 !== b.questions.length) {
      for (var e = _themeEditingFactory.create(c), f = _playerFactory.create(e), g = _templates.loadQuestion(a, c, e, d, f, c.version), h = _themeFactory.create(b.resources, b.theme, g), i = [], j = 0; j < b.questions.length; ++j) {
        var k = _questionsFactory.create(b.questions[j], h, f, e, b.resources, c);k && i.push(k);
      }return !1 !== c.autoStart && f.start(i, g), { start: function start() {
          return f.start(i, g);
        }, next: function next() {
          return f.loadNextQuestion();
        }, previous: function previous() {
          return f.loadPreviousQuestion();
        }, getResults: function getResults() {
          return f.getResults();
        } };
    }if (c && c.onFail) {
      c.onFail("Empty survey: No questions found");var l = document.createElement("div");l.className = "conduct empty-survey", d.string("NoQuestionsFound", "The survey is empty", function (a) {
        l.innerHTML = a;
      }), a.innerHTML = "", a.appendChild(l);
    }
  };var _templates = function () {
    return { loadUnsupported: function loadUnsupported(a, b) {
        var c = document.createElement("div");c.className = "conduct";var d = document.createElement("div");d.className = "unsupported", d.innerHTML = "This version of the survey is not supported (v" + b + ")", c.appendChild(d), a.innerHTML = "", a.appendChild(c);
      }, loadQuestion: function loadQuestion(a, b, c, d, e, f) {
        b && b.cssPath ? loadCss(b.cssPath, !0) : document.location.origin.indexOf("http://localhost") >= 0 ? loadCss(document.location.origin + "/dist/" + f + "/survey/survey-" + f + ".css", !0) : loadCss(document.location.origin + "/survey-" + f + ".css", !0);var g = document.createElement("div");g.className = "conduct" + (c.isEditing() ? " theme-editing" : "");var h = document.createElement("content");h.className = "content", g.appendChild(h);var i = document.createElement("header");i.appendChild(document.createElement("div")), c.registerDnDListenerOnEditableItem("header", i), h.appendChild(i);var j = document.createElement("main"),
            k = document.createElement("div");c.registerDnDListenerOnEditableItem("body", k);var l = document.createElement("div");l.className = "title";var m = document.createElement("h2");l.appendChild(m), k.appendChild(l);var n = document.createElement("div");n.className = "answers";var o = document.createElement("div");if (n.appendChild(o), k.appendChild(n), b && b.showControls) {
          var p = document.createElement("div");p.className = "controls";var q = document.createElement("button");q.className = "btn-large btn-primary btn-controls", d.string("BT_PREVIOUS", "Previous", function (a) {
            q.innerHTML = a;
          }), q.addEventListener("click", function () {
            e.loadPreviousQuestion();
          }), c.registerEditableItem("controls", q), p.appendChild(q);var r = document.createElement("button");r.className = "btn-large btn-primary btn-controls", d.string("BT_NEXT", "Next", function (a) {
            r.innerHTML = a;
          }), r.addEventListener("click", function () {
            e.loadNextQuestion();
          }), c.registerEditableItem("controls", r), p.appendChild(r);var s = document.createElement("button");s.className = "btn-large btn-primary btn-controls", d.string("BT_SUBMIT", "Submit", function (a) {
            s.innerHTML = a;
          }), s.addEventListener("click", function () {
            b && b.onSubmit && b.onSubmit(e.getResults());
          }), c.registerEditableItem("controls", s), p.appendChild(s), k.appendChild(p);
        }j.appendChild(k), h.appendChild(j);var t = document.createElement("footer");if (t.appendChild(document.createElement("div")), c.registerDnDListenerOnEditableItem("footer", t), h.appendChild(t), c.isEditing()) {
          var u = document.createElement("canvas");u.className = "overlay-theme-editing";var v = u.getContext("2d");h.appendChild(u), c.registerCanvasUpdate(function (a) {
            a ? (u.width = h.offsetWidth, u.height = h.offsetHeight, a(v, INNOWAYTION.utils.ui.offsetPosition(h)), u.style.display = "block") : u.style.display = "none";
          });
        }return a.innerHTML = "", a.appendChild(g), { setTitle: function setTitle(a) {
            m.innerHTML = a, m.style.display = a ? "block" : "none";
          }, showHeaderWithRuler: function showHeaderWithRuler(a) {
            a("display: table-row");
          }, showFooterWithRuler: function showFooterWithRuler(a) {
            a("display: table-row");
          }, getRootEl: function getRootEl() {
            return h;
          }, getAnswerEl: function getAnswerEl() {
            return o;
          }, resetAnswerEl: function resetAnswerEl() {
            o.innerHTML = "";
          }, update: function update() {
            if (q && r && s) {
              if (c.isEditing()) return q.removeAttribute("disabled"), r.removeAttribute("disabled"), void s.removeAttribute("disabled");e.canLoadPrevQuestion() ? q.removeAttribute("disabled") : q.setAttribute("disabled", "disabled"), e.canLoadNextQuestion() ? r.removeAttribute("disabled") : r.setAttribute("disabled", "disabled"), e.canSubmit() ? s.removeAttribute("disabled") : s.setAttribute("disabled", "disabled");
            }
          } };
      } };
  }.call(),
      _themeEditingFactory = function () {
    var a = function a(_a3, b, c, d) {
      if (!c || !_a3 || !b || 0 === b.length) return void console.error("Invalid arguments");var e;return c(function (a, c) {
        a.clearRect(0, 0, c.width, c.height), a.moveTo(0, 0), a.lineTo(c.width, 0), a.lineTo(c.width, c.height), a.lineTo(0, c.height), a.lineTo(0, 0), a.closePath();var d,
            f = [];for (d = 0; d < b.length; ++d) {
          var g = INNOWAYTION.utils.ui.offsetPosition(b[d]);g.top -= c.top, g.left -= c.left, a.moveTo(g.left, g.top), a.lineTo(g.left, g.top + g.height), a.lineTo(g.left + g.width, g.top + g.height), a.lineTo(g.left + g.width, g.top), a.lineTo(g.left, g.top), a.closePath(), f.push([g.left, g.top, g.width, g.height]);
        }for (a.fillStyle = "rgba(0, 0, 0, 0.5)", a.fill(), d = 0; d < f.length; ++d) {
          a.beginPath(), a.lineWidth = "3", a.strokeStyle = "red", a.rect(f[d][0], f[d][1], f[d][2], f[d][3]), a.stroke();
        }e = { el: a.canvas, rect: c };
      }), e;
    },
        b = function b(a) {
      a ? a() : console.error("Invalid argument");
    },
        c = function c(_c2, d, f, g, h, i) {
      if (!_c2 || !g[f]) return void console.error("Invalid arguments");var j = a(f, g[f].els, i);h && h.stopPropagation(), d && d.onItemHighlighted && d.onItemHighlighted(f);var k = function k(a) {
        e(_c2, j.rect.left + a.offsetX, j.rect.top + a.offsetY, g) && j.dismiss();
      };return j.click = function (a) {
        if (d && d.onItemClicked) {
          var b;_c2.className.indexOf("selected") >= 0 && (b = "selected"), d.onItemClicked(f, _c2, b);
        }
      }, j.dismiss = function () {
        j.el.removeEventListener("mouseover", k), j.el.removeEventListener("mousemove", k), j.el.removeEventListener("mouseleave", j.dismiss), j.el.removeEventListener("click", j.click), b(i);
      }, j.el.addEventListener("mouseover", k, !1), j.el.addEventListener("mousemove", k, !1), j.el.addEventListener("mouseleave", j.dismiss, !1), j.el.addEventListener("click", j.click, !1), j;
    },
        d = function d(a, b, _d, f, g, h) {
      if (!a || !g) return void console.error("Invalid arguments");g.preventDefault && g.preventDefault(), g.dataTransfer.dropEffect = "move";var i = c(a, b, _d, f, g, h),
          j = function j(b) {
        e(a, i.rect.left + b.offsetX, i.rect.top + b.offsetY, f, function (a) {
          return !a.acceptDnDImage;
        }) ? k() : (b.preventDefault && b.preventDefault(), b.stopPropagation(), b.dataTransfer.dropEffect = "move");
      },
          k = function k() {
        i.el.removeEventListener("dragover", j), i.el.removeEventListener("dragleave", k), i.el.removeEventListener("drop", l), i.dismiss();
      },
          l = function l(a) {
        k(), a.preventDefault && a.preventDefault(), a.stopPropagation();var c = a.dataTransfer,
            e = c.files;if (0 !== e.length) {
          var f = new FileReader();f.onloadend = function () {
            (b || b.onDropImage) && setTimeout(function () {
              b.onDropImage(_d, this.result);
            }.bind(this), 1);
          }, f.readAsDataURL(e[0]);
        }
      };i.el.addEventListener("dragover", j, !1), i.el.addEventListener("dragleave", k, !1), i.el.addEventListener("drop", l, !1);
    },
        e = function e(a, b, c, d, _e) {
      for (var f = [], g = Object.keys(d), h = 0; h < g.length; ++h) {
        for (var i = d[g[h]].els, j = 0; j < i.length; ++j) {
          if (!_e || !_e(i[j])) {
            var k = INNOWAYTION.utils.ui.offsetPosition(i[j]);if (k.left <= b && k.left + k.width >= b && k.top <= c && k.top + k.height >= c) {
              f.push({ el: i[j], area: k.width * k.height });break;
            }
          }
        }
      }return f.sort(function (a, b) {
        return a.area > b.area;
      }), f.length > 0 && a !== f[0].el;
    };return { create: function create(e) {
        var f,
            g,
            h = {};e && e.themeEditing && (f = e.themeEditing(function (c) {
          c ? h[c] && a(c, h[c].els, g) : b(g);
        }, function (a) {
          if (h[a]) return h[a].maxSize;
        }));var i = { isEditing: function isEditing() {
            return e && e.themeEditing;
          }, registerCanvasUpdate: function registerCanvasUpdate(a) {
            g = a;
          }, registerEditableItem: function registerEditableItem(a, b, d) {
            return !!i.isEditing() && (b && a ? (h[a] ? h[a].els.push(b) : h[a] = { els: [b] }, d && (h[a].maxSize = d), b.addEventListener("mouseover", function (d) {
              c(b, f, a, h, d, g);
            }), !0) : (console.error("Invalid parameters"), !1));
          }, registerDnDListenerOnEditableItem: function registerDnDListenerOnEditableItem(a, b, c) {
            i.registerEditableItem(a, b, c) && (f && f.onDropImage || console.warn('No callbacks registered for "onDropImage". Probably nothing will be saved'), b.acceptDnDImage = !0, b.addEventListener("dragover", function (c) {
              d(b, f, a, h, c, g);
            }));
          } };return i;
      } };
  }.call(),
      _themeFactory = function () {
    var a = 0,
        b = function b() {
      return "theme_" + ++a;
    },
        c = function c(a, _c3, d, e, f, g, h) {
      if (!f) return void console.error("Invalid argument");if (e) {
        var i = b();f.className += " " + i;var j = [_c3 + " " + f.nodeName + "." + i + (g || "")];a.all.createSelectorRules(j, e.all, void 0, d), h.push({ selectors: j, theme: e });
      }
    },
        d = function d(a, b, c, _d2, e) {
      if (b && b.length) {
        var f = function f(c, _f) {
          for (var g = !1, i = b[0] + _f, j = 1; j < b.length; ++j) {
            i += "," + b[j] + _f;
          }i += "{";var k = function k(a) {
            i += a + ";", g = !0;
          };h(c, k, e), g && (_d2 && _d2(k), i += "}", a.insertRule(i, 0));
        };f(c, ""), c["font-family"] && f({ "font-family": c["font-family"] }, " *");
      }
    },
        e = function e(a) {
      return a ? a.offsetWidth <= 300 ? "portrait" : a.offsetHeight <= 300 ? "landscape" : "all" : "all";
    },
        f = function f(a) {
      a && (a.remove ? a.remove(a) : a.removeNode(!0));
    },
        g = function g(a) {
      var b = document.createElement("style");return b.appendChild(document.createTextNode("")), document.head.appendChild(b), { createSelectorRules: function createSelectorRules(a, c, e, f) {
          if (!a) return void console.error("Invalid arguments");c && d(b.sheet, a, c, e, f);
        }, destroy: function destroy() {
          f(b);
        } };
    },
        h = function h(a, b, c) {
      if (b && a) {
        if (void 0 !== a.backgroundImage) switch (c && b("background-image: url('" + c[a.backgroundImage] + "')"), a.backgroundMode) {case "stretched":
            b("background-repeat: no-repeat"), b("background-size: 100% 100%"), b("background-position: center");break;case "fitToWidth":
            b("background-repeat: no-repeat"), b("background-size: cover"), b("background-position: center");break;case "left":
            b("background-repeat: no-repeat"), b("background-position: left center"), b("background-size: contain");break;case "right":
            b("background-repeat: no-repeat"), b("background-position: right center"), b("background-size: contain");break;default:
            void 0 !== a.backgroundMode && "center" !== a.backgroundMode && console.log("Unsupported mode for background mode: " + a.backgroundMode), b("background-repeat: no-repeat"), b("background-position: center"), b("background-size: contain");}a.backgroundColor && b("background-color: " + a.backgroundColor), a.color && b("color: " + a.color), a["font-family"] && b("font-family: " + a["font-family"]);
      }
    },
        i = function i(a, b, c, d) {
      if (c) {
        var f = function f(e, _f2) {
          var h = g(b.getRootEl()),
              i = {},
              j = {};if (c.body && c.body[e] && (i[e] = {}, j[e] = {}, i[e].backgroundColor = c.body[e].backgroundColor, i[e].backgroundImage = c.body[e].backgroundImage, j[e].color = c.body[e].color), h.createSelectorRules([a + " main"], i[e], void 0, d), h.createSelectorRules([a + " .title"], j[e], void 0, d), h.createSelectorRules([a], c.text ? c.text[e] : void 0, void 0, d), h.createSelectorRules([a + " footer"], c.footer ? c.footer[e] : void 0, b.showFooterWithRuler, d), h.createSelectorRules([a + " header"], c.header ? c.header[e] : void 0, b.showHeaderWithRuler, d), h.createSelectorRules([a + " .controls button[disabled='']"], c.controls ? c.controls[e] : void 0, void 0, d), _f2) for (var k = 0; k < _f2.length; ++k) {
            h.createSelectorRules(_f2[k].selectors, _f2[k].theme[e], void 0, d);
          }return h;
        },
            h = [],
            i = "all",
            j = {};j.all = f("all");var k = function k() {
          l && (clearInterval(l), l = void 0);for (var a = Object.keys(j), b = 0; b < a.length; ++b) {
            j[a[b]] && j[a[b]].destroy();
          }h = void 0;
        },
            l = setInterval(function () {
          if (0 === b.getRootEl().offsetWidth) return k(), void console.log("Theme was destroyed (Root element is likely to have disappeared)");var a = e(b.getRootEl());"all" !== i && a !== i && (j[i].destroy(), j[i] = null), "all" !== a && a !== i && (j[a] = f(a, h)), i = a;
        }, 100);return { styleSheets: j, theme: c, destroy: k, styleForEls: h };
      }
    };return { create: function create(a, d, e) {
        var f, g;a && (f = a.themes, g = a.images);var h = b(),
            j = ".conduct .content." + h;e.getRootEl().className += " " + h;var k;return { applyThemeToUnselectedAnswer: function applyThemeToUnselectedAnswer(a) {
            k && k.theme && k.theme.answers && c(k.styleSheets, j, g, k.theme.answers.unselected, a, ":not(.selected)", k.styleForEls);
          }, applyThemeToSelectedAnswer: function applyThemeToSelectedAnswer(a) {
            k && k.theme && k.theme.answers && c(k.styleSheets, j, g, k.theme.answers.selected, a, ".selected", k.styleForEls);
          }, load: function load(a) {
            k && k.destroy(), k = "object" == (typeof a === "undefined" ? "undefined" : _typeof(a)) ? i(j, e, a, g) : f ? i(j, e, f[void 0 === a ? d : a], g) : void 0;
          } };
      } };
  }.call(),
      _version = function () {
    var a = ["1.1.0", "1.2.0"];return { get: function get(a) {
        return "version" in a ? a.version : "0.0.0";
      }, check: function check(b) {
        var c = _version.get(b);return !!c && a.indexOf(c) >= 0;
      } };
  }.call();
  //# sourceMappingURL=survey-1.2.0.js.map
})();

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    survey: Object,
    cssPath: String,
    localizationPath: String,
    user: Object,
    onSubmit: Function,
    onFail: Function
  },

  mounted: function mounted() {
    this.reload(this.survey);
  },


  watch: {
    survey: function survey(newSurvey) {
      this.reload(newSurvey);
    }
  },

  methods: {
    reload: function reload(json) {
      var _this = this;

      if (!json) {
        return;
      }

      DLOOP.createSurvey(this.$el, json, {
        cssPath: this.cssPath,
        localesPath: this.localizationPath,
        showControls: true,
        onFail: function onFail(err) {
          if (_this.onFail) {
            _this.onFail(err);
          } else {
            console.log('Failed to load the survey: ' + err);
          }
        },
        onSubmit: this.onSubmit,
        userInfo: this.user
      });
    }
  }
});

/***/ }),
/* 569 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[249]);


// WEBPACK FOOTER //
// static/js/app.4ad5be527e0e24bc6563.js